/* eslint-disable */
export const armmBarangays = [
    {
        CITY: 'AKBAR',
        BARANGAY: 'CADDAYAN',
    },
    {
        CITY: 'AKBAR',
        BARANGAY: 'LINONGAN',
    },
    {
        CITY: 'AKBAR',
        BARANGAY: 'LOWER BATO-BATO',
    },
    {
        CITY: 'AKBAR',
        BARANGAY: 'MANGALUT',
    },
    {
        CITY: 'AKBAR',
        BARANGAY: 'MANGUSO',
    },
    {
        CITY: 'AKBAR',
        BARANGAY: 'PAGUENGAN',
    },
    {
        CITY: 'AKBAR',
        BARANGAY: 'SEMUT',
    },
    {
        CITY: 'AKBAR',
        BARANGAY: 'UPPER BATO-BATO',
    },
    {
        CITY: 'AKBAR',
        BARANGAY: 'UPPER SINANGKAPAN',
    },
    {
        CITY: 'AL-BARKA',
        BARANGAY: 'APIL-APIL',
    },
    {
        CITY: 'AL-BARKA',
        BARANGAY: 'BATO-BATO',
    },
    {
        CITY: 'AL-BARKA',
        BARANGAY: 'BOHE-PIANG',
    },
    {
        CITY: 'AL-BARKA',
        BARANGAY: 'BUCALAO',
    },
    {
        CITY: 'AL-BARKA',
        BARANGAY: 'CAMBUG',
    },
    {
        CITY: 'AL-BARKA',
        BARANGAY: 'DANAPAH',
    },
    {
        CITY: 'AL-BARKA',
        BARANGAY: 'GUINANTA',
    },
    {
        CITY: 'AL-BARKA',
        BARANGAY: 'KAILIH',
    },
    {
        CITY: 'AL-BARKA',
        BARANGAY: 'KINUKUTAN',
    },
    {
        CITY: 'AL-BARKA',
        BARANGAY: 'KUHON',
    },
    {
        CITY: 'AL-BARKA',
        BARANGAY: 'KUHON LENNUH',
    },
    {
        CITY: 'AL-BARKA',
        BARANGAY: 'LINUAN',
    },
    {
        CITY: 'AL-BARKA',
        BARANGAY: 'LOOKBISAYA (KAULUNGAN ISLAND)',
    },
    {
        CITY: 'AL-BARKA',
        BARANGAY: 'MACALANG',
    },
    {
        CITY: 'AL-BARKA',
        BARANGAY: 'MAGCAWA',
    },
    {
        CITY: 'AL-BARKA',
        BARANGAY: 'SANGKAHAN (KAULUNGAN ISLAND)',
    },
    {
        CITY: 'BASILAN-ISABELA-CITY',
        BARANGAY: 'AGUADA',
    },
    {
        CITY: 'BASILAN-ISABELA-CITY',
        BARANGAY: 'BALATANAY',
    },
    {
        CITY: 'BASILAN-ISABELA-CITY',
        BARANGAY: 'BALUNO',
    },
    {
        CITY: 'BASILAN-ISABELA-CITY',
        BARANGAY: 'BEGANG',
    },
    {
        CITY: 'BASILAN-ISABELA-CITY',
        BARANGAY: 'BINUANGAN',
    },
    {
        CITY: 'BASILAN-ISABELA-CITY',
        BARANGAY: 'BUSAY',
    },
    {
        CITY: 'BASILAN-ISABELA-CITY',
        BARANGAY: 'CABUNBATA',
    },
    {
        CITY: 'BASILAN-ISABELA-CITY',
        BARANGAY: 'CALVARIO',
    },
    {
        CITY: 'BASILAN-ISABELA-CITY',
        BARANGAY: 'CARBON',
    },
    {
        CITY: 'BASILAN-ISABELA-CITY',
        BARANGAY: 'DIKI',
    },
    {
        CITY: 'BASILAN-ISABELA-CITY',
        BARANGAY: 'DONA RAMONA T. ALANO (ISABELA WESTSITE)',
    },
    {
        CITY: 'BASILAN-ISABELA-CITY',
        BARANGAY: 'ISABELA EASTSIDE (POB.)',
    },
    {
        CITY: 'BASILAN-ISABELA-CITY',
        BARANGAY: 'ISABELA PROPER (POB.)',
    },
    {
        CITY: 'BASILAN-ISABELA-CITY',
        BARANGAY: 'KAPATAGAN GRANDE',
    },
    {
        CITY: 'BASILAN-ISABELA-CITY',
        BARANGAY: 'KAPAYAWAN',
    },
    {
        CITY: 'BASILAN-ISABELA-CITY',
        BARANGAY: 'KAUMPURNAH ZONE I',
    },
    {
        CITY: 'BASILAN-ISABELA-CITY',
        BARANGAY: 'KAUMPURNAH ZONE II',
    },
    {
        CITY: 'BASILAN-ISABELA-CITY',
        BARANGAY: 'KAUMPURNAH ZONE III',
    },
    {
        CITY: 'BASILAN-ISABELA-CITY',
        BARANGAY: 'KUMALARANG',
    },
    {
        CITY: 'BASILAN-ISABELA-CITY',
        BARANGAY: 'LA PIEDAD (POB.)',
    },
    {
        CITY: 'BASILAN-ISABELA-CITY',
        BARANGAY: 'LAMPINIGAN',
    },
    {
        CITY: 'BASILAN-ISABELA-CITY',
        BARANGAY: 'LANOTE',
    },
    {
        CITY: 'BASILAN-ISABELA-CITY',
        BARANGAY: 'LUKBUTON',
    },
    {
        CITY: 'BASILAN-ISABELA-CITY',
        BARANGAY: 'LUMBANG',
    },
    {
        CITY: 'BASILAN-ISABELA-CITY',
        BARANGAY: 'MAKIRI',
    },
    {
        CITY: 'BASILAN-ISABELA-CITY',
        BARANGAY: 'MALIGUE (LUNOT)',
    },
    {
        CITY: 'BASILAN-ISABELA-CITY',
        BARANGAY: 'MARANG-MARANG',
    },
    {
        CITY: 'BASILAN-ISABELA-CITY',
        BARANGAY: 'MARKETSITE (POB.)',
    },
    {
        CITY: 'BASILAN-ISABELA-CITY',
        BARANGAY: 'MASULA',
    },
    {
        CITY: 'BASILAN-ISABELA-CITY',
        BARANGAY: 'MENZI',
    },
    {
        CITY: 'BASILAN-ISABELA-CITY',
        BARANGAY: 'PANIGAYAN',
    },
    {
        CITY: 'BASILAN-ISABELA-CITY',
        BARANGAY: 'PANUNSULAN',
    },
    {
        CITY: 'BASILAN-ISABELA-CITY',
        BARANGAY: 'PORT AREA (POB.)',
    },
    {
        CITY: 'BASILAN-ISABELA-CITY',
        BARANGAY: 'RIVERSIDE',
    },
    {
        CITY: 'BASILAN-ISABELA-CITY',
        BARANGAY: 'SAN RAFAEL',
    },
    {
        CITY: 'BASILAN-ISABELA-CITY',
        BARANGAY: 'SANTA BARBARA',
    },
    {
        CITY: 'BASILAN-ISABELA-CITY',
        BARANGAY: 'SANTA CRUZ (POB.)',
    },
    {
        CITY: 'BASILAN-ISABELA-CITY',
        BARANGAY: 'SEASIDE (POB.)',
    },
    {
        CITY: 'BASILAN-ISABELA-CITY',
        BARANGAY: 'SMALL KAPATAGAN',
    },
    {
        CITY: 'BASILAN-ISABELA-CITY',
        BARANGAY: 'SUMAGDANG',
    },
    {
        CITY: 'BASILAN-ISABELA-CITY',
        BARANGAY: 'SUNRISE VILLAGE (POB.)',
    },
    {
        CITY: 'BASILAN-ISABELA-CITY',
        BARANGAY: 'TABIAWAN',
    },
    {
        CITY: 'BASILAN-ISABELA-CITY',
        BARANGAY: 'TABUK (POB.)',
    },
    {
        CITY: 'BASILAN-ISABELA-CITY',
        BARANGAY: 'TAMPALAN',
    },
    {
        CITY: 'BASILAN-ISABELA-CITY',
        BARANGAY: 'TIMPUL',
    },
    {
        CITY: 'TUBURAN',
        BARANGAY: 'BOHETAMBIS',
    },
    {
        CITY: 'TUBURAN',
        BARANGAY: 'CALUT',
    },
    {
        CITY: 'TUBURAN',
        BARANGAY: 'DUGA-A',
    },
    {
        CITY: 'TUBURAN',
        BARANGAY: 'KATIPUNAN',
    },
    {
        CITY: 'TUBURAN',
        BARANGAY: 'LAHI-LAHI',
    },
    {
        CITY: 'TUBURAN',
        BARANGAY: 'LOWER SINANGKAPAN',
    },
    {
        CITY: 'TUBURAN',
        BARANGAY: 'LOWER TABLAS',
    },
    {
        CITY: 'TUBURAN',
        BARANGAY: 'MAHAWID',
    },
    {
        CITY: 'TUBURAN',
        BARANGAY: 'SINULATAN',
    },
    {
        CITY: 'TUBURAN',
        BARANGAY: 'TABLAS USEW',
    },
    {
        CITY: 'HADJI-MOHAMMAD-AJUL',
        BARANGAY: 'BASAKAN',
    },
    {
        CITY: 'HADJI-MOHAMMAD-AJUL',
        BARANGAY: 'BUTON',
    },
    {
        CITY: 'HADJI-MOHAMMAD-AJUL',
        BARANGAY: 'CANDIIS',
    },
    {
        CITY: 'HADJI-MOHAMMAD-AJUL',
        BARANGAY: 'LANGIL',
    },
    {
        CITY: 'HADJI-MOHAMMAD-AJUL',
        BARANGAY: 'LANGONG',
    },
    {
        CITY: 'HADJI-MOHAMMAD-AJUL',
        BARANGAY: 'LANGUYAN',
    },
    {
        CITY: 'HADJI-MOHAMMAD-AJUL',
        BARANGAY: 'PINTASAN',
    },
    {
        CITY: 'HADJI-MOHAMMAD-AJUL',
        BARANGAY: 'SERONGGON',
    },
    {
        CITY: 'HADJI-MOHAMMAD-AJUL',
        BARANGAY: 'SIBAGO',
    },
    {
        CITY: 'HADJI-MOHAMMAD-AJUL',
        BARANGAY: 'SULUTAN MATANGAL',
    },
    {
        CITY: 'HADJI-MOHAMMAD-AJUL',
        BARANGAY: 'TUBURAN PROPER (POB.)',
    },
    {
        CITY: 'HADJI-MUHTAMAD',
        BARANGAY: 'BALUK-BALUK',
    },
    {
        CITY: 'HADJI-MUHTAMAD',
        BARANGAY: 'DASALAN',
    },
    {
        CITY: 'HADJI-MUHTAMAD',
        BARANGAY: 'LUBUKAN',
    },
    {
        CITY: 'HADJI-MUHTAMAD',
        BARANGAY: 'LUUKBONGSOD',
    },
    {
        CITY: 'HADJI-MUHTAMAD',
        BARANGAY: 'MANANGGAL',
    },
    {
        CITY: 'HADJI-MUHTAMAD',
        BARANGAY: 'PALAHANGAN',
    },
    {
        CITY: 'HADJI-MUHTAMAD',
        BARANGAY: 'PANDUCAN',
    },
    {
        CITY: 'HADJI-MUHTAMAD',
        BARANGAY: 'SANGBAY BIG',
    },
    {
        CITY: 'HADJI-MUHTAMAD',
        BARANGAY: 'SANGBAY SMALL',
    },
    {
        CITY: 'HADJI-MUHTAMAD',
        BARANGAY: 'TAUSAN',
    },
    {
        CITY: 'LAMITAN',
        BARANGAY: 'ARCO',
    },
    {
        CITY: 'LAMITAN',
        BARANGAY: 'BA-AS',
    },
    {
        CITY: 'LAMITAN',
        BARANGAY: 'BAIMBING',
    },
    {
        CITY: 'LAMITAN',
        BARANGAY: 'BALAGTASAN',
    },
    {
        CITY: 'LAMITAN',
        BARANGAY: 'BALAS',
    },
    {
        CITY: 'LAMITAN',
        BARANGAY: 'BALOBO',
    },
    {
        CITY: 'LAMITAN',
        BARANGAY: 'BATO',
    },
    {
        CITY: 'LAMITAN',
        BARANGAY: 'BAUNGOS',
    },
    {
        CITY: 'LAMITAN',
        BARANGAY: 'BOHEBESSEY',
    },
    {
        CITY: 'LAMITAN',
        BARANGAY: 'BOHEIBU',
    },
    {
        CITY: 'LAMITAN',
        BARANGAY: 'BOHENANGE',
    },
    {
        CITY: 'LAMITAN',
        BARANGAY: 'BOHESAPA',
    },
    {
        CITY: 'LAMITAN',
        BARANGAY: 'BOHEYAKAN',
    },
    {
        CITY: 'LAMITAN',
        BARANGAY: 'BOHEYAWAS',
    },
    {
        CITY: 'LAMITAN',
        BARANGAY: 'BUAHAN',
    },
    {
        CITY: 'LAMITAN',
        BARANGAY: 'BULANTING',
    },
    {
        CITY: 'LAMITAN',
        BARANGAY: 'BULINGAN',
    },
    {
        CITY: 'LAMITAN',
        BARANGAY: 'CABOBO',
    },
    {
        CITY: 'LAMITAN',
        BARANGAY: 'CALUGUSAN',
    },
    {
        CITY: 'LAMITAN',
        BARANGAY: 'CAMPO UNO',
    },
    {
        CITY: 'LAMITAN',
        BARANGAY: 'COLONIA',
    },
    {
        CITY: 'LAMITAN',
        BARANGAY: 'DANIT-PUNTOCAN',
    },
    {
        CITY: 'LAMITAN',
        BARANGAY: 'KULAY BATO',
    },
    {
        CITY: 'LAMITAN',
        BARANGAY: 'LEBBUH',
    },
    {
        CITY: 'LAMITAN',
        BARANGAY: 'LIMO-OK',
    },
    {
        CITY: 'LAMITAN',
        BARANGAY: 'LO-OK',
    },
    {
        CITY: 'LAMITAN',
        BARANGAY: 'LUKSUMBANG',
    },
    {
        CITY: 'LAMITAN',
        BARANGAY: 'LUMUTON',
    },
    {
        CITY: 'LAMITAN',
        BARANGAY: 'MAGANDA',
    },
    {
        CITY: 'LAMITAN',
        BARANGAY: 'MALAKAS',
    },
    {
        CITY: 'LAMITAN',
        BARANGAY: 'MALIGAYA',
    },
    {
        CITY: 'LAMITAN',
        BARANGAY: 'MALINIS (POB.)',
    },
    {
        CITY: 'LAMITAN',
        BARANGAY: 'MALO-ONG CANAL',
    },
    {
        CITY: 'LAMITAN',
        BARANGAY: 'MALO-ONG SAN JOSE',
    },
    {
        CITY: 'LAMITAN',
        BARANGAY: 'MATATAG',
    },
    {
        CITY: 'LAMITAN',
        BARANGAY: 'MATIBAY',
    },
    {
        CITY: 'LAMITAN',
        BARANGAY: 'PARANGBASAK',
    },
    {
        CITY: 'LAMITAN',
        BARANGAY: 'SABONG',
    },
    {
        CITY: 'LAMITAN',
        BARANGAY: 'SANTA CLARA',
    },
    {
        CITY: 'LAMITAN',
        BARANGAY: 'SENGAL',
    },
    {
        CITY: 'LAMITAN',
        BARANGAY: 'SIMBANGON',
    },
    {
        CITY: 'LAMITAN',
        BARANGAY: 'TANDONG AHAS',
    },
    {
        CITY: 'LAMITAN',
        BARANGAY: 'TUMAKID',
    },
    {
        CITY: 'LAMITAN',
        BARANGAY: 'UBIT',
    },
    {
        CITY: 'LAMITAN',
        BARANGAY: 'ULAME',
    },
    {
        CITY: 'LANTAWAN',
        BARANGAY: 'ATONG-ATONG',
    },
    {
        CITY: 'LANTAWAN',
        BARANGAY: 'BAGBAGON',
    },
    {
        CITY: 'LANTAWAN',
        BARANGAY: 'BAUNGIS',
    },
    {
        CITY: 'LANTAWAN',
        BARANGAY: 'BULAN-BULAN',
    },
    {
        CITY: 'LANTAWAN',
        BARANGAY: 'BULANZA',
    },
    {
        CITY: 'LANTAWAN',
        BARANGAY: 'CALAYAN',
    },
    {
        CITY: 'LANTAWAN',
        BARANGAY: 'CALUGUSAN',
    },
    {
        CITY: 'LANTAWAN',
        BARANGAY: 'CANIBUNGAN',
    },
    {
        CITY: 'LANTAWAN',
        BARANGAY: 'LANDUGAN',
    },
    {
        CITY: 'LANTAWAN',
        BARANGAY: 'LANTAWAN PROPER (POB.)',
    },
    {
        CITY: 'LANTAWAN',
        BARANGAY: 'LAWILA',
    },
    {
        CITY: 'LANTAWAN',
        BARANGAY: 'LAWI-LAWI',
    },
    {
        CITY: 'LANTAWAN',
        BARANGAY: 'LOWER BANAS',
    },
    {
        CITY: 'LANTAWAN',
        BARANGAY: 'LOWER MANGGAS',
    },
    {
        CITY: 'LANTAWAN',
        BARANGAY: 'LUUK-MALUHA',
    },
    {
        CITY: 'LANTAWAN',
        BARANGAY: 'MATARLING',
    },
    {
        CITY: 'LANTAWAN',
        BARANGAY: 'MATIKANG',
    },
    {
        CITY: 'LANTAWAN',
        BARANGAY: 'PAMUCALIN',
    },
    {
        CITY: 'LANTAWAN',
        BARANGAY: 'PANIONGAN',
    },
    {
        CITY: 'LANTAWAN',
        BARANGAY: 'PARIAN-BAUNOH',
    },
    {
        CITY: 'LANTAWAN',
        BARANGAY: 'SUBA-AN (PANGASAHAN)',
    },
    {
        CITY: 'LANTAWAN',
        BARANGAY: 'SWITCH YAKAL',
    },
    {
        CITY: 'LANTAWAN',
        BARANGAY: 'TAIRAN',
    },
    {
        CITY: 'LANTAWAN',
        BARANGAY: 'UPPER BANAS',
    },
    {
        CITY: 'LANTAWAN',
        BARANGAY: 'UPPER MANGGAS',
    },
    {
        CITY: 'MALUSO',
        BARANGAY: 'ABONG-ABONG',
    },
    {
        CITY: 'MALUSO',
        BARANGAY: 'BATUNGAL',
    },
    {
        CITY: 'MALUSO',
        BARANGAY: 'CALANG CANAS',
    },
    {
        CITY: 'MALUSO',
        BARANGAY: 'FUENTE MALUSO',
    },
    {
        CITY: 'MALUSO',
        BARANGAY: 'GUANAN NORTH (ZONE I)',
    },
    {
        CITY: 'MALUSO',
        BARANGAY: 'GUANAN SOUTH (ZONE II)',
    },
    {
        CITY: 'MALUSO',
        BARANGAY: 'LIMBUBONG',
    },
    {
        CITY: 'MALUSO',
        BARANGAY: 'MAHAYAHAY LOWER (ZONE I)',
    },
    {
        CITY: 'MALUSO',
        BARANGAY: 'MAHAYAHAY UPPER (ZONE II)',
    },
    {
        CITY: 'MALUSO',
        BARANGAY: 'MUSLIM AREA',
    },
    {
        CITY: 'MALUSO',
        BARANGAY: 'PORT HOLLAND ZONE I POB. (UPPER)',
    },
    {
        CITY: 'MALUSO',
        BARANGAY: 'PORT HOLLAND ZONE II POB. (SHIPYARD MAIN)',
    },
    {
        CITY: 'MALUSO',
        BARANGAY: 'PORT HOLLAND ZONE III POB. (SAMAL VILLAGE)',
    },
    {
        CITY: 'MALUSO',
        BARANGAY: 'PORT HOLLAND ZONE IV (LOWER)',
    },
    {
        CITY: 'MALUSO',
        BARANGAY: 'PORT HOLLAND ZONE V (SHIPYARD TABUK)',
    },
    {
        CITY: 'MALUSO',
        BARANGAY: 'TABERLONGAN',
    },
    {
        CITY: 'MALUSO',
        BARANGAY: 'TAMUK',
    },
    {
        CITY: 'MALUSO',
        BARANGAY: 'TOWNSITE (POB.)',
    },
    {
        CITY: 'MALUSO',
        BARANGAY: 'TUBIGAN',
    },
    {
        CITY: 'MALUSO',
        BARANGAY: 'UPPER GARLAYAN',
    },
    {
        CITY: 'SUMISIP',
        BARANGAY: 'BACUNG',
    },
    {
        CITY: 'SUMISIP',
        BARANGAY: 'BAIWAS',
    },
    {
        CITY: 'SUMISIP',
        BARANGAY: 'BASAK',
    },
    {
        CITY: 'SUMISIP',
        BARANGAY: 'BENEMBENGAN LOWER',
    },
    {
        CITY: 'SUMISIP',
        BARANGAY: 'BENEMBENGAN UPPER',
    },
    {
        CITY: 'SUMISIP',
        BARANGAY: 'BOHE-LANGUYAN',
    },
    {
        CITY: 'SUMISIP',
        BARANGAY: 'BULI-BULI',
    },
    {
        CITY: 'SUMISIP',
        BARANGAY: 'CABCABAN',
    },
    {
        CITY: 'SUMISIP',
        BARANGAY: 'CABENGBENG LOWER',
    },
    {
        CITY: 'SUMISIP',
        BARANGAY: 'CABENGBENG UPPER',
    },
    {
        CITY: 'SUMISIP',
        BARANGAY: 'ETTUB-ETTUB',
    },
    {
        CITY: 'SUMISIP',
        BARANGAY: 'GUIONG',
    },
    {
        CITY: 'SUMISIP',
        BARANGAY: 'KAUM-AIR',
    },
    {
        CITY: 'SUMISIP',
        BARANGAY: 'KAUMPAMATSAKEM',
    },
    {
        CITY: 'SUMISIP',
        BARANGAY: 'LIBUG',
    },
    {
        CITY: 'SUMISIP',
        BARANGAY: 'LIMBOCANDIS',
    },
    {
        CITY: 'SUMISIP',
        BARANGAY: 'LUKKETON',
    },
    {
        CITY: 'SUMISIP',
        BARANGAY: 'LUUK-BAIT',
    },
    {
        CITY: 'SUMISIP',
        BARANGAY: 'MAHATALANG',
    },
    {
        CITY: 'SUMISIP',
        BARANGAY: 'MANAUL',
    },
    {
        CITY: 'SUMISIP',
        BARANGAY: 'MANGAL (POB.)',
    },
    {
        CITY: 'SUMISIP',
        BARANGAY: 'MARANG',
    },
    {
        CITY: 'SUMISIP',
        BARANGAY: 'MEBAK',
    },
    {
        CITY: 'SUMISIP',
        BARANGAY: 'SAHAYA BOHE BATO',
    },
    {
        CITY: 'SUMISIP',
        BARANGAY: 'SAPAH BULAK',
    },
    {
        CITY: 'SUMISIP',
        BARANGAY: 'SUMISIP CENTRAL',
    },
    {
        CITY: 'SUMISIP',
        BARANGAY: 'TIKUS',
    },
    {
        CITY: 'SUMISIP',
        BARANGAY: 'TONGSENGAL',
    },
    {
        CITY: 'SUMISIP',
        BARANGAY: 'TUMAHUBONG',
    },
    {
        CITY: 'TABUAN-LASA',
        BARANGAY: 'BABAG (BABUAN ISLAND)',
    },
    {
        CITY: 'TABUAN-LASA',
        BARANGAY: 'BALANTING',
    },
    {
        CITY: 'TABUAN-LASA',
        BARANGAY: 'BOLOH-BOLOH',
    },
    {
        CITY: 'TABUAN-LASA',
        BARANGAY: 'BUKUT-UMUS',
    },
    {
        CITY: 'TABUAN-LASA',
        BARANGAY: 'KAUMPURNAH',
    },
    {
        CITY: 'TABUAN-LASA',
        BARANGAY: 'LANAWAN',
    },
    {
        CITY: 'TABUAN-LASA',
        BARANGAY: 'PISAK-PISAK',
    },
    {
        CITY: 'TABUAN-LASA',
        BARANGAY: 'SALUPING',
    },
    {
        CITY: 'TABUAN-LASA',
        BARANGAY: 'SULIGAN (BABUAN ISLAND)',
    },
    {
        CITY: 'TABUAN-LASA',
        BARANGAY: 'SULLOH (TAPIANTANA)',
    },
    {
        CITY: 'TABUAN-LASA',
        BARANGAY: 'TAMBULIG BUTON',
    },
    {
        CITY: 'TABUAN-LASA',
        BARANGAY: 'TONG-UMUS',
    },
    {
        CITY: 'TIPO-TIPO',
        BARANGAY: 'BADJA',
    },
    {
        CITY: 'TIPO-TIPO',
        BARANGAY: 'BAGUINDAN',
    },
    {
        CITY: 'TIPO-TIPO',
        BARANGAY: 'BANAH',
    },
    {
        CITY: 'TIPO-TIPO',
        BARANGAY: 'BANGCUANG',
    },
    {
        CITY: 'TIPO-TIPO',
        BARANGAY: 'BOHEBACA',
    },
    {
        CITY: 'TIPO-TIPO',
        BARANGAY: 'BOHELEBUNG',
    },
    {
        CITY: 'TIPO-TIPO',
        BARANGAY: 'BOHE-TAMBAK',
    },
    {
        CITY: 'TIPO-TIPO',
        BARANGAY: 'LAGAYAS',
    },
    {
        CITY: 'TIPO-TIPO',
        BARANGAY: 'LIMBO-UPAS',
    },
    {
        CITY: 'TIPO-TIPO',
        BARANGAY: 'SILANGKUM',
    },
    {
        CITY: 'TIPO-TIPO',
        BARANGAY: 'TIPO-TIPO PROPER (POB.)',
    },
    {
        CITY: 'UNGKAYA-PUKAN',
        BARANGAY: 'AMALOY',
    },
    {
        CITY: 'UNGKAYA-PUKAN',
        BARANGAY: 'BOHE-PAHUH',
    },
    {
        CITY: 'UNGKAYA-PUKAN',
        BARANGAY: 'BOHE-SUYAK',
    },
    {
        CITY: 'UNGKAYA-PUKAN',
        BARANGAY: 'CABANGALAN',
    },
    {
        CITY: 'UNGKAYA-PUKAN',
        BARANGAY: 'DANIT',
    },
    {
        CITY: 'UNGKAYA-PUKAN',
        BARANGAY: 'KAMAMBURINGAN',
    },
    {
        CITY: 'UNGKAYA-PUKAN',
        BARANGAY: 'MATATA',
    },
    {
        CITY: 'UNGKAYA-PUKAN',
        BARANGAY: 'MATERLING',
    },
    {
        CITY: 'UNGKAYA-PUKAN',
        BARANGAY: 'PIPIL',
    },
    {
        CITY: 'UNGKAYA-PUKAN',
        BARANGAY: 'SUNGKAYUT',
    },
    {
        CITY: 'UNGKAYA-PUKAN',
        BARANGAY: 'TONGBATO',
    },
    {
        CITY: 'UNGKAYA-PUKAN',
        BARANGAY: 'ULITAN',
    },
    {
        CITY: 'AMPATUAN',
        BARANGAY: 'DICALONGAN (POB.)',
    },
    {
        CITY: 'AMPATUAN',
        BARANGAY: 'KAKAL',
    },
    {
        CITY: 'AMPATUAN',
        BARANGAY: 'KAMASI',
    },
    {
        CITY: 'AMPATUAN',
        BARANGAY: 'KAPINPILAN',
    },
    {
        CITY: 'AMPATUAN',
        BARANGAY: 'KAURAN',
    },
    {
        CITY: 'AMPATUAN',
        BARANGAY: 'MALATIMON',
    },
    {
        CITY: 'AMPATUAN',
        BARANGAY: 'MATAGABONG',
    },
    {
        CITY: 'AMPATUAN',
        BARANGAY: 'SALMAN',
    },
    {
        CITY: 'AMPATUAN',
        BARANGAY: 'SANIAG',
    },
    {
        CITY: 'AMPATUAN',
        BARANGAY: 'TOMICOR',
    },
    {
        CITY: 'AMPATUAN',
        BARANGAY: 'TUBAK',
    },
    {
        CITY: 'BARIRA',
        BARANGAY: 'BARIRA (POB.)',
    },
    {
        CITY: 'BARIRA',
        BARANGAY: 'BUALAN',
    },
    {
        CITY: 'BARIRA',
        BARANGAY: 'GADUNG',
    },
    {
        CITY: 'BARIRA',
        BARANGAY: 'KOROSOYAN',
    },
    {
        CITY: 'BARIRA',
        BARANGAY: 'LAMIN',
    },
    {
        CITY: 'BARIRA',
        BARANGAY: 'LIONG',
    },
    {
        CITY: 'BARIRA',
        BARANGAY: 'LIPA',
    },
    {
        CITY: 'BARIRA',
        BARANGAY: 'LIPAWAN',
    },
    {
        CITY: 'BARIRA',
        BARANGAY: 'MARANG',
    },
    {
        CITY: 'BARIRA',
        BARANGAY: 'MINABAY',
    },
    {
        CITY: 'BARIRA',
        BARANGAY: 'NABALAWAG',
    },
    {
        CITY: 'BARIRA',
        BARANGAY: 'PANGGAO',
    },
    {
        CITY: 'BARIRA',
        BARANGAY: 'ROMINIMBANG',
    },
    {
        CITY: 'BARIRA',
        BARANGAY: 'TOGAIG',
    },
    {
        CITY: 'BULDON',
        BARANGAY: 'AMPUAN',
    },
    {
        CITY: 'BULDON',
        BARANGAY: 'ARATUC',
    },
    {
        CITY: 'BULDON',
        BARANGAY: 'CABAYUAN',
    },
    {
        CITY: 'BULDON',
        BARANGAY: 'CALAAN (POB.)',
    },
    {
        CITY: 'BULDON',
        BARANGAY: 'DINGANEN',
    },
    {
        CITY: 'BULDON',
        BARANGAY: 'EDCOR (GALLEGO EDCOR)',
    },
    {
        CITY: 'BULDON',
        BARANGAY: 'KARIM',
    },
    {
        CITY: 'BULDON',
        BARANGAY: 'KULIMPANG',
    },
    {
        CITY: 'BULDON',
        BARANGAY: 'MATAYA',
    },
    {
        CITY: 'BULDON',
        BARANGAY: 'MINABAY',
    },
    {
        CITY: 'BULDON',
        BARANGAY: 'NUYO',
    },
    {
        CITY: 'BULDON',
        BARANGAY: 'ORING',
    },
    {
        CITY: 'BULDON',
        BARANGAY: 'PANTAWAN',
    },
    {
        CITY: 'BULDON',
        BARANGAY: 'PIERS',
    },
    {
        CITY: 'BULDON',
        BARANGAY: 'RUMIDAS',
    },
    {
        CITY: 'BULUAN',
        BARANGAY: 'DIGAL',
    },
    {
        CITY: 'BULUAN',
        BARANGAY: 'LOWER SILING',
    },
    {
        CITY: 'BULUAN',
        BARANGAY: 'MASLABENG',
    },
    {
        CITY: 'BULUAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BULUAN',
        BARANGAY: 'POPOL',
    },
    {
        CITY: 'BULUAN',
        BARANGAY: 'TALITAY',
    },
    {
        CITY: 'BULUAN',
        BARANGAY: 'UPPER SILING',
    },
    {
        CITY: 'DATU-ABDULLAH-SANGKI',
        BARANGAY: 'BANABA',
    },
    {
        CITY: 'DATU-ABDULLAH-SANGKI',
        BARANGAY: 'DIMAAMPAO',
    },
    {
        CITY: 'DATU-ABDULLAH-SANGKI',
        BARANGAY: 'DIMAMPAO',
    },
    {
        CITY: 'DATU-ABDULLAH-SANGKI',
        BARANGAY: 'GUINIBON',
    },
    {
        CITY: 'DATU-ABDULLAH-SANGKI',
        BARANGAY: 'KAYA-KAYA',
    },
    {
        CITY: 'DATU-ABDULLAH-SANGKI',
        BARANGAY: 'MAGANOY',
    },
    {
        CITY: 'DATU-ABDULLAH-SANGKI',
        BARANGAY: 'MAO',
    },
    {
        CITY: 'DATU-ABDULLAH-SANGKI',
        BARANGAY: 'MARANDING',
    },
    {
        CITY: 'DATU-ABDULLAH-SANGKI',
        BARANGAY: 'SUGADOL',
    },
    {
        CITY: 'DATU-ABDULLAH-SANGKI',
        BARANGAY: 'TALISAWA',
    },
    {
        CITY: 'DATU-ABDULLAH-SANGKI',
        BARANGAY: 'TUKANOLOCONG (TUKANOLOGONG)',
    },
    {
        CITY: 'DATU-ANGGAL-MIDTIMBANG',
        BARANGAY: 'ADAON',
    },
    {
        CITY: 'DATU-ANGGAL-MIDTIMBANG',
        BARANGAY: 'BRAR',
    },
    {
        CITY: 'DATU-ANGGAL-MIDTIMBANG',
        BARANGAY: 'MAPAYAG',
    },
    {
        CITY: 'DATU-ANGGAL-MIDTIMBANG',
        BARANGAY: 'MIDTIMBANG (POB.)',
    },
    {
        CITY: 'DATU-ANGGAL-MIDTIMBANG',
        BARANGAY: 'NUNANGAN (NUNANGEN)',
    },
    {
        CITY: 'DATU-ANGGAL-MIDTIMBANG',
        BARANGAY: 'TUGAL',
    },
    {
        CITY: 'DATU-ANGGAL-MIDTIMBANG',
        BARANGAY: 'TULUNAN',
    },
    {
        CITY: 'DATU-BLAH-T.-SINSUAT',
        BARANGAY: 'KINIMI',
    },
    {
        CITY: 'DATU-BLAH-T.-SINSUAT',
        BARANGAY: 'LAGUITAN',
    },
    {
        CITY: 'DATU-BLAH-T.-SINSUAT',
        BARANGAY: 'LAPAKEN',
    },
    {
        CITY: 'DATU-BLAH-T.-SINSUAT',
        BARANGAY: 'MATUBER',
    },
    {
        CITY: 'DATU-BLAH-T.-SINSUAT',
        BARANGAY: 'METI',
    },
    {
        CITY: 'DATU-BLAH-T.-SINSUAT',
        BARANGAY: 'NALKAN',
    },
    {
        CITY: 'DATU-BLAH-T.-SINSUAT',
        BARANGAY: 'PENANSARAN',
    },
    {
        CITY: 'DATU-BLAH-T.-SINSUAT',
        BARANGAY: 'PURA',
    },
    {
        CITY: 'DATU-BLAH-T.-SINSUAT',
        BARANGAY: 'RESA',
    },
    {
        CITY: 'DATU-BLAH-T.-SINSUAT',
        BARANGAY: 'SEDEM',
    },
    {
        CITY: 'DATU-BLAH-T.-SINSUAT',
        BARANGAY: 'SINIPAK',
    },
    {
        CITY: 'DATU-BLAH-T.-SINSUAT',
        BARANGAY: 'TAMBAK',
    },
    {
        CITY: 'DATU-BLAH-T.-SINSUAT',
        BARANGAY: 'TUBUAN',
    },
    {
        CITY: 'DATU-HOFFER-AMPATUAN',
        BARANGAY: 'KUBENTONG',
    },
    {
        CITY: 'DATU-HOFFER-AMPATUAN',
        BARANGAY: 'LABU-LABU I',
    },
    {
        CITY: 'DATU-HOFFER-AMPATUAN',
        BARANGAY: 'LABU-LABU II',
    },
    {
        CITY: 'DATU-HOFFER-AMPATUAN',
        BARANGAY: 'LIMPONGO',
    },
    {
        CITY: 'DATU-HOFFER-AMPATUAN',
        BARANGAY: 'MACALAG',
    },
    {
        CITY: 'DATU-HOFFER-AMPATUAN',
        BARANGAY: 'SAYAP',
    },
    {
        CITY: 'DATU-HOFFER-AMPATUAN',
        BARANGAY: 'TAIB',
    },
    {
        CITY: 'DATU-HOFFER-AMPATUAN',
        BARANGAY: 'TALIBADOK',
    },
    {
        CITY: 'DATU-HOFFER-AMPATUAN',
        BARANGAY: 'TUAYAN',
    },
    {
        CITY: 'DATU-HOFFER-AMPATUAN',
        BARANGAY: 'TUAYAN I',
    },
    {
        CITY: 'DATU-HOFFER-AMPATUAN',
        BARANGAY: 'TUNTUNGAN',
    },
    {
        CITY: 'DATU-ODIN-SINSUAT',
        BARANGAY: 'AMBOLODTO',
    },
    {
        CITY: 'DATU-ODIN-SINSUAT',
        BARANGAY: 'AWANG',
    },
    {
        CITY: 'DATU-ODIN-SINSUAT',
        BARANGAY: 'BADAK',
    },
    {
        CITY: 'DATU-ODIN-SINSUAT',
        BARANGAY: 'BAGOENGED',
    },
    {
        CITY: 'DATU-ODIN-SINSUAT',
        BARANGAY: 'BAKA',
    },
    {
        CITY: 'DATU-ODIN-SINSUAT',
        BARANGAY: 'BENOLEN',
    },
    {
        CITY: 'DATU-ODIN-SINSUAT',
        BARANGAY: 'BITU',
    },
    {
        CITY: 'DATU-ODIN-SINSUAT',
        BARANGAY: 'BONGUED',
    },
    {
        CITY: 'DATU-ODIN-SINSUAT',
        BARANGAY: 'BUGAWAS',
    },
    {
        CITY: 'DATU-ODIN-SINSUAT',
        BARANGAY: 'CAPITON',
    },
    {
        CITY: 'DATU-ODIN-SINSUAT',
        BARANGAY: 'DADOS',
    },
    {
        CITY: 'DATU-ODIN-SINSUAT',
        BARANGAY: 'DALICAN POBLACION',
    },
    {
        CITY: 'DATU-ODIN-SINSUAT',
        BARANGAY: 'DINAIG PROPER',
    },
    {
        CITY: 'DATU-ODIN-SINSUAT',
        BARANGAY: 'DULANGAN',
    },
    {
        CITY: 'DATU-ODIN-SINSUAT',
        BARANGAY: 'KAKAR',
    },
    {
        CITY: 'DATU-ODIN-SINSUAT',
        BARANGAY: 'KENEBEKA',
    },
    {
        CITY: 'DATU-ODIN-SINSUAT',
        BARANGAY: 'KURINTEM',
    },
    {
        CITY: 'DATU-ODIN-SINSUAT',
        BARANGAY: 'KUSIONG',
    },
    {
        CITY: 'DATU-ODIN-SINSUAT',
        BARANGAY: 'LABUNGAN',
    },
    {
        CITY: 'DATU-ODIN-SINSUAT',
        BARANGAY: 'LINEK',
    },
    {
        CITY: 'DATU-ODIN-SINSUAT',
        BARANGAY: 'MAKIR',
    },
    {
        CITY: 'DATU-ODIN-SINSUAT',
        BARANGAY: 'MARGUES',
    },
    {
        CITY: 'DATU-ODIN-SINSUAT',
        BARANGAY: 'MOMPONG',
    },
    {
        CITY: 'DATU-ODIN-SINSUAT',
        BARANGAY: 'NEKITAN',
    },
    {
        CITY: 'DATU-ODIN-SINSUAT',
        BARANGAY: 'SAPALAN',
    },
    {
        CITY: 'DATU-ODIN-SINSUAT',
        BARANGAY: 'SEMBA',
    },
    {
        CITY: 'DATU-ODIN-SINSUAT',
        BARANGAY: 'SIBUTO',
    },
    {
        CITY: 'DATU-ODIN-SINSUAT',
        BARANGAY: 'SIFAREN (SIFARAN)',
    },
    {
        CITY: 'DATU-ODIN-SINSUAT',
        BARANGAY: 'TAMBAK',
    },
    {
        CITY: 'DATU-ODIN-SINSUAT',
        BARANGAY: 'TAMONTAKA',
    },
    {
        CITY: 'DATU-ODIN-SINSUAT',
        BARANGAY: 'TANUEL',
    },
    {
        CITY: 'DATU-ODIN-SINSUAT',
        BARANGAY: 'TAPIAN',
    },
    {
        CITY: 'DATU-ODIN-SINSUAT',
        BARANGAY: 'TAVIRAN',
    },
    {
        CITY: 'DATU-ODIN-SINSUAT',
        BARANGAY: 'TENONGGOS',
    },
    {
        CITY: 'DATU-PAGLAS',
        BARANGAY: 'ALIP (POB.)',
    },
    {
        CITY: 'DATU-PAGLAS',
        BARANGAY: 'BONAWAN',
    },
    {
        CITY: 'DATU-PAGLAS',
        BARANGAY: 'BULOD',
    },
    {
        CITY: 'DATU-PAGLAS',
        BARANGAY: 'DAMALUSAY',
    },
    {
        CITY: 'DATU-PAGLAS',
        BARANGAY: 'DAMAWATO',
    },
    {
        CITY: 'DATU-PAGLAS',
        BARANGAY: 'DATANG',
    },
    {
        CITY: 'DATU-PAGLAS',
        BARANGAY: 'ELBEBE',
    },
    {
        CITY: 'DATU-PAGLAS',
        BARANGAY: 'KALUMENGA (KALUMANGA)',
    },
    {
        CITY: 'DATU-PAGLAS',
        BARANGAY: 'KATIL',
    },
    {
        CITY: 'DATU-PAGLAS',
        BARANGAY: 'LIPAO',
    },
    {
        CITY: 'DATU-PAGLAS',
        BARANGAY: 'LOMOYON',
    },
    {
        CITY: 'DATU-PAGLAS',
        BARANGAY: 'MADIDIS',
    },
    {
        CITY: 'DATU-PAGLAS',
        BARANGAY: 'MAKAT',
    },
    {
        CITY: 'DATU-PAGLAS',
        BARANGAY: 'MALALA',
    },
    {
        CITY: 'DATU-PAGLAS',
        BARANGAY: 'MANGADEG',
    },
    {
        CITY: 'DATU-PAGLAS',
        BARANGAY: 'MANINDOLO',
    },
    {
        CITY: 'DATU-PAGLAS',
        BARANGAY: 'MAO',
    },
    {
        CITY: 'DATU-PAGLAS',
        BARANGAY: 'NAPOK',
    },
    {
        CITY: 'DATU-PAGLAS',
        BARANGAY: 'PALAO SA BUTO',
    },
    {
        CITY: 'DATU-PAGLAS',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'DATU-PAGLAS',
        BARANGAY: 'PUYA',
    },
    {
        CITY: 'DATU-PAGLAS',
        BARANGAY: 'SALENDAB',
    },
    {
        CITY: 'DATU-PAGLAS',
        BARANGAY: 'SEPAKA',
    },
    {
        CITY: 'DATU-PIANG',
        BARANGAY: 'ALONGANAN',
    },
    {
        CITY: 'DATU-PIANG',
        BARANGAY: 'AMBADAO',
    },
    {
        CITY: 'DATU-PIANG',
        BARANGAY: 'BALANAKAN',
    },
    {
        CITY: 'DATU-PIANG',
        BARANGAY: 'BALONG',
    },
    {
        CITY: 'DATU-PIANG',
        BARANGAY: 'BUAYAN',
    },
    {
        CITY: 'DATU-PIANG',
        BARANGAY: 'DADO',
    },
    {
        CITY: 'DATU-PIANG',
        BARANGAY: 'DAMABALAS',
    },
    {
        CITY: 'DATU-PIANG',
        BARANGAY: 'DUAMINANGA',
    },
    {
        CITY: 'DATU-PIANG',
        BARANGAY: 'KALIPAPA',
    },
    {
        CITY: 'DATU-PIANG',
        BARANGAY: 'KANGUAN',
    },
    {
        CITY: 'DATU-PIANG',
        BARANGAY: 'LIONG',
    },
    {
        CITY: 'DATU-PIANG',
        BARANGAY: 'MAGASLONG',
    },
    {
        CITY: 'DATU-PIANG',
        BARANGAY: 'MASIGAY',
    },
    {
        CITY: 'DATU-PIANG',
        BARANGAY: 'MONTAY',
    },
    {
        CITY: 'DATU-PIANG',
        BARANGAY: 'POBLACION (DULAWAN)',
    },
    {
        CITY: 'DATU-PIANG',
        BARANGAY: 'REINA REGENTE',
    },
    {
        CITY: 'DATU-SALIBO',
        BARANGAY: 'ALONGANAN',
    },
    {
        CITY: 'DATU-SALIBO',
        BARANGAY: 'ANDAVIT',
    },
    {
        CITY: 'DATU-SALIBO',
        BARANGAY: 'BALANAKAN',
    },
    {
        CITY: 'DATU-SALIBO',
        BARANGAY: 'BUAYAN',
    },
    {
        CITY: 'DATU-SALIBO',
        BARANGAY: 'BUTILEN',
    },
    {
        CITY: 'DATU-SALIBO',
        BARANGAY: 'DADO',
    },
    {
        CITY: 'DATU-SALIBO',
        BARANGAY: 'DAMABALAS',
    },
    {
        CITY: 'DATU-SALIBO',
        BARANGAY: 'DUAMINANGA',
    },
    {
        CITY: 'DATU-SALIBO',
        BARANGAY: 'KALIPAPA',
    },
    {
        CITY: 'DATU-SALIBO',
        BARANGAY: 'LIONG',
    },
    {
        CITY: 'DATU-SALIBO',
        BARANGAY: 'MAGASLONG',
    },
    {
        CITY: 'DATU-SALIBO',
        BARANGAY: 'MASIGAY',
    },
    {
        CITY: 'DATU-SALIBO',
        BARANGAY: 'PAGATIN',
    },
    {
        CITY: 'DATU-SALIBO',
        BARANGAY: 'PANDI',
    },
    {
        CITY: 'DATU-SALIBO',
        BARANGAY: 'PENDITEN',
    },
    {
        CITY: 'DATU-SALIBO',
        BARANGAY: 'SAMBULAWAN',
    },
    {
        CITY: 'DATU-SALIBO',
        BARANGAY: 'TEE',
    },
    {
        CITY: 'DATU-SAUDI-AMPATUAN',
        BARANGAY: 'DAPIAWAN',
    },
    {
        CITY: 'DATU-SAUDI-AMPATUAN',
        BARANGAY: 'ELIAN',
    },
    {
        CITY: 'DATU-SAUDI-AMPATUAN',
        BARANGAY: 'GAWANG',
    },
    {
        CITY: 'DATU-SAUDI-AMPATUAN',
        BARANGAY: 'KABENGI',
    },
    {
        CITY: 'DATU-SAUDI-AMPATUAN',
        BARANGAY: 'KITANGO',
    },
    {
        CITY: 'DATU-SAUDI-AMPATUAN',
        BARANGAY: 'KITAPOK',
    },
    {
        CITY: 'DATU-SAUDI-AMPATUAN',
        BARANGAY: 'MADIA',
    },
    {
        CITY: 'DATU-SAUDI-AMPATUAN',
        BARANGAY: 'SALBU',
    },
    {
        CITY: 'DATU-UNSAY',
        BARANGAY: 'BULAYAN',
    },
    {
        CITY: 'DATU-UNSAY',
        BARANGAY: 'IGANAGAMPONG',
    },
    {
        CITY: 'DATU-UNSAY',
        BARANGAY: 'MACALAG',
    },
    {
        CITY: 'DATU-UNSAY',
        BARANGAY: 'MAITUMAIG',
    },
    {
        CITY: 'DATU-UNSAY',
        BARANGAY: 'MALANGOG',
    },
    {
        CITY: 'DATU-UNSAY',
        BARANGAY: 'META',
    },
    {
        CITY: 'DATU-UNSAY',
        BARANGAY: 'PANANGETI',
    },
    {
        CITY: 'DATU-UNSAY',
        BARANGAY: 'TUNTUNGAN',
    },
    {
        CITY: 'GEN.-S.-K.-PENDATUN',
        BARANGAY: 'BADAK',
    },
    {
        CITY: 'GEN.-S.-K.-PENDATUN',
        BARANGAY: 'BULOD',
    },
    {
        CITY: 'GEN.-S.-K.-PENDATUN',
        BARANGAY: 'KALADTURAN',
    },
    {
        CITY: 'GEN.-S.-K.-PENDATUN',
        BARANGAY: 'KULASI',
    },
    {
        CITY: 'GEN.-S.-K.-PENDATUN',
        BARANGAY: 'LAO-LAO',
    },
    {
        CITY: 'GEN.-S.-K.-PENDATUN',
        BARANGAY: 'LASANGAN',
    },
    {
        CITY: 'GEN.-S.-K.-PENDATUN',
        BARANGAY: 'LOWER IDTIG',
    },
    {
        CITY: 'GEN.-S.-K.-PENDATUN',
        BARANGAY: 'LUMABAO',
    },
    {
        CITY: 'GEN.-S.-K.-PENDATUN',
        BARANGAY: 'MAKAINIS',
    },
    {
        CITY: 'GEN.-S.-K.-PENDATUN',
        BARANGAY: 'MIDCONDING',
    },
    {
        CITY: 'GEN.-S.-K.-PENDATUN',
        BARANGAY: 'MIDPANDACAN',
    },
    {
        CITY: 'GEN.-S.-K.-PENDATUN',
        BARANGAY: 'PANOSOLEN',
    },
    {
        CITY: 'GEN.-S.-K.-PENDATUN',
        BARANGAY: 'PIDTIGUIAN',
    },
    {
        CITY: 'GEN.-S.-K.-PENDATUN',
        BARANGAY: 'QUIPOLOT',
    },
    {
        CITY: 'GEN.-S.-K.-PENDATUN',
        BARANGAY: 'RAMCOR',
    },
    {
        CITY: 'GEN.-S.-K.-PENDATUN',
        BARANGAY: 'SADANGEN',
    },
    {
        CITY: 'GEN.-S.-K.-PENDATUN',
        BARANGAY: 'SADANGIN',
    },
    {
        CITY: 'GEN.-S.-K.-PENDATUN',
        BARANGAY: 'SUMAKUBAY',
    },
    {
        CITY: 'GEN.-S.-K.-PENDATUN',
        BARANGAY: 'TONGGOL',
    },
    {
        CITY: 'GEN.-S.-K.-PENDATUN',
        BARANGAY: 'UPPER LASANGAN',
    },
    {
        CITY: 'GUINDULUNGAN',
        BARANGAY: 'AHAN',
    },
    {
        CITY: 'GUINDULUNGAN',
        BARANGAY: 'BAGAN',
    },
    {
        CITY: 'GUINDULUNGAN',
        BARANGAY: 'DATALPANDAN',
    },
    {
        CITY: 'GUINDULUNGAN',
        BARANGAY: 'KALUMAMIS',
    },
    {
        CITY: 'GUINDULUNGAN',
        BARANGAY: 'KATEMAN',
    },
    {
        CITY: 'GUINDULUNGAN',
        BARANGAY: 'LAMBAYAO',
    },
    {
        CITY: 'GUINDULUNGAN',
        BARANGAY: 'MACASAMPEN',
    },
    {
        CITY: 'GUINDULUNGAN',
        BARANGAY: 'MUSLIM',
    },
    {
        CITY: 'GUINDULUNGAN',
        BARANGAY: 'MUTI',
    },
    {
        CITY: 'GUINDULUNGAN',
        BARANGAY: 'SAMPAO',
    },
    {
        CITY: 'GUINDULUNGAN',
        BARANGAY: 'TAMBUNAN II',
    },
    {
        CITY: 'KABUNTALAN',
        BARANGAY: 'BAGUMBAYAN',
    },
    {
        CITY: 'KABUNTALAN',
        BARANGAY: 'BUTERIN',
    },
    {
        CITY: 'KABUNTALAN',
        BARANGAY: 'DADTUMOG (DADTUMEG)',
    },
    {
        CITY: 'KABUNTALAN',
        BARANGAY: 'GAMBAR',
    },
    {
        CITY: 'KABUNTALAN',
        BARANGAY: 'GANTA',
    },
    {
        CITY: 'KABUNTALAN',
        BARANGAY: 'KATIDTUAN',
    },
    {
        CITY: 'KABUNTALAN',
        BARANGAY: 'LANGEBAN',
    },
    {
        CITY: 'KABUNTALAN',
        BARANGAY: 'LIONG',
    },
    {
        CITY: 'KABUNTALAN',
        BARANGAY: 'LOWER TAVIRAN',
    },
    {
        CITY: 'KABUNTALAN',
        BARANGAY: 'MAITONG',
    },
    {
        CITY: 'KABUNTALAN',
        BARANGAY: 'MATILAK',
    },
    {
        CITY: 'KABUNTALAN',
        BARANGAY: 'PAGALUNGAN',
    },
    {
        CITY: 'KABUNTALAN',
        BARANGAY: 'PAYAN',
    },
    {
        CITY: 'KABUNTALAN',
        BARANGAY: 'PEDTAD',
    },
    {
        CITY: 'KABUNTALAN',
        BARANGAY: 'PENED',
    },
    {
        CITY: 'KABUNTALAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'KABUNTALAN',
        BARANGAY: 'UPPER TAVIRAN',
    },
    {
        CITY: 'PARANG',
        BARANGAY: 'BONGO ISLAND (LITAYEN)',
    },
    {
        CITY: 'PARANG',
        BARANGAY: 'CAMPO ISLAM',
    },
    {
        CITY: 'PARANG',
        BARANGAY: 'COTONGAN',
    },
    {
        CITY: 'PARANG',
        BARANGAY: 'DATU MACARIMBANG BIRUAR',
    },
    {
        CITY: 'PARANG',
        BARANGAY: 'GADUNGAN',
    },
    {
        CITY: 'PARANG',
        BARANGAY: 'GADUNGANPEDPANDARAN',
    },
    {
        CITY: 'PARANG',
        BARANGAY: 'GUIDAY T. BIRUAR',
    },
    {
        CITY: 'PARANG',
        BARANGAY: 'GUMAGADONG CALAWAG',
    },
    {
        CITY: 'PARANG',
        BARANGAY: 'KABUAN',
    },
    {
        CITY: 'PARANG',
        BARANGAY: 'LANDASAN (SARMIENTO)',
    },
    {
        CITY: 'PARANG',
        BARANGAY: 'LIMBAYAN',
    },
    {
        CITY: 'PARANG',
        BARANGAY: 'MACASANDAG',
    },
    {
        CITY: 'PARANG',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'PARANG',
        BARANGAY: 'MAKING',
    },
    {
        CITY: 'PARANG',
        BARANGAY: 'MANION',
    },
    {
        CITY: 'PARANG',
        BARANGAY: 'MORO POINT',
    },
    {
        CITY: 'PARANG',
        BARANGAY: 'NITUAN',
    },
    {
        CITY: 'PARANG',
        BARANGAY: 'ORANDANG',
    },
    {
        CITY: 'PARANG',
        BARANGAY: 'PINANTAO',
    },
    {
        CITY: 'PARANG',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'PARANG',
        BARANGAY: 'POBLACION II',
    },
    {
        CITY: 'PARANG',
        BARANGAY: 'POLLOC',
    },
    {
        CITY: 'PARANG',
        BARANGAY: 'SAMBEREN',
    },
    {
        CITY: 'PARANG',
        BARANGAY: 'TAGUDTONGAN',
    },
    {
        CITY: 'PARANG',
        BARANGAY: 'TUCA-MAROR',
    },
    {
        CITY: 'MAMASAPANO',
        BARANGAY: 'PUSAO',
    },
    {
        CITY: 'MANGUDADATU',
        BARANGAY: 'DALADAGAN',
    },
    {
        CITY: 'MANGUDADATU',
        BARANGAY: 'KALIAN',
    },
    {
        CITY: 'MANGUDADATU',
        BARANGAY: 'LUAYAN',
    },
    {
        CITY: 'MANGUDADATU',
        BARANGAY: 'PAITAN',
    },
    {
        CITY: 'MANGUDADATU',
        BARANGAY: 'PANAPAN',
    },
    {
        CITY: 'MANGUDADATU',
        BARANGAY: 'TENOK',
    },
    {
        CITY: 'MANGUDADATU',
        BARANGAY: 'TINAMBULAN',
    },
    {
        CITY: 'MANGUDADATU',
        BARANGAY: 'TUMBAO',
    },
    {
        CITY: 'MATANOG',
        BARANGAY: 'BAYANGA NORTE',
    },
    {
        CITY: 'MATANOG',
        BARANGAY: 'BAYANGA SUR',
    },
    {
        CITY: 'MATANOG',
        BARANGAY: 'BUGASAN NORTE',
    },
    {
        CITY: 'MATANOG',
        BARANGAY: 'BUGASAN SUR (POB.)',
    },
    {
        CITY: 'MATANOG',
        BARANGAY: 'KIDAMA',
    },
    {
        CITY: 'MATANOG',
        BARANGAY: 'LANGCO',
    },
    {
        CITY: 'MATANOG',
        BARANGAY: 'LANGKONG',
    },
    {
        CITY: 'MATANOG',
        BARANGAY: 'SAPAD',
    },
    {
        CITY: 'NORTHERN-KABUNTALAN',
        BARANGAY: 'BALONG',
    },
    {
        CITY: 'NORTHERN-KABUNTALAN',
        BARANGAY: 'DAMATOG',
    },
    {
        CITY: 'NORTHERN-KABUNTALAN',
        BARANGAY: 'GAYONGA',
    },
    {
        CITY: 'NORTHERN-KABUNTALAN',
        BARANGAY: 'GUIAWA',
    },
    {
        CITY: 'NORTHERN-KABUNTALAN',
        BARANGAY: 'INDATUAN',
    },
    {
        CITY: 'NORTHERN-KABUNTALAN',
        BARANGAY: 'KAPIMPILAN',
    },
    {
        CITY: 'NORTHERN-KABUNTALAN',
        BARANGAY: 'LIBUNGAN',
    },
    {
        CITY: 'NORTHERN-KABUNTALAN',
        BARANGAY: 'MONTAY',
    },
    {
        CITY: 'NORTHERN-KABUNTALAN',
        BARANGAY: 'PAULINO LABIO',
    },
    {
        CITY: 'NORTHERN-KABUNTALAN',
        BARANGAY: 'SABAKEN',
    },
    {
        CITY: 'NORTHERN-KABUNTALAN',
        BARANGAY: 'TUMAGUINTING',
    },
    {
        CITY: 'PAGAGAWAN',
        BARANGAY: 'BALATUNGKAYO (BATUNGKAYO)',
    },
    {
        CITY: 'PAGAGAWAN',
        BARANGAY: 'BULIT',
    },
    {
        CITY: 'PAGAGAWAN',
        BARANGAY: 'BULOD',
    },
    {
        CITY: 'PAGAGAWAN',
        BARANGAY: 'DUNGGUAN',
    },
    {
        CITY: 'PAGAGAWAN',
        BARANGAY: 'LIMBALUD',
    },
    {
        CITY: 'PAGAGAWAN',
        BARANGAY: 'MARIDAGAO',
    },
    {
        CITY: 'PAGAGAWAN',
        BARANGAY: 'NABUNDAS',
    },
    {
        CITY: 'PAGAGAWAN',
        BARANGAY: 'PAGAGAWAN',
    },
    {
        CITY: 'PAGAGAWAN',
        BARANGAY: 'TALAPAS',
    },
    {
        CITY: 'PAGAGAWAN',
        BARANGAY: 'TALITAY',
    },
    {
        CITY: 'PAGAGAWAN',
        BARANGAY: 'TUNGGOL',
    },
    {
        CITY: 'PAGALUNGAN',
        BARANGAY: 'BAGOENGED',
    },
    {
        CITY: 'PAGALUNGAN',
        BARANGAY: 'BULIOK',
    },
    {
        CITY: 'PAGALUNGAN',
        BARANGAY: 'DALGAN',
    },
    {
        CITY: 'PAGALUNGAN',
        BARANGAY: 'DAMALASAK',
    },
    {
        CITY: 'PAGALUNGAN',
        BARANGAY: 'GALAKIT',
    },
    {
        CITY: 'PAGALUNGAN',
        BARANGAY: 'INUG-UG',
    },
    {
        CITY: 'PAGALUNGAN',
        BARANGAY: 'KALBUGAN',
    },
    {
        CITY: 'PAGALUNGAN',
        BARANGAY: 'KILANGAN',
    },
    {
        CITY: 'PAGALUNGAN',
        BARANGAY: 'KUDAL',
    },
    {
        CITY: 'PAGALUNGAN',
        BARANGAY: 'LAYOG',
    },
    {
        CITY: 'PAGALUNGAN',
        BARANGAY: 'LINANDANGAN',
    },
    {
        CITY: 'PAGALUNGAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'PAGLAT',
        BARANGAY: 'CAMPO',
    },
    {
        CITY: 'PAGLAT',
        BARANGAY: 'DAMAKLING',
    },
    {
        CITY: 'PAGLAT',
        BARANGAY: 'DAMALUSAY',
    },
    {
        CITY: 'PAGLAT',
        BARANGAY: 'KAKAL',
    },
    {
        CITY: 'PAGLAT',
        BARANGAY: 'PAGLAT',
    },
    {
        CITY: 'PAGLAT',
        BARANGAY: 'SALAM',
    },
    {
        CITY: 'PAGLAT',
        BARANGAY: 'TUAL',
    },
    {
        CITY: 'PAGLAT',
        BARANGAY: 'UPPER IDTIG',
    },
    {
        CITY: 'PANDAG',
        BARANGAY: 'KABULING',
    },
    {
        CITY: 'PANDAG',
        BARANGAY: 'KAYAGA',
    },
    {
        CITY: 'PANDAG',
        BARANGAY: 'KAYUPO (CUYAPO)',
    },
    {
        CITY: 'PANDAG',
        BARANGAY: 'LEPAK',
    },
    {
        CITY: 'PANDAG',
        BARANGAY: 'LOWER DILAG',
    },
    {
        CITY: 'PANDAG',
        BARANGAY: 'MALANGIT',
    },
    {
        CITY: 'PANDAG',
        BARANGAY: 'PANDAG',
    },
    {
        CITY: 'PANDAG',
        BARANGAY: 'UPPER DILAG',
    },
    {
        CITY: 'RAJAH-BUAYAN',
        BARANGAY: 'BAITAL',
    },
    {
        CITY: 'RAJAH-BUAYAN',
        BARANGAY: 'BAKAT',
    },
    {
        CITY: 'RAJAH-BUAYAN',
        BARANGAY: 'DAPANTIS',
    },
    {
        CITY: 'RAJAH-BUAYAN',
        BARANGAY: 'GAUNAN',
    },
    {
        CITY: 'RAJAH-BUAYAN',
        BARANGAY: 'MALIBPOLOK',
    },
    {
        CITY: 'RAJAH-BUAYAN',
        BARANGAY: 'MILEB',
    },
    {
        CITY: 'RAJAH-BUAYAN',
        BARANGAY: 'PANADTABAN',
    },
    {
        CITY: 'RAJAH-BUAYAN',
        BARANGAY: 'PIDSANDAWAN',
    },
    {
        CITY: 'RAJAH-BUAYAN',
        BARANGAY: 'SAMPAO',
    },
    {
        CITY: 'RAJAH-BUAYAN',
        BARANGAY: 'SAPAKAN (POB.)',
    },
    {
        CITY: 'RAJAH-BUAYAN',
        BARANGAY: 'TABUNGAO',
    },
    {
        CITY: 'SHARIFF-AGUAK',
        BARANGAY: 'BAGONG',
    },
    {
        CITY: 'SHARIFF-AGUAK',
        BARANGAY: 'BIALONG',
    },
    {
        CITY: 'SHARIFF-AGUAK',
        BARANGAY: 'KULOY',
    },
    {
        CITY: 'SHARIFF-AGUAK',
        BARANGAY: 'LABU-LABU',
    },
    {
        CITY: 'SHARIFF-AGUAK',
        BARANGAY: 'LAPOK (LEPOK)',
    },
    {
        CITY: 'SHARIFF-AGUAK',
        BARANGAY: 'MALINGAO',
    },
    {
        CITY: 'SHARIFF-AGUAK',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SHARIFF-AGUAK',
        BARANGAY: 'POBLACION I',
    },
    {
        CITY: 'SHARIFF-AGUAK',
        BARANGAY: 'POBLACION II',
    },
    {
        CITY: 'SHARIFF-AGUAK',
        BARANGAY: 'SATAN',
    },
    {
        CITY: 'SHARIFF-AGUAK',
        BARANGAY: 'TAPIKAN',
    },
    {
        CITY: 'SHARIFF-AGUAK',
        BARANGAY: 'TIMBANGAN',
    },
    {
        CITY: 'SHARIFF-AGUAK',
        BARANGAY: 'TINA',
    },
    {
        CITY: 'SHARIFF-SAYDONA-MUSTAPHA',
        BARANGAY: 'BAKAT',
    },
    {
        CITY: 'SHARIFF-SAYDONA-MUSTAPHA',
        BARANGAY: 'DALE-BONG',
    },
    {
        CITY: 'SHARIFF-SAYDONA-MUSTAPHA',
        BARANGAY: 'DASAWAO',
    },
    {
        CITY: 'SHARIFF-SAYDONA-MUSTAPHA',
        BARANGAY: 'DATU BAKAL',
    },
    {
        CITY: 'SHARIFF-SAYDONA-MUSTAPHA',
        BARANGAY: 'DATU KILAY',
    },
    {
        CITY: 'SHARIFF-SAYDONA-MUSTAPHA',
        BARANGAY: 'DUGUENGEN',
    },
    {
        CITY: 'SHARIFF-SAYDONA-MUSTAPHA',
        BARANGAY: 'GANTA',
    },
    {
        CITY: 'SHARIFF-SAYDONA-MUSTAPHA',
        BARANGAY: 'INALADAN',
    },
    {
        CITY: 'SHARIFF-SAYDONA-MUSTAPHA',
        BARANGAY: 'LIBUTAN',
    },
    {
        CITY: 'SHARIFF-SAYDONA-MUSTAPHA',
        BARANGAY: 'LINANTANGAN',
    },
    {
        CITY: 'SHARIFF-SAYDONA-MUSTAPHA',
        BARANGAY: 'NABUNDAS',
    },
    {
        CITY: 'SHARIFF-SAYDONA-MUSTAPHA',
        BARANGAY: 'PAGATIN',
    },
    {
        CITY: 'SHARIFF-SAYDONA-MUSTAPHA',
        BARANGAY: 'PAGATIN (PAGATIN I)',
    },
    {
        CITY: 'SHARIFF-SAYDONA-MUSTAPHA',
        BARANGAY: 'PAMALIAN',
    },
    {
        CITY: 'SHARIFF-SAYDONA-MUSTAPHA',
        BARANGAY: 'PIKEG',
    },
    {
        CITY: 'SOUTH-UPI',
        BARANGAY: 'BIARONG',
    },
    {
        CITY: 'SOUTH-UPI',
        BARANGAY: 'BONGO',
    },
    {
        CITY: 'SOUTH-UPI',
        BARANGAY: 'ITAW',
    },
    {
        CITY: 'SOUTH-UPI',
        BARANGAY: 'KIGAN',
    },
    {
        CITY: 'SOUTH-UPI',
        BARANGAY: 'KUYA',
    },
    {
        CITY: 'SOUTH-UPI',
        BARANGAY: 'LAMUD',
    },
    {
        CITY: 'SOUTH-UPI',
        BARANGAY: 'LOOY',
    },
    {
        CITY: 'SOUTH-UPI',
        BARANGAY: 'PANDAN',
    },
    {
        CITY: 'SOUTH-UPI',
        BARANGAY: 'PILAR',
    },
    {
        CITY: 'SOUTH-UPI',
        BARANGAY: 'ROMANGAOB (POB.)',
    },
    {
        CITY: 'SOUTH-UPI',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'SULTAN-KUDARAT',
        BARANGAY: 'ALAMADA',
    },
    {
        CITY: 'SULTAN-KUDARAT',
        BARANGAY: 'BANATIN',
    },
    {
        CITY: 'SULTAN-KUDARAT',
        BARANGAY: 'BANUBO',
    },
    {
        CITY: 'SULTAN-KUDARAT',
        BARANGAY: 'BULALO',
    },
    {
        CITY: 'SULTAN-KUDARAT',
        BARANGAY: 'BULIBOD',
    },
    {
        CITY: 'SULTAN-KUDARAT',
        BARANGAY: 'CALSADA',
    },
    {
        CITY: 'SULTAN-KUDARAT',
        BARANGAY: 'CROSSING SIMUAY',
    },
    {
        CITY: 'SULTAN-KUDARAT',
        BARANGAY: 'DALUMANGCOB (POB.)',
    },
    {
        CITY: 'SULTAN-KUDARAT',
        BARANGAY: 'DAMANIOG',
    },
    {
        CITY: 'SULTAN-KUDARAT',
        BARANGAY: 'DARAPANAN',
    },
    {
        CITY: 'SULTAN-KUDARAT',
        BARANGAY: 'GANG',
    },
    {
        CITY: 'SULTAN-KUDARAT',
        BARANGAY: 'INAWAN',
    },
    {
        CITY: 'SULTAN-KUDARAT',
        BARANGAY: 'KABUNTALAN',
    },
    {
        CITY: 'SULTAN-KUDARAT',
        BARANGAY: 'KAKAR',
    },
    {
        CITY: 'SULTAN-KUDARAT',
        BARANGAY: 'KAPIMPILAN',
    },
    {
        CITY: 'SULTAN-KUDARAT',
        BARANGAY: 'KATAMLANGAN (MATAMPAY)',
    },
    {
        CITY: 'SULTAN-KUDARAT',
        BARANGAY: 'KATIDTUAN',
    },
    {
        CITY: 'SULTAN-KUDARAT',
        BARANGAY: 'KATULI',
    },
    {
        CITY: 'SULTAN-KUDARAT',
        BARANGAY: 'LADIA',
    },
    {
        CITY: 'SULTAN-KUDARAT',
        BARANGAY: 'LIMBO',
    },
    {
        CITY: 'SULTAN-KUDARAT',
        BARANGAY: 'MAIDAPA',
    },
    {
        CITY: 'SULTAN-KUDARAT',
        BARANGAY: 'MAKAGUILING',
    },
    {
        CITY: 'SULTAN-KUDARAT',
        BARANGAY: 'MATENGEN',
    },
    {
        CITY: 'SULTAN-KUDARAT',
        BARANGAY: 'MULAUG',
    },
    {
        CITY: 'SULTAN-KUDARAT',
        BARANGAY: 'NALINAN',
    },
    {
        CITY: 'SULTAN-KUDARAT',
        BARANGAY: 'NARA',
    },
    {
        CITY: 'SULTAN-KUDARAT',
        BARANGAY: 'NEKITAN',
    },
    {
        CITY: 'SULTAN-KUDARAT',
        BARANGAY: 'OLAS',
    },
    {
        CITY: 'SULTAN-KUDARAT',
        BARANGAY: 'PANATAN',
    },
    {
        CITY: 'SULTAN-KUDARAT',
        BARANGAY: 'PIGCALAGAN',
    },
    {
        CITY: 'SULTAN-KUDARAT',
        BARANGAY: 'PIGKELEGAN (IBOTEGEN)',
    },
    {
        CITY: 'SULTAN-KUDARAT',
        BARANGAY: 'PINARING',
    },
    {
        CITY: 'SULTAN-KUDARAT',
        BARANGAY: 'PINGPING',
    },
    {
        CITY: 'SULTAN-KUDARAT',
        BARANGAY: 'RAGUISI',
    },
    {
        CITY: 'SULTAN-KUDARAT',
        BARANGAY: 'REBUKEN',
    },
    {
        CITY: 'SULTAN-KUDARAT',
        BARANGAY: 'SALIMBAO',
    },
    {
        CITY: 'SULTAN-KUDARAT',
        BARANGAY: 'SAMBOLAWAN',
    },
    {
        CITY: 'SULTAN-KUDARAT',
        BARANGAY: 'SENDITAN',
    },
    {
        CITY: 'SULTAN-KUDARAT',
        BARANGAY: 'UNGAP',
    },
    {
        CITY: 'SULTAN-MASTURA',
        BARANGAY: 'BALUT',
    },
    {
        CITY: 'SULTAN-MASTURA',
        BARANGAY: 'BOLIOK',
    },
    {
        CITY: 'SULTAN-MASTURA',
        BARANGAY: 'BUNGABONG',
    },
    {
        CITY: 'SULTAN-MASTURA',
        BARANGAY: 'DAGURONGAN',
    },
    {
        CITY: 'SULTAN-MASTURA',
        BARANGAY: 'KIRKIR',
    },
    {
        CITY: 'SULTAN-MASTURA',
        BARANGAY: 'MACABICO (MACABISO)',
    },
    {
        CITY: 'SULTAN-MASTURA',
        BARANGAY: 'NAMUKEN',
    },
    {
        CITY: 'SULTAN-MASTURA',
        BARANGAY: 'SIMUAY/SEASHORE',
    },
    {
        CITY: 'SULTAN-MASTURA',
        BARANGAY: 'SOLON',
    },
    {
        CITY: 'SULTAN-MASTURA',
        BARANGAY: 'TAMBO',
    },
    {
        CITY: 'SULTAN-MASTURA',
        BARANGAY: 'TAPAYAN',
    },
    {
        CITY: 'SULTAN-MASTURA',
        BARANGAY: 'TARIKEN',
    },
    {
        CITY: 'SULTAN-MASTURA',
        BARANGAY: 'TUKA',
    },
    {
        CITY: 'SULTAN-SA-BARONGIS',
        BARANGAY: 'ANGKAYAMAT',
    },
    {
        CITY: 'SULTAN-SA-BARONGIS',
        BARANGAY: 'BARURAO',
    },
    {
        CITY: 'SULTAN-SA-BARONGIS',
        BARANGAY: 'BULOD',
    },
    {
        CITY: 'SULTAN-SA-BARONGIS',
        BARANGAY: 'DARAMPUA',
    },
    {
        CITY: 'SULTAN-SA-BARONGIS',
        BARANGAY: 'GADUNGAN',
    },
    {
        CITY: 'SULTAN-SA-BARONGIS',
        BARANGAY: 'KULAMBOG',
    },
    {
        CITY: 'SULTAN-SA-BARONGIS',
        BARANGAY: 'LANGGAPANAN',
    },
    {
        CITY: 'SULTAN-SA-BARONGIS',
        BARANGAY: 'MASULOT',
    },
    {
        CITY: 'SULTAN-SA-BARONGIS',
        BARANGAY: 'PALDONG',
    },
    {
        CITY: 'SULTAN-SA-BARONGIS',
        BARANGAY: 'PAPAKAN',
    },
    {
        CITY: 'SULTAN-SA-BARONGIS',
        BARANGAY: 'TUGAL',
    },
    {
        CITY: 'SULTAN-SA-BARONGIS',
        BARANGAY: 'TUKANAKUDEN',
    },
    {
        CITY: 'TALAYAN',
        BARANGAY: 'BINANGGA NORTH',
    },
    {
        CITY: 'TALAYAN',
        BARANGAY: 'BINANGGA SOUTH',
    },
    {
        CITY: 'TALAYAN',
        BARANGAY: 'BOBOGUIRON',
    },
    {
        CITY: 'TALAYAN',
        BARANGAY: 'DAMABLAC',
    },
    {
        CITY: 'TALAYAN',
        BARANGAY: 'FUGOTAN',
    },
    {
        CITY: 'TALAYAN',
        BARANGAY: 'FUKOL',
    },
    {
        CITY: 'TALAYAN',
        BARANGAY: 'KATIBPUAN',
    },
    {
        CITY: 'TALAYAN',
        BARANGAY: 'KEDATI',
    },
    {
        CITY: 'TALAYAN',
        BARANGAY: 'LANTING',
    },
    {
        CITY: 'TALAYAN',
        BARANGAY: 'LINAMUNAN',
    },
    {
        CITY: 'TALAYAN',
        BARANGAY: 'MARADER',
    },
    {
        CITY: 'TALAYAN',
        BARANGAY: 'TALAYAN',
    },
    {
        CITY: 'TALAYAN',
        BARANGAY: 'TAMAR',
    },
    {
        CITY: 'TALAYAN',
        BARANGAY: 'TAMBUNAN I',
    },
    {
        CITY: 'TALAYAN',
        BARANGAY: 'TIMBALUAN',
    },
    {
        CITY: 'TALITAY',
        BARANGAY: 'BINTAN (BENTAN)',
    },
    {
        CITY: 'TALITAY',
        BARANGAY: 'GADUNGAN',
    },
    {
        CITY: 'TALITAY',
        BARANGAY: 'KILADAP',
    },
    {
        CITY: 'TALITAY',
        BARANGAY: 'KILALAN',
    },
    {
        CITY: 'TALITAY',
        BARANGAY: 'KUDEN',
    },
    {
        CITY: 'TALITAY',
        BARANGAY: 'MAKADAYON',
    },
    {
        CITY: 'TALITAY',
        BARANGAY: 'MANGGAY',
    },
    {
        CITY: 'TALITAY',
        BARANGAY: 'PAGEDA',
    },
    {
        CITY: 'TALITAY',
        BARANGAY: 'TALITAY',
    },
    {
        CITY: 'UPI',
        BARANGAY: 'BANTEK',
    },
    {
        CITY: 'UPI',
        BARANGAY: 'BAYABAS',
    },
    {
        CITY: 'UPI',
        BARANGAY: 'BLENSONG',
    },
    {
        CITY: 'UPI',
        BARANGAY: 'BORONGOTAN',
    },
    {
        CITY: 'UPI',
        BARANGAY: 'BUGABUNGAN',
    },
    {
        CITY: 'UPI',
        BARANGAY: 'BUNGCOG',
    },
    {
        CITY: 'UPI',
        BARANGAY: 'DARUGAO',
    },
    {
        CITY: 'UPI',
        BARANGAY: 'GANASI',
    },
    {
        CITY: 'UPI',
        BARANGAY: 'KABAKABA',
    },
    {
        CITY: 'UPI',
        BARANGAY: 'KIBLEG',
    },
    {
        CITY: 'UPI',
        BARANGAY: 'KIBUCAY',
    },
    {
        CITY: 'UPI',
        BARANGAY: 'KIGA',
    },
    {
        CITY: 'UPI',
        BARANGAY: 'KINITAN (KINITAAN)',
    },
    {
        CITY: 'UPI',
        BARANGAY: 'MIRAB',
    },
    {
        CITY: 'UPI',
        BARANGAY: 'NANGI',
    },
    {
        CITY: 'UPI',
        BARANGAY: 'NURO POBLACION',
    },
    {
        CITY: 'UPI',
        BARANGAY: 'RANAO PILAYAN',
    },
    {
        CITY: 'UPI',
        BARANGAY: 'REMPES',
    },
    {
        CITY: 'UPI',
        BARANGAY: 'RENEDE',
    },
    {
        CITY: 'UPI',
        BARANGAY: 'RENTI',
    },
    {
        CITY: 'UPI',
        BARANGAY: 'RIFAO',
    },
    {
        CITY: 'UPI',
        BARANGAY: 'SEFEGEFEN',
    },
    {
        CITY: 'UPI',
        BARANGAY: 'TINUNGKAAN',
    },
    {
        CITY: 'BACUNGAN',
        BARANGAY: 'BACUNGAN (POB.)',
    },
    {
        CITY: 'BACUNGAN',
        BARANGAY: 'BOGABONGAN',
    },
    {
        CITY: 'BACUNGAN',
        BARANGAY: 'DELUSOM',
    },
    {
        CITY: 'BACUNGAN',
        BARANGAY: 'MANGOP',
    },
    {
        CITY: 'BACUNGAN',
        BARANGAY: 'MANIL',
    },
    {
        CITY: 'BACUNGAN',
        BARANGAY: 'MAWAL',
    },
    {
        CITY: 'BACUNGAN',
        BARANGAY: 'MIDATAG',
    },
    {
        CITY: 'BACUNGAN',
        BARANGAY: 'MOROB',
    },
    {
        CITY: 'BACUNGAN',
        BARANGAY: 'NASIBAC',
    },
    {
        CITY: 'BACUNGAN',
        BARANGAY: 'RIZON',
    },
    {
        CITY: 'BACUNGAN',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'BACUNGAN',
        BARANGAY: 'SIPACONG',
    },
    {
        CITY: 'BACUNGAN',
        BARANGAY: 'TALINGA',
    },
    {
        CITY: 'BACUNGAN',
        BARANGAY: 'TINAPLAN',
    },
    {
        CITY: 'BACUNGAN',
        BARANGAY: 'TINIGUIBAN',
    },
    {
        CITY: 'BACUNGAN',
        BARANGAY: 'TINUYOP',
    },
    {
        CITY: 'BACUNGAN',
        BARANGAY: 'TIOGAN',
    },
    {
        CITY: 'BACUNGAN',
        BARANGAY: 'TITIK',
    },
    {
        CITY: 'BALIGUIAN',
        BARANGAY: 'ALEGRIA',
    },
    {
        CITY: 'BALIGUIAN',
        BARANGAY: 'DIANGAS',
    },
    {
        CITY: 'BALIGUIAN',
        BARANGAY: 'DICULOM',
    },
    {
        CITY: 'BALIGUIAN',
        BARANGAY: 'GUIMOTAN',
    },
    {
        CITY: 'BALIGUIAN',
        BARANGAY: 'KAUSWAGAN',
    },
    {
        CITY: 'BALIGUIAN',
        BARANGAY: 'KILALABAN',
    },
    {
        CITY: 'BALIGUIAN',
        BARANGAY: 'LINAY',
    },
    {
        CITY: 'BALIGUIAN',
        BARANGAY: 'LUMAY',
    },
    {
        CITY: 'BALIGUIAN',
        BARANGAY: 'MALINAO',
    },
    {
        CITY: 'BALIGUIAN',
        BARANGAY: 'MAMAD',
    },
    {
        CITY: 'BALIGUIAN',
        BARANGAY: 'MAMAWAN',
    },
    {
        CITY: 'BALIGUIAN',
        BARANGAY: 'MILIDAN',
    },
    {
        CITY: 'BALIGUIAN',
        BARANGAY: 'NONOYAN',
    },
    {
        CITY: 'BALIGUIAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BALIGUIAN',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'BALIGUIAN',
        BARANGAY: 'TAMAO',
    },
    {
        CITY: 'BALIGUIAN',
        BARANGAY: 'TAN-AWAN',
    },
    {
        CITY: 'DAPITAN-CITY',
        BARANGAY: 'ALIGUAY',
    },
    {
        CITY: 'DAPITAN-CITY',
        BARANGAY: 'ANTIPOLO',
    },
    {
        CITY: 'DAPITAN-CITY',
        BARANGAY: 'ASENIERO',
    },
    {
        CITY: 'DAPITAN-CITY',
        BARANGAY: 'BA-AO',
    },
    {
        CITY: 'DAPITAN-CITY',
        BARANGAY: 'BAGTING (POB.)',
    },
    {
        CITY: 'DAPITAN-CITY',
        BARANGAY: 'BANBANAN',
    },
    {
        CITY: 'DAPITAN-CITY',
        BARANGAY: 'BANONONG (POB.)',
    },
    {
        CITY: 'DAPITAN-CITY',
        BARANGAY: 'BARCELONA',
    },
    {
        CITY: 'DAPITAN-CITY',
        BARANGAY: 'BAYLIMANGO',
    },
    {
        CITY: 'DAPITAN-CITY',
        BARANGAY: 'BURGOS',
    },
    {
        CITY: 'DAPITAN-CITY',
        BARANGAY: 'CANLUCANI',
    },
    {
        CITY: 'DAPITAN-CITY',
        BARANGAY: 'CARANG',
    },
    {
        CITY: 'DAPITAN-CITY',
        BARANGAY: 'CAWA-CAWA (POB.)',
    },
    {
        CITY: 'DAPITAN-CITY',
        BARANGAY: 'DAMPALAN',
    },
    {
        CITY: 'DAPITAN-CITY',
        BARANGAY: 'DARO',
    },
    {
        CITY: 'DAPITAN-CITY',
        BARANGAY: 'DAWO (POB.)',
    },
    {
        CITY: 'DAPITAN-CITY',
        BARANGAY: 'DIWA-AN',
    },
    {
        CITY: 'DAPITAN-CITY',
        BARANGAY: 'GUIMPUTLAN',
    },
    {
        CITY: 'DAPITAN-CITY',
        BARANGAY: 'HILLTOP',
    },
    {
        CITY: 'DAPITAN-CITY',
        BARANGAY: 'ILAYA',
    },
    {
        CITY: 'DAPITAN-CITY',
        BARANGAY: 'KAUSWAGAN (TALISAY)',
    },
    {
        CITY: 'DAPITAN-CITY',
        BARANGAY: 'LARAYAN',
    },
    {
        CITY: 'DAPITAN-CITY',
        BARANGAY: 'LINABO (POB.)',
    },
    {
        CITY: 'DAPITAN-CITY',
        BARANGAY: 'LIYANG',
    },
    {
        CITY: 'DAPITAN-CITY',
        BARANGAY: 'MARIA CRISTINA',
    },
    {
        CITY: 'DAPITAN-CITY',
        BARANGAY: 'MARIA URAY',
    },
    {
        CITY: 'DAPITAN-CITY',
        BARANGAY: 'MASIDLAKON',
    },
    {
        CITY: 'DAPITAN-CITY',
        BARANGAY: 'MATAGOBTOB POB. (TALISAY)',
    },
    {
        CITY: 'DAPITAN-CITY',
        BARANGAY: 'NAPO',
    },
    {
        CITY: 'DAPITAN-CITY',
        BARANGAY: 'OPAO',
    },
    {
        CITY: 'DAPITAN-CITY',
        BARANGAY: 'ORO',
    },
    {
        CITY: 'DAPITAN-CITY',
        BARANGAY: 'OWAON',
    },
    {
        CITY: 'DAPITAN-CITY',
        BARANGAY: 'OYAN',
    },
    {
        CITY: 'DAPITAN-CITY',
        BARANGAY: 'POLO',
    },
    {
        CITY: 'DAPITAN-CITY',
        BARANGAY: 'POTOL (POB.)',
    },
    {
        CITY: 'DAPITAN-CITY',
        BARANGAY: 'POTUNGAN',
    },
    {
        CITY: 'DAPITAN-CITY',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'DAPITAN-CITY',
        BARANGAY: 'SAN NICOLAS',
    },
    {
        CITY: 'DAPITAN-CITY',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'DAPITAN-CITY',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'DAPITAN-CITY',
        BARANGAY: 'SANTA CRUZ (POB.)',
    },
    {
        CITY: 'DAPITAN-CITY',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'DAPITAN-CITY',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'DAPITAN-CITY',
        BARANGAY: 'SICAYAB BOCANA',
    },
    {
        CITY: 'DAPITAN-CITY',
        BARANGAY: 'SIGAYAN',
    },
    {
        CITY: 'DAPITAN-CITY',
        BARANGAY: 'SILINOG',
    },
    {
        CITY: 'DAPITAN-CITY',
        BARANGAY: 'SINONOC',
    },
    {
        CITY: 'DAPITAN-CITY',
        BARANGAY: 'SULANGON',
    },
    {
        CITY: 'DAPITAN-CITY',
        BARANGAY: 'TAG-OLO',
    },
    {
        CITY: 'DAPITAN-CITY',
        BARANGAY: 'TAGUILON',
    },
    {
        CITY: 'DAPITAN-CITY',
        BARANGAY: 'TAMION',
    },
    {
        CITY: 'DIPOLOG-CITY',
        BARANGAY: 'BARRA (POB.)',
    },
    {
        CITY: 'DIPOLOG-CITY',
        BARANGAY: 'BIASONG (POB.)',
    },
    {
        CITY: 'DIPOLOG-CITY',
        BARANGAY: 'CENTRAL (POB.)',
    },
    {
        CITY: 'DIPOLOG-CITY',
        BARANGAY: 'COGON',
    },
    {
        CITY: 'DIPOLOG-CITY',
        BARANGAY: 'DICAYAS',
    },
    {
        CITY: 'DIPOLOG-CITY',
        BARANGAY: 'DIWAN',
    },
    {
        CITY: 'DIPOLOG-CITY',
        BARANGAY: 'ESTACA (POB.)',
    },
    {
        CITY: 'DIPOLOG-CITY',
        BARANGAY: 'GALAS',
    },
    {
        CITY: 'DIPOLOG-CITY',
        BARANGAY: 'GULAYON',
    },
    {
        CITY: 'DIPOLOG-CITY',
        BARANGAY: 'LUGDUNGAN',
    },
    {
        CITY: 'DIPOLOG-CITY',
        BARANGAY: 'MINAOG',
    },
    {
        CITY: 'DIPOLOG-CITY',
        BARANGAY: 'MIPUTAK (POB.)',
    },
    {
        CITY: 'DIPOLOG-CITY',
        BARANGAY: 'OLINGAN',
    },
    {
        CITY: 'DIPOLOG-CITY',
        BARANGAY: 'PUNTA',
    },
    {
        CITY: 'DIPOLOG-CITY',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'DIPOLOG-CITY',
        BARANGAY: 'SANGKOL',
    },
    {
        CITY: 'DIPOLOG-CITY',
        BARANGAY: 'SANTA FILOMENA',
    },
    {
        CITY: 'DIPOLOG-CITY',
        BARANGAY: 'SANTA ISABEL',
    },
    {
        CITY: 'DIPOLOG-CITY',
        BARANGAY: 'SICAYAB',
    },
    {
        CITY: 'DIPOLOG-CITY',
        BARANGAY: 'SINAMAN',
    },
    {
        CITY: 'DIPOLOG-CITY',
        BARANGAY: 'TURNO',
    },
    {
        CITY: 'GODOD',
        BARANGAY: 'BALUNO',
    },
    {
        CITY: 'GODOD',
        BARANGAY: 'BANUANGAN',
    },
    {
        CITY: 'GODOD',
        BARANGAY: 'BUNAWAN',
    },
    {
        CITY: 'GODOD',
        BARANGAY: 'DILUCOT',
    },
    {
        CITY: 'GODOD',
        BARANGAY: 'DIPOPOR',
    },
    {
        CITY: 'GODOD',
        BARANGAY: 'GUISAPONG',
    },
    {
        CITY: 'GODOD',
        BARANGAY: 'LIMBONGA (LIMBOANGAN)',
    },
    {
        CITY: 'GODOD',
        BARANGAY: 'LOMOGOM',
    },
    {
        CITY: 'GODOD',
        BARANGAY: 'MAUSWAGON',
    },
    {
        CITY: 'GODOD',
        BARANGAY: 'MIAMPIC',
    },
    {
        CITY: 'GODOD',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'GODOD',
        BARANGAY: 'RABA',
    },
    {
        CITY: 'GODOD',
        BARANGAY: 'RAMBON',
    },
    {
        CITY: 'GODOD',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'GODOD',
        BARANGAY: 'SARAWAGAN',
    },
    {
        CITY: 'GODOD',
        BARANGAY: 'SIANAN',
    },
    {
        CITY: 'GODOD',
        BARANGAY: 'SIORAN',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'BACONG',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'BAGONG SILANG',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'BANGANON',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'BAYANIHAN',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'CANUPONG',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'COCOB',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'DATAGAN',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'IMELDA',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'IMMACULADA CONCEPCION',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'LA LIBERTAD',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'LOAY',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'LOWER LUX',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'LUX',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'MALIAN',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'MAMAWAN',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'MAP',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'MATUNOY',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'NEW DAPITAN',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'PANGANURAN',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'PITAWE',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'PITOGO',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'POBLACION (GUTALAC)',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'SALVADOR',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'SAS',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'SIBALIC',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'TIPAN',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'UPPER GUTALAC',
    },
    {
        CITY: 'JOSE-DALMAN',
        BARANGAY: 'BALATAKAN',
    },
    {
        CITY: 'JOSE-DALMAN',
        BARANGAY: 'BITOON',
    },
    {
        CITY: 'JOSE-DALMAN',
        BARANGAY: 'DINASAN',
    },
    {
        CITY: 'JOSE-DALMAN',
        BARANGAY: 'ILIHAN',
    },
    {
        CITY: 'JOSE-DALMAN',
        BARANGAY: 'LABAKID',
    },
    {
        CITY: 'JOSE-DALMAN',
        BARANGAY: 'LIPAY',
    },
    {
        CITY: 'JOSE-DALMAN',
        BARANGAY: 'LITALIP',
    },
    {
        CITY: 'JOSE-DALMAN',
        BARANGAY: 'LOPERO',
    },
    {
        CITY: 'JOSE-DALMAN',
        BARANGAY: 'LUMANPING',
    },
    {
        CITY: 'JOSE-DALMAN',
        BARANGAY: 'MADALAG',
    },
    {
        CITY: 'JOSE-DALMAN',
        BARANGAY: 'MANAWAN',
    },
    {
        CITY: 'JOSE-DALMAN',
        BARANGAY: 'MARUPAY',
    },
    {
        CITY: 'JOSE-DALMAN',
        BARANGAY: 'POBLACION (PONOT)',
    },
    {
        CITY: 'JOSE-DALMAN',
        BARANGAY: 'SIGAMOK',
    },
    {
        CITY: 'JOSE-DALMAN',
        BARANGAY: 'SIPAROK',
    },
    {
        CITY: 'JOSE-DALMAN',
        BARANGAY: 'TABON',
    },
    {
        CITY: 'JOSE-DALMAN',
        BARANGAY: 'TAMAROK',
    },
    {
        CITY: 'JOSE-DALMAN',
        BARANGAY: 'TAMIL',
    },
    {
        CITY: 'KALAWIT',
        BARANGAY: 'BATAYAN',
    },
    {
        CITY: 'KALAWIT',
        BARANGAY: 'BOTONG',
    },
    {
        CITY: 'KALAWIT',
        BARANGAY: 'CONCEPCION',
    },
    {
        CITY: 'KALAWIT',
        BARANGAY: 'DANIEL MAING (DOMINOLOG)',
    },
    {
        CITY: 'KALAWIT',
        BARANGAY: 'FATIMA (LACSUTAN)',
    },
    {
        CITY: 'KALAWIT',
        BARANGAY: 'GATAS',
    },
    {
        CITY: 'KALAWIT',
        BARANGAY: 'KALAWIT (POB.)',
    },
    {
        CITY: 'KALAWIT',
        BARANGAY: 'MARCELO',
    },
    {
        CITY: 'KALAWIT',
        BARANGAY: 'NEW CALAMBA',
    },
    {
        CITY: 'KALAWIT',
        BARANGAY: 'PALALIAN',
    },
    {
        CITY: 'KALAWIT',
        BARANGAY: 'PARAISO',
    },
    {
        CITY: 'KALAWIT',
        BARANGAY: 'PIANON',
    },
    {
        CITY: 'KALAWIT',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'KALAWIT',
        BARANGAY: 'TUGOP',
    },
    {
        CITY: 'KATIPUNAN',
        BARANGAY: 'BALOK',
    },
    {
        CITY: 'KATIPUNAN',
        BARANGAY: 'BARANGAY DOS (POB.)',
    },
    {
        CITY: 'KATIPUNAN',
        BARANGAY: 'BARANGAY UNO (POB.)',
    },
    {
        CITY: 'KATIPUNAN',
        BARANGAY: 'BASAGAN',
    },
    {
        CITY: 'KATIPUNAN',
        BARANGAY: 'BINIRAY',
    },
    {
        CITY: 'KATIPUNAN',
        BARANGAY: 'BULAWAN',
    },
    {
        CITY: 'KATIPUNAN',
        BARANGAY: 'CARUPAY',
    },
    {
        CITY: 'KATIPUNAN',
        BARANGAY: 'DAANGLUNGSOD',
    },
    {
        CITY: 'KATIPUNAN',
        BARANGAY: 'DABIAK',
    },
    {
        CITY: 'KATIPUNAN',
        BARANGAY: 'DR. JOSE RIZAL (LOWER MIAS)',
    },
    {
        CITY: 'KATIPUNAN',
        BARANGAY: 'FIMAGAS',
    },
    {
        CITY: 'KATIPUNAN',
        BARANGAY: 'LOYURAN',
    },
    {
        CITY: 'KATIPUNAN',
        BARANGAY: 'MALASAY',
    },
    {
        CITY: 'KATIPUNAN',
        BARANGAY: 'MALUGAS',
    },
    {
        CITY: 'KATIPUNAN',
        BARANGAY: 'MATAM',
    },
    {
        CITY: 'KATIPUNAN',
        BARANGAY: 'MIAS',
    },
    {
        CITY: 'KATIPUNAN',
        BARANGAY: 'MIATAN',
    },
    {
        CITY: 'KATIPUNAN',
        BARANGAY: 'NANGINAN',
    },
    {
        CITY: 'KATIPUNAN',
        BARANGAY: 'NEW TAMBO',
    },
    {
        CITY: 'KATIPUNAN',
        BARANGAY: 'PATIK',
    },
    {
        CITY: 'KATIPUNAN',
        BARANGAY: 'SAN ANTONIO (LOOY)',
    },
    {
        CITY: 'KATIPUNAN',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'KATIPUNAN',
        BARANGAY: 'SANAO',
    },
    {
        CITY: 'KATIPUNAN',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'KATIPUNAN',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'KATIPUNAN',
        BARANGAY: 'SERES',
    },
    {
        CITY: 'KATIPUNAN',
        BARANGAY: 'SEROAN',
    },
    {
        CITY: 'KATIPUNAN',
        BARANGAY: 'SINGATONG',
    },
    {
        CITY: 'KATIPUNAN',
        BARANGAY: 'SINUYAK',
    },
    {
        CITY: 'KATIPUNAN',
        BARANGAY: 'SITOG',
    },
    {
        CITY: 'KATIPUNAN',
        BARANGAY: 'TUBURAN',
    },
    {
        CITY: 'LABASON',
        BARANGAY: 'ANTONINO (POB.)',
    },
    {
        CITY: 'LABASON',
        BARANGAY: 'BALAS',
    },
    {
        CITY: 'LABASON',
        BARANGAY: 'BOBONGAN',
    },
    {
        CITY: 'LABASON',
        BARANGAY: 'DANSALAN',
    },
    {
        CITY: 'LABASON',
        BARANGAY: 'GABU',
    },
    {
        CITY: 'LABASON',
        BARANGAY: 'GIL SANCHEZ',
    },
    {
        CITY: 'LABASON',
        BARANGAY: 'IMELDA',
    },
    {
        CITY: 'LABASON',
        BARANGAY: 'IMMACULADA',
    },
    {
        CITY: 'LABASON',
        BARANGAY: 'KIPIT',
    },
    {
        CITY: 'LABASON',
        BARANGAY: 'LA UNION',
    },
    {
        CITY: 'LABASON',
        BARANGAY: 'LAPATAN',
    },
    {
        CITY: 'LABASON',
        BARANGAY: 'LAWAGAN',
    },
    {
        CITY: 'LABASON',
        BARANGAY: 'LAWIGAN',
    },
    {
        CITY: 'LABASON',
        BARANGAY: 'LOPOC (POB.)',
    },
    {
        CITY: 'LABASON',
        BARANGAY: 'MALINTUBOAN',
    },
    {
        CITY: 'LABASON',
        BARANGAY: 'NEW SALVACION',
    },
    {
        CITY: 'LABASON',
        BARANGAY: 'OSUKAN',
    },
    {
        CITY: 'LABASON',
        BARANGAY: 'PATAWAG',
    },
    {
        CITY: 'LABASON',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'LABASON',
        BARANGAY: 'UBAY',
    },
    {
        CITY: 'LA-LIBERTAD',
        BARANGAY: 'EL PARAISO',
    },
    {
        CITY: 'LA-LIBERTAD',
        BARANGAY: 'LA UNION',
    },
    {
        CITY: 'LA-LIBERTAD',
        BARANGAY: 'LA VICTORIA',
    },
    {
        CITY: 'LA-LIBERTAD',
        BARANGAY: 'MAUSWAGON',
    },
    {
        CITY: 'LA-LIBERTAD',
        BARANGAY: 'MERCEDES',
    },
    {
        CITY: 'LA-LIBERTAD',
        BARANGAY: 'NEW ARGAO',
    },
    {
        CITY: 'LA-LIBERTAD',
        BARANGAY: 'NEW BATAAN',
    },
    {
        CITY: 'LA-LIBERTAD',
        BARANGAY: 'NEW CARCAR',
    },
    {
        CITY: 'LA-LIBERTAD',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'LA-LIBERTAD',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'LA-LIBERTAD',
        BARANGAY: 'SANTA CATALINA',
    },
    {
        CITY: 'LA-LIBERTAD',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'LA-LIBERTAD',
        BARANGAY: 'SINGARAN',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'BANIGAN',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'BAYBAY (POB.)',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'CABANGCALAN',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'CANAAN',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'CANDELARIA',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'CAUSWAGAN',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'COMMUNAL',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'COMPRA',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'DELA PAZ',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'EL PARAISO',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'FATIMA',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'GANASE',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'GOAW',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'GOIN',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'KAYOK',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'LA LIBERTAD (MAWAL)',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'LAMAO',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'MABUHAY',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'MAIGANG',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'MALILA',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'MAUSWAGON',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'NEW BETHLEHEM',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'OVERVIEW',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'PANABANG',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'PATAWAG',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'PUNTA',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'SILUCAP',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'TAPICAN',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'TIMAN',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'VILLA CALIXTO SUDIACAL',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'VILLA M. TEJERO',
    },
    {
        CITY: 'MANUKAN',
        BARANGAY: 'DIPANE',
    },
    {
        CITY: 'MANUKAN',
        BARANGAY: 'DISAKAN',
    },
    {
        CITY: 'MANUKAN',
        BARANGAY: 'DON JOSE AGUIRRE',
    },
    {
        CITY: 'MANUKAN',
        BARANGAY: 'EAST POBLACION',
    },
    {
        CITY: 'MANUKAN',
        BARANGAY: 'GUPOT',
    },
    {
        CITY: 'MANUKAN',
        BARANGAY: 'LIBUTON',
    },
    {
        CITY: 'MANUKAN',
        BARANGAY: 'LINAY',
    },
    {
        CITY: 'MANUKAN',
        BARANGAY: 'LINGATONGAN',
    },
    {
        CITY: 'MANUKAN',
        BARANGAY: 'LUPASANG',
    },
    {
        CITY: 'MANUKAN',
        BARANGAY: 'MATE',
    },
    {
        CITY: 'MANUKAN',
        BARANGAY: 'MESES',
    },
    {
        CITY: 'MANUKAN',
        BARANGAY: 'PALARANAN',
    },
    {
        CITY: 'MANUKAN',
        BARANGAY: 'PANGANDAO',
    },
    {
        CITY: 'MANUKAN',
        BARANGAY: 'PATAGAN',
    },
    {
        CITY: 'MANUKAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'MANUKAN',
        BARANGAY: 'PUNTA BLANCA',
    },
    {
        CITY: 'MANUKAN',
        BARANGAY: 'SALUYONG',
    },
    {
        CITY: 'MANUKAN',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'MANUKAN',
        BARANGAY: 'SERONGAN',
    },
    {
        CITY: 'MANUKAN',
        BARANGAY: 'SUISAYAN',
    },
    {
        CITY: 'MANUKAN',
        BARANGAY: 'UPPER DISAKAN',
    },
    {
        CITY: 'MANUKAN',
        BARANGAY: 'VILLARAMOS',
    },
    {
        CITY: 'MUTIA',
        BARANGAY: 'ALVENDA',
    },
    {
        CITY: 'MUTIA',
        BARANGAY: 'BUENASUERTE',
    },
    {
        CITY: 'MUTIA',
        BARANGAY: 'DILAND',
    },
    {
        CITY: 'MUTIA',
        BARANGAY: 'DIOLEN',
    },
    {
        CITY: 'MUTIA',
        BARANGAY: 'HEAD TIPAN',
    },
    {
        CITY: 'MUTIA',
        BARANGAY: 'NEW CASUL',
    },
    {
        CITY: 'MUTIA',
        BARANGAY: 'NEW SIQUIJOR',
    },
    {
        CITY: 'MUTIA',
        BARANGAY: 'NEWLAND',
    },
    {
        CITY: 'MUTIA',
        BARANGAY: 'PASO RIO',
    },
    {
        CITY: 'MUTIA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'MUTIA',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'MUTIA',
        BARANGAY: 'SANTO TOMAS',
    },
    {
        CITY: 'MUTIA',
        BARANGAY: 'TINGLAN',
    },
    {
        CITY: 'MUTIA',
        BARANGAY: 'TOTONGON',
    },
    {
        CITY: 'MUTIA',
        BARANGAY: 'TUBAC',
    },
    {
        CITY: 'MUTIA',
        BARANGAY: 'UNIDOS',
    },
    {
        CITY: 'PINAN',
        BARANGAY: 'ADANTE',
    },
    {
        CITY: 'PINAN',
        BARANGAY: 'BACUYONG',
    },
    {
        CITY: 'PINAN',
        BARANGAY: 'BAGONG SILANG',
    },
    {
        CITY: 'PINAN',
        BARANGAY: 'CALICAN',
    },
    {
        CITY: 'PINAN',
        BARANGAY: 'DEL PILAR',
    },
    {
        CITY: 'PINAN',
        BARANGAY: 'DESIN',
    },
    {
        CITY: 'PINAN',
        BARANGAY: 'DILAWA',
    },
    {
        CITY: 'PINAN',
        BARANGAY: 'DIONUM',
    },
    {
        CITY: 'PINAN',
        BARANGAY: 'LAPU-LAPU',
    },
    {
        CITY: 'PINAN',
        BARANGAY: 'LOWER GUMAY',
    },
    {
        CITY: 'PINAN',
        BARANGAY: 'LUZVILLA',
    },
    {
        CITY: 'PINAN',
        BARANGAY: 'POBLACION NORTH',
    },
    {
        CITY: 'PINAN',
        BARANGAY: 'POBLACION SOUTH',
    },
    {
        CITY: 'PINAN',
        BARANGAY: 'SANTA FE',
    },
    {
        CITY: 'PINAN',
        BARANGAY: 'SEGABE',
    },
    {
        CITY: 'PINAN',
        BARANGAY: 'SIKITAN',
    },
    {
        CITY: 'PINAN',
        BARANGAY: 'SILANO',
    },
    {
        CITY: 'PINAN',
        BARANGAY: 'TERESITA',
    },
    {
        CITY: 'PINAN',
        BARANGAY: 'TINAYTAYAN',
    },
    {
        CITY: 'PINAN',
        BARANGAY: 'UBAY (DAAN TIPAN)',
    },
    {
        CITY: 'PINAN',
        BARANGAY: 'UPPER GUMAY',
    },
    {
        CITY: 'PINAN',
        BARANGAY: 'VILLARICO',
    },
    {
        CITY: 'POLANCO',
        BARANGAY: 'ANASTACIO',
    },
    {
        CITY: 'POLANCO',
        BARANGAY: 'BANDERA',
    },
    {
        CITY: 'POLANCO',
        BARANGAY: 'BETHLEHEM',
    },
    {
        CITY: 'POLANCO',
        BARANGAY: 'DANGI',
    },
    {
        CITY: 'POLANCO',
        BARANGAY: 'DANSULLAN',
    },
    {
        CITY: 'POLANCO',
        BARANGAY: 'DE VENTA PERLA',
    },
    {
        CITY: 'POLANCO',
        BARANGAY: 'GUINLES',
    },
    {
        CITY: 'POLANCO',
        BARANGAY: 'ISIS',
    },
    {
        CITY: 'POLANCO',
        BARANGAY: 'LABRADOR (PRINDA)',
    },
    {
        CITY: 'POLANCO',
        BARANGAY: 'LAPAYANBAJA',
    },
    {
        CITY: 'POLANCO',
        BARANGAY: 'LETAPAN',
    },
    {
        CITY: 'POLANCO',
        BARANGAY: 'LINABO',
    },
    {
        CITY: 'POLANCO',
        BARANGAY: 'LINGASAD',
    },
    {
        CITY: 'POLANCO',
        BARANGAY: 'MACLEODES',
    },
    {
        CITY: 'POLANCO',
        BARANGAY: 'MAGANGON',
    },
    {
        CITY: 'POLANCO',
        BARANGAY: 'MALIGAYA',
    },
    {
        CITY: 'POLANCO',
        BARANGAY: 'MILAD',
    },
    {
        CITY: 'POLANCO',
        BARANGAY: 'NEW LEBANGON',
    },
    {
        CITY: 'POLANCO',
        BARANGAY: 'NEW SICAYAB',
    },
    {
        CITY: 'POLANCO',
        BARANGAY: 'OBAY',
    },
    {
        CITY: 'POLANCO',
        BARANGAY: 'PIAN',
    },
    {
        CITY: 'POLANCO',
        BARANGAY: 'POBLACION NORTH',
    },
    {
        CITY: 'POLANCO',
        BARANGAY: 'POBLACION SOUTH',
    },
    {
        CITY: 'POLANCO',
        BARANGAY: 'SAN ANTONIO (PAETAN)',
    },
    {
        CITY: 'POLANCO',
        BARANGAY: 'SAN MIGUEL (LOBOC)',
    },
    {
        CITY: 'POLANCO',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'POLANCO',
        BARANGAY: 'SANTO NINO (LANTOY)',
    },
    {
        CITY: 'POLANCO',
        BARANGAY: 'SIANIB',
    },
    {
        CITY: 'POLANCO',
        BARANGAY: 'SILAWE',
    },
    {
        CITY: 'POLANCO',
        BARANGAY: 'VILLAHERMOSA',
    },
    {
        CITY: 'PRES.-MANUEL-A.-ROXAS',
        BARANGAY: 'BALUBO',
    },
    {
        CITY: 'PRES.-MANUEL-A.-ROXAS',
        BARANGAY: 'BANBANAN',
    },
    {
        CITY: 'PRES.-MANUEL-A.-ROXAS',
        BARANGAY: 'CANIBONGAN',
    },
    {
        CITY: 'PRES.-MANUEL-A.-ROXAS',
        BARANGAY: 'CAPASE',
    },
    {
        CITY: 'PRES.-MANUEL-A.-ROXAS',
        BARANGAY: 'CAPE',
    },
    {
        CITY: 'PRES.-MANUEL-A.-ROXAS',
        BARANGAY: 'DENOMAN',
    },
    {
        CITY: 'PRES.-MANUEL-A.-ROXAS',
        BARANGAY: 'DOHINOB',
    },
    {
        CITY: 'PRES.-MANUEL-A.-ROXAS',
        BARANGAY: 'GALOKSO',
    },
    {
        CITY: 'PRES.-MANUEL-A.-ROXAS',
        BARANGAY: 'GUBAT',
    },
    {
        CITY: 'PRES.-MANUEL-A.-ROXAS',
        BARANGAY: 'IRASAN',
    },
    {
        CITY: 'PRES.-MANUEL-A.-ROXAS',
        BARANGAY: 'LABAKID',
    },
    {
        CITY: 'PRES.-MANUEL-A.-ROXAS',
        BARANGAY: 'LANGATIAN',
    },
    {
        CITY: 'PRES.-MANUEL-A.-ROXAS',
        BARANGAY: 'LIPAKAN',
    },
    {
        CITY: 'PRES.-MANUEL-A.-ROXAS',
        BARANGAY: 'MARUPAY',
    },
    {
        CITY: 'PRES.-MANUEL-A.-ROXAS',
        BARANGAY: 'MOLITON',
    },
    {
        CITY: 'PRES.-MANUEL-A.-ROXAS',
        BARANGAY: 'NABILID',
    },
    {
        CITY: 'PRES.-MANUEL-A.-ROXAS',
        BARANGAY: 'PANAMPALAY',
    },
    {
        CITY: 'PRES.-MANUEL-A.-ROXAS',
        BARANGAY: 'PANGOLOGON',
    },
    {
        CITY: 'PRES.-MANUEL-A.-ROXAS',
        BARANGAY: 'PIAO',
    },
    {
        CITY: 'PRES.-MANUEL-A.-ROXAS',
        BARANGAY: 'PINALAN',
    },
    {
        CITY: 'PRES.-MANUEL-A.-ROXAS',
        BARANGAY: 'PINAMAR',
    },
    {
        CITY: 'PRES.-MANUEL-A.-ROXAS',
        BARANGAY: 'PONGOLAN',
    },
    {
        CITY: 'PRES.-MANUEL-A.-ROXAS',
        BARANGAY: 'SALISIG',
    },
    {
        CITY: 'PRES.-MANUEL-A.-ROXAS',
        BARANGAY: 'SEBOD',
    },
    {
        CITY: 'PRES.-MANUEL-A.-ROXAS',
        BARANGAY: 'SIBATOG',
    },
    {
        CITY: 'PRES.-MANUEL-A.-ROXAS',
        BARANGAY: 'SITUBO',
    },
    {
        CITY: 'PRES.-MANUEL-A.-ROXAS',
        BARANGAY: 'TANAYAN',
    },
    {
        CITY: 'PRES.-MANUEL-A.-ROXAS',
        BARANGAY: 'TANTINGON',
    },
    {
        CITY: 'PRES.-MANUEL-A.-ROXAS',
        BARANGAY: 'UPPER IRASAN',
    },
    {
        CITY: 'PRES.-MANUEL-A.-ROXAS',
        BARANGAY: 'UPPER MINANG',
    },
    {
        CITY: 'PRES.-MANUEL-A.-ROXAS',
        BARANGAY: 'VILLAHERMOSO',
    },
    {
        CITY: 'SALUG',
        BARANGAY: 'BACONG',
    },
    {
        CITY: 'SALUG',
        BARANGAY: 'BALAKAN',
    },
    {
        CITY: 'SALUG',
        BARANGAY: 'BINONI',
    },
    {
        CITY: 'SALUG',
        BARANGAY: 'CALUCAP',
    },
    {
        CITY: 'SALUG',
        BARANGAY: 'CANAWAN',
    },
    {
        CITY: 'SALUG',
        BARANGAY: 'CARACOL',
    },
    {
        CITY: 'SALUG',
        BARANGAY: 'DANAO',
    },
    {
        CITY: 'SALUG',
        BARANGAY: 'DINOAN',
    },
    {
        CITY: 'SALUG',
        BARANGAY: 'DIPOLOD',
    },
    {
        CITY: 'SALUG',
        BARANGAY: 'FATIMA (POGAN)',
    },
    {
        CITY: 'SALUG',
        BARANGAY: 'IPILAN',
    },
    {
        CITY: 'SALUG',
        BARANGAY: 'LANAWAN',
    },
    {
        CITY: 'SALUG',
        BARANGAY: 'LIGUAC',
    },
    {
        CITY: 'SALUG',
        BARANGAY: 'LIPAKAN',
    },
    {
        CITY: 'SALUG',
        BARANGAY: 'MUCAS',
    },
    {
        CITY: 'SALUG',
        BARANGAY: 'PACUHAN',
    },
    {
        CITY: 'SALUG',
        BARANGAY: 'POBLACION (SALUG)',
    },
    {
        CITY: 'SALUG',
        BARANGAY: 'POBLACION EAST',
    },
    {
        CITY: 'SALUG',
        BARANGAY: 'PUKAY',
    },
    {
        CITY: 'SALUG',
        BARANGAY: 'RAMON MAGSAYSAY',
    },
    {
        CITY: 'SALUG',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'SALUG',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'SALUG',
        BARANGAY: 'TAMBALANG',
    },
    {
        CITY: 'SALUG',
        BARANGAY: 'TAPALAN',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'ANTONINO',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'BAGONG BAGUIO',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'BAGUMBAYAN',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'BIAYON',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'DAMPALAN',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'DANAO',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'DON ELENO',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'KAUSWAGAN',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'LABIRAY',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'LIWANAG',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'MABUHAY',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'MACALIBRE',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'MAHAYAHAY',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'MARAPONG',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'NAZARETH',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'NEBO',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'NEW RIZAL',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'NEW TANGUB',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'NUEVAVISTA',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'PEDAGAN',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'PENACIO',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'POBLACION ALTO',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'POBLACION BAJO',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'PRINCESA FRESHIA',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'PRINCESA LAMAYA',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'SINAAD',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'SINAI',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'SITUBO',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'TINAGO',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'TININDUGAN',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'TUBURAN',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'VENUS',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'WILBEN',
    },
    {
        CITY: 'SIAYAN',
        BARANGAY: 'BALOK',
    },
    {
        CITY: 'SIAYAN',
        BARANGAY: 'BALUNOKAN',
    },
    {
        CITY: 'SIAYAN',
        BARANGAY: 'DATAGAN',
    },
    {
        CITY: 'SIAYAN',
        BARANGAY: 'DENOYAN',
    },
    {
        CITY: 'SIAYAN',
        BARANGAY: 'DIONGAN',
    },
    {
        CITY: 'SIAYAN',
        BARANGAY: 'DOMOGOK',
    },
    {
        CITY: 'SIAYAN',
        BARANGAY: 'DUMPILAS',
    },
    {
        CITY: 'SIAYAN',
        BARANGAY: 'GONAYEN',
    },
    {
        CITY: 'SIAYAN',
        BARANGAY: 'GUIBO',
    },
    {
        CITY: 'SIAYAN',
        BARANGAY: 'GUNYAN',
    },
    {
        CITY: 'SIAYAN',
        BARANGAY: 'LITOLET',
    },
    {
        CITY: 'SIAYAN',
        BARANGAY: 'MACASING',
    },
    {
        CITY: 'SIAYAN',
        BARANGAY: 'MANGILAY',
    },
    {
        CITY: 'SIAYAN',
        BARANGAY: 'MOYO',
    },
    {
        CITY: 'SIAYAN',
        BARANGAY: 'MUNOZ',
    },
    {
        CITY: 'SIAYAN',
        BARANGAY: 'PANGE',
    },
    {
        CITY: 'SIAYAN',
        BARANGAY: 'PARANGLUMBA (POB.)',
    },
    {
        CITY: 'SIAYAN',
        BARANGAY: 'POLAYO',
    },
    {
        CITY: 'SIAYAN',
        BARANGAY: 'SAYAW',
    },
    {
        CITY: 'SIAYAN',
        BARANGAY: 'SERIAC',
    },
    {
        CITY: 'SIAYAN',
        BARANGAY: 'SIAYAN PROPER (POB.)',
    },
    {
        CITY: 'SIAYAN',
        BARANGAY: 'SUGUILON',
    },
    {
        CITY: 'SIBUCO',
        BARANGAY: 'ANONGAN',
    },
    {
        CITY: 'SIBUCO',
        BARANGAY: 'BASAK',
    },
    {
        CITY: 'SIBUCO',
        BARANGAY: 'BONGALAO',
    },
    {
        CITY: 'SIBUCO',
        BARANGAY: 'CABBUNAN',
    },
    {
        CITY: 'SIBUCO',
        BARANGAY: 'CAWIT-CAWIT',
    },
    {
        CITY: 'SIBUCO',
        BARANGAY: 'CULAGUAN',
    },
    {
        CITY: 'SIBUCO',
        BARANGAY: 'CUSIPAN',
    },
    {
        CITY: 'SIBUCO',
        BARANGAY: 'DINULAN',
    },
    {
        CITY: 'SIBUCO',
        BARANGAY: 'JATIAN',
    },
    {
        CITY: 'SIBUCO',
        BARANGAY: 'KAMARANGAN',
    },
    {
        CITY: 'SIBUCO',
        BARANGAY: 'LAKIKI',
    },
    {
        CITY: 'SIBUCO',
        BARANGAY: 'LAMBAGOAN',
    },
    {
        CITY: 'SIBUCO',
        BARANGAY: 'LIMPAPA',
    },
    {
        CITY: 'SIBUCO',
        BARANGAY: 'LINGAYON',
    },
    {
        CITY: 'SIBUCO',
        BARANGAY: 'LINTANGAN',
    },
    {
        CITY: 'SIBUCO',
        BARANGAY: 'LITAWAN',
    },
    {
        CITY: 'SIBUCO',
        BARANGAY: 'LUNDAY',
    },
    {
        CITY: 'SIBUCO',
        BARANGAY: 'MALAYAL',
    },
    {
        CITY: 'SIBUCO',
        BARANGAY: 'MANTIVO',
    },
    {
        CITY: 'SIBUCO',
        BARANGAY: 'NALA (POB.)',
    },
    {
        CITY: 'SIBUCO',
        BARANGAY: 'PANGANURAN',
    },
    {
        CITY: 'SIBUCO',
        BARANGAY: 'PANGIAN',
    },
    {
        CITY: 'SIBUCO',
        BARANGAY: 'PANIRAN',
    },
    {
        CITY: 'SIBUCO',
        BARANGAY: 'PASILNAHUT',
    },
    {
        CITY: 'SIBUCO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SIBUCO',
        BARANGAY: 'PULIRAN',
    },
    {
        CITY: 'SIBUCO',
        BARANGAY: 'SANTO NINO (CULABOG)',
    },
    {
        CITY: 'SIBUCO',
        BARANGAY: 'TANGARAK',
    },
    {
        CITY: 'SIBUTAD',
        BARANGAY: 'BAGACAY',
    },
    {
        CITY: 'SIBUTAD',
        BARANGAY: 'CALILIC',
    },
    {
        CITY: 'SIBUTAD',
        BARANGAY: 'CALUBE',
    },
    {
        CITY: 'SIBUTAD',
        BARANGAY: 'DELAPA',
    },
    {
        CITY: 'SIBUTAD',
        BARANGAY: 'KANIM',
    },
    {
        CITY: 'SIBUTAD',
        BARANGAY: 'LIBAY',
    },
    {
        CITY: 'SIBUTAD',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'SIBUTAD',
        BARANGAY: 'MARAPONG',
    },
    {
        CITY: 'SIBUTAD',
        BARANGAY: 'MINLASAG',
    },
    {
        CITY: 'SIBUTAD',
        BARANGAY: 'OYAN',
    },
    {
        CITY: 'SIBUTAD',
        BARANGAY: 'PANGANURAN',
    },
    {
        CITY: 'SIBUTAD',
        BARANGAY: 'POBLACION (SIBUTAD)',
    },
    {
        CITY: 'SIBUTAD',
        BARANGAY: 'SAWANG',
    },
    {
        CITY: 'SIBUTAD',
        BARANGAY: 'SIBULOC',
    },
    {
        CITY: 'SIBUTAD',
        BARANGAY: 'SINIPAY',
    },
    {
        CITY: 'SIBUTAD',
        BARANGAY: 'SIPALOC',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'BAGO',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'BALOK',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'BANTAYAN',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'BATO',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'BENIGNO AQUINO JR.',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'BINUANGAN',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'BITOON',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'BUCANA',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'CALATUNAN',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'CALUAN',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'CALUBIAN',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'DAGOHOY',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'DAPAON',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'DATAGAN',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'DATU TANGKILAN',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'DICOYONG',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'DISUD',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'DON RICARDO MACIAS (DINOBOT)',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'DONA JOSEFA',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'DUMALOGDOG',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'FATIMA',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'GAMPIS',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'GOLEO',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'IMELDA',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'INUMAN',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'JOAQUIN MACIAS',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'LA CONCEPCION',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'LA ROCHE SAN MIGUEL',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'LABAKID',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'LAGAG',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'LAPERO',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'LAWIS',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'MANDIH',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'MARAS',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'MAWAL',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'MISOK',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'MOTIBOT',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'NATO',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'NIPAAN',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'PANGALALAN',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'PIAO',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'SANTO ROSARIO',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'SIARE',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'TALINGA',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'TIGBAO',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'TINAPLAN',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'TITIK',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'UPPER INUMAN',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'UPPER NIPAAN',
    },
    {
        CITY: 'SIOCON',
        BARANGAY: 'ANDRES MICUBO JR. (BALILI)',
    },
    {
        CITY: 'SIOCON',
        BARANGAY: 'BALAGUNAN',
    },
    {
        CITY: 'SIOCON',
        BARANGAY: 'BUCANA',
    },
    {
        CITY: 'SIOCON',
        BARANGAY: 'BULACAN',
    },
    {
        CITY: 'SIOCON',
        BARANGAY: 'CANDIZ',
    },
    {
        CITY: 'SIOCON',
        BARANGAY: 'DATU SAILILA',
    },
    {
        CITY: 'SIOCON',
        BARANGAY: 'DIONISIO RICONALLA',
    },
    {
        CITY: 'SIOCON',
        BARANGAY: 'JOSE P. BRILLANTES',
    },
    {
        CITY: 'SIOCON',
        BARANGAY: 'JOSE P. BRILLANTES SR. (OLD LITUBAN)',
    },
    {
        CITY: 'SIOCON',
        BARANGAY: 'LATABON',
    },
    {
        CITY: 'SIOCON',
        BARANGAY: 'MAKIANG',
    },
    {
        CITY: 'SIOCON',
        BARANGAY: 'MALAMBUHANGIN',
    },
    {
        CITY: 'SIOCON',
        BARANGAY: 'MALIPOT',
    },
    {
        CITY: 'SIOCON',
        BARANGAY: 'MANAOL',
    },
    {
        CITY: 'SIOCON',
        BARANGAY: 'MATEO FRANCISCO',
    },
    {
        CITY: 'SIOCON',
        BARANGAY: 'MATIAG',
    },
    {
        CITY: 'SIOCON',
        BARANGAY: 'NEW LITUBAN',
    },
    {
        CITY: 'SIOCON',
        BARANGAY: 'PANGIAN',
    },
    {
        CITY: 'SIOCON',
        BARANGAY: 'PISAWAK',
    },
    {
        CITY: 'SIOCON',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SIOCON',
        BARANGAY: 'S. CABRAL',
    },
    {
        CITY: 'SIOCON',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'SIOCON',
        BARANGAY: 'SIAY',
    },
    {
        CITY: 'SIOCON',
        BARANGAY: 'SUHAILE ARABI',
    },
    {
        CITY: 'SIOCON',
        BARANGAY: 'TABAYO',
    },
    {
        CITY: 'SIOCON',
        BARANGAY: 'TAGAYTAY',
    },
    {
        CITY: 'SIOCON',
        BARANGAY: 'TIBANGAO',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'BALATAKAN',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'BALONKAN',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'BALUBUAN',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'BITUGAN',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'BONGON',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'CATUYAN',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'CULASIAN',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'DANGANON',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'DONA CECILIA',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'GUBAN',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'LAGUNDI',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'LIBUCON',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'LUBOK',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'MACUYON',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'MINANGA',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'MOTONG',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'NAPULAN',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'PANABUTAN',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'PIACAN',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'PINA',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'PISA ITOM',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'PISA PUTI',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'PUGOS',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'PULA BATO',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'PULANG LUPA',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'SAINT MARY (POB.)',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'SAN NICOLAS (POB.)',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'SAN ROQUE (POB.)',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'SAN VICENTE (POB.)',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'SIPAKIT',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'SIPAWA',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'SIRAWAI PROPER (POB.)',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'TALABIGA',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'TAPANAYAN',
    },
    {
        CITY: 'TAMPILISAN',
        BARANGAY: 'BALACBAAN',
    },
    {
        CITY: 'TAMPILISAN',
        BARANGAY: 'BANBANAN',
    },
    {
        CITY: 'TAMPILISAN',
        BARANGAY: 'BARILI',
    },
    {
        CITY: 'TAMPILISAN',
        BARANGAY: 'CABONG',
    },
    {
        CITY: 'TAMPILISAN',
        BARANGAY: 'CAMUL',
    },
    {
        CITY: 'TAMPILISAN',
        BARANGAY: 'FARMINGTON',
    },
    {
        CITY: 'TAMPILISAN',
        BARANGAY: 'GALINGON',
    },
    {
        CITY: 'TAMPILISAN',
        BARANGAY: 'LAWAAN',
    },
    {
        CITY: 'TAMPILISAN',
        BARANGAY: 'LUMBAYAO',
    },
    {
        CITY: 'TAMPILISAN',
        BARANGAY: 'MALILA-T',
    },
    {
        CITY: 'TAMPILISAN',
        BARANGAY: 'MOLOS',
    },
    {
        CITY: 'TAMPILISAN',
        BARANGAY: 'NEW DAPITAN',
    },
    {
        CITY: 'TAMPILISAN',
        BARANGAY: 'POBLACION (TAMPILISAN)',
    },
    {
        CITY: 'TAMPILISAN',
        BARANGAY: 'SANDAYONG',
    },
    {
        CITY: 'TAMPILISAN',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'TAMPILISAN',
        BARANGAY: 'SITUBO',
    },
    {
        CITY: 'TAMPILISAN',
        BARANGAY: 'TILUBOG',
    },
    {
        CITY: 'TAMPILISAN',
        BARANGAY: 'TININGGAAN',
    },
    {
        CITY: 'TAMPILISAN',
        BARANGAY: 'TUBOD',
    },
    {
        CITY: 'TAMPILISAN',
        BARANGAY: 'ZNAC',
    },
    {
        CITY: 'ZAMBOANGA-DEL-NORTE-RIZAL',
        BARANGAY: 'BALUBOHAN',
    },
    {
        CITY: 'ZAMBOANGA-DEL-NORTE-RIZAL',
        BARANGAY: 'BIRAYAN',
    },
    {
        CITY: 'ZAMBOANGA-DEL-NORTE-RIZAL',
        BARANGAY: 'DAMASING',
    },
    {
        CITY: 'ZAMBOANGA-DEL-NORTE-RIZAL',
        BARANGAY: 'EAST POBLACION',
    },
    {
        CITY: 'ZAMBOANGA-DEL-NORTE-RIZAL',
        BARANGAY: 'LA ESPERANZA',
    },
    {
        CITY: 'ZAMBOANGA-DEL-NORTE-RIZAL',
        BARANGAY: 'MABUHAY',
    },
    {
        CITY: 'ZAMBOANGA-DEL-NORTE-RIZAL',
        BARANGAY: 'MABUNAO',
    },
    {
        CITY: 'ZAMBOANGA-DEL-NORTE-RIZAL',
        BARANGAY: 'MITIMOS',
    },
    {
        CITY: 'ZAMBOANGA-DEL-NORTE-RIZAL',
        BARANGAY: 'NANGCA',
    },
    {
        CITY: 'ZAMBOANGA-DEL-NORTE-RIZAL',
        BARANGAY: 'NANGCAAN',
    },
    {
        CITY: 'ZAMBOANGA-DEL-NORTE-RIZAL',
        BARANGAY: 'NAPILAN',
    },
    {
        CITY: 'ZAMBOANGA-DEL-NORTE-RIZAL',
        BARANGAY: 'NASIPANG',
    },
    {
        CITY: 'ZAMBOANGA-DEL-NORTE-RIZAL',
        BARANGAY: 'NEW DAPITAN',
    },
    {
        CITY: 'ZAMBOANGA-DEL-NORTE-RIZAL',
        BARANGAY: 'NILABO',
    },
    {
        CITY: 'ZAMBOANGA-DEL-NORTE-RIZAL',
        BARANGAY: 'NORTH MAPANG',
    },
    {
        CITY: 'ZAMBOANGA-DEL-NORTE-RIZAL',
        BARANGAY: 'RIZALINA',
    },
    {
        CITY: 'ZAMBOANGA-DEL-NORTE-RIZAL',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'ZAMBOANGA-DEL-NORTE-RIZAL',
        BARANGAY: 'SEBACA',
    },
    {
        CITY: 'ZAMBOANGA-DEL-NORTE-RIZAL',
        BARANGAY: 'SIPAON',
    },
    {
        CITY: 'ZAMBOANGA-DEL-NORTE-RIZAL',
        BARANGAY: 'SOUTH MAPANG',
    },
    {
        CITY: 'ZAMBOANGA-DEL-NORTE-RIZAL',
        BARANGAY: 'TOLON',
    },
    {
        CITY: 'ZAMBOANGA-DEL-NORTE-RIZAL',
        BARANGAY: 'WEST POBLACION',
    },
    {
        CITY: 'BACOLOD-KALAWI',
        BARANGAY: 'AMPAO',
    },
    {
        CITY: 'BACOLOD-KALAWI',
        BARANGAY: 'BAGOAINGUD',
    },
    {
        CITY: 'BACOLOD-KALAWI',
        BARANGAY: 'BALUT',
    },
    {
        CITY: 'BACOLOD-KALAWI',
        BARANGAY: 'BARUA',
    },
    {
        CITY: 'BACOLOD-KALAWI',
        BARANGAY: 'BUADIAWANI',
    },
    {
        CITY: 'BACOLOD-KALAWI',
        BARANGAY: 'BUBONG',
    },
    {
        CITY: 'BACOLOD-KALAWI',
        BARANGAY: 'DARAMOYOD',
    },
    {
        CITY: 'BACOLOD-KALAWI',
        BARANGAY: 'DILABAYAN',
    },
    {
        CITY: 'BACOLOD-KALAWI',
        BARANGAY: 'DIPATUAN',
    },
    {
        CITY: 'BACOLOD-KALAWI',
        BARANGAY: 'GANDAMATO',
    },
    {
        CITY: 'BACOLOD-KALAWI',
        BARANGAY: 'GURAIN',
    },
    {
        CITY: 'BACOLOD-KALAWI',
        BARANGAY: 'ILIAN',
    },
    {
        CITY: 'BACOLOD-KALAWI',
        BARANGAY: 'LAMA',
    },
    {
        CITY: 'BACOLOD-KALAWI',
        BARANGAY: 'LIAWAO',
    },
    {
        CITY: 'BACOLOD-KALAWI',
        BARANGAY: 'LUMBACA-INGUD',
    },
    {
        CITY: 'BACOLOD-KALAWI',
        BARANGAY: 'MADANDING',
    },
    {
        CITY: 'BACOLOD-KALAWI',
        BARANGAY: 'ORONG',
    },
    {
        CITY: 'BACOLOD-KALAWI',
        BARANGAY: 'PINDOLONAN',
    },
    {
        CITY: 'BACOLOD-KALAWI',
        BARANGAY: 'POBLACION I',
    },
    {
        CITY: 'BACOLOD-KALAWI',
        BARANGAY: 'POBLACION II',
    },
    {
        CITY: 'BACOLOD-KALAWI',
        BARANGAY: 'RAYA',
    },
    {
        CITY: 'BACOLOD-KALAWI',
        BARANGAY: 'ROROWAN',
    },
    {
        CITY: 'BACOLOD-KALAWI',
        BARANGAY: 'SUGOD',
    },
    {
        CITY: 'BACOLOD-KALAWI',
        BARANGAY: 'TAMBO',
    },
    {
        CITY: 'BACOLOD-KALAWI',
        BARANGAY: 'TUKA I',
    },
    {
        CITY: 'BACOLOD-KALAWI',
        BARANGAY: 'TUKA II',
    },
    {
        CITY: 'BALABAGAN',
        BARANGAY: 'BAGOAINGUD',
    },
    {
        CITY: 'BALABAGAN',
        BARANGAY: 'BANAGO',
    },
    {
        CITY: 'BALABAGAN',
        BARANGAY: 'BARORAO',
    },
    {
        CITY: 'BALABAGAN',
        BARANGAY: 'BATUAN',
    },
    {
        CITY: 'BALABAGAN',
        BARANGAY: 'BUDAS',
    },
    {
        CITY: 'BALABAGAN',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'BALABAGAN',
        BARANGAY: 'BUISAN (BENGABENG)',
    },
    {
        CITY: 'BALABAGAN',
        BARANGAY: 'CALILANGAN',
    },
    {
        CITY: 'BALABAGAN',
        BARANGAY: 'IGABAY',
    },
    {
        CITY: 'BALABAGAN',
        BARANGAY: 'ILIAN',
    },
    {
        CITY: 'BALABAGAN',
        BARANGAY: 'LALABUAN',
    },
    {
        CITY: 'BALABAGAN',
        BARANGAY: 'LORENZO',
    },
    {
        CITY: 'BALABAGAN',
        BARANGAY: 'LOWER ITIL',
    },
    {
        CITY: 'BALABAGAN',
        BARANGAY: 'LUMBAC',
    },
    {
        CITY: 'BALABAGAN',
        BARANGAY: 'MACAO',
    },
    {
        CITY: 'BALABAGAN',
        BARANGAY: 'MAGULALUNG OCCIDENTAL',
    },
    {
        CITY: 'BALABAGAN',
        BARANGAY: 'MAGULALUNG ORIENTAL',
    },
    {
        CITY: 'BALABAGAN',
        BARANGAY: 'MATAMPAY',
    },
    {
        CITY: 'BALABAGAN',
        BARANGAY: 'MATANOG',
    },
    {
        CITY: 'BALABAGAN',
        BARANGAY: 'MOLIMOC',
    },
    {
        CITY: 'BALABAGAN',
        BARANGAY: 'NARRA',
    },
    {
        CITY: 'BALABAGAN',
        BARANGAY: 'PINDOLONAN',
    },
    {
        CITY: 'BALABAGAN',
        BARANGAY: 'PLASAN',
    },
    {
        CITY: 'BALABAGAN',
        BARANGAY: 'POBLACION (BALABAGAN)',
    },
    {
        CITY: 'BALABAGAN',
        BARANGAY: 'PURAKAN',
    },
    {
        CITY: 'BALABAGAN',
        BARANGAY: 'TATAYA',
    },
    {
        CITY: 'BALABAGAN',
        BARANGAY: 'UPPER ITIL',
    },
    {
        CITY: 'BALINDONG',
        BARANGAY: 'ABAGA',
    },
    {
        CITY: 'BALINDONG',
        BARANGAY: 'BANTOGA WATO',
    },
    {
        CITY: 'BALINDONG',
        BARANGAY: 'BARIT',
    },
    {
        CITY: 'BALINDONG',
        BARANGAY: 'BOLINSONG',
    },
    {
        CITY: 'BALINDONG',
        BARANGAY: 'BORAKIS',
    },
    {
        CITY: 'BALINDONG',
        BARANGAY: 'BUALAN',
    },
    {
        CITY: 'BALINDONG',
        BARANGAY: 'BUBONG',
    },
    {
        CITY: 'BALINDONG',
        BARANGAY: 'BUBONG CADAPAAN',
    },
    {
        CITY: 'BALINDONG',
        BARANGAY: 'CADAPAAN',
    },
    {
        CITY: 'BALINDONG',
        BARANGAY: 'CADAYONAN',
    },
    {
        CITY: 'BALINDONG',
        BARANGAY: 'DADAYAG',
    },
    {
        CITY: 'BALINDONG',
        BARANGAY: 'DADO',
    },
    {
        CITY: 'BALINDONG',
        BARANGAY: 'DIBARUSAN',
    },
    {
        CITY: 'BALINDONG',
        BARANGAY: 'DILAUSAN',
    },
    {
        CITY: 'BALINDONG',
        BARANGAY: 'DIMARAO',
    },
    {
        CITY: 'BALINDONG',
        BARANGAY: 'INGUD',
    },
    {
        CITY: 'BALINDONG',
        BARANGAY: 'KALUNTAY',
    },
    {
        CITY: 'BALINDONG',
        BARANGAY: 'LALABUAN',
    },
    {
        CITY: 'BALINDONG',
        BARANGAY: 'LATI',
    },
    {
        CITY: 'BALINDONG',
        BARANGAY: 'LILOD',
    },
    {
        CITY: 'BALINDONG',
        BARANGAY: 'LIMBO',
    },
    {
        CITY: 'BALINDONG',
        BARANGAY: 'LUMBAC LALAN',
    },
    {
        CITY: 'BALINDONG',
        BARANGAY: 'LUMBAC WATO',
    },
    {
        CITY: 'BALINDONG',
        BARANGAY: 'LUMBAYAO',
    },
    {
        CITY: 'BALINDONG',
        BARANGAY: 'MAGARANG',
    },
    {
        CITY: 'BALINDONG',
        BARANGAY: 'MALAIG',
    },
    {
        CITY: 'BALINDONG',
        BARANGAY: 'NUSA LUMBA RANAO',
    },
    {
        CITY: 'BALINDONG',
        BARANGAY: 'PADILA',
    },
    {
        CITY: 'BALINDONG',
        BARANGAY: 'PAGAYAWAN',
    },
    {
        CITY: 'BALINDONG',
        BARANGAY: 'PAIGOAY',
    },
    {
        CITY: 'BALINDONG',
        BARANGAY: 'PANTARAGOO',
    },
    {
        CITY: 'BALINDONG',
        BARANGAY: 'POBLACION (BALINDONG)',
    },
    {
        CITY: 'BALINDONG',
        BARANGAY: 'RAYA',
    },
    {
        CITY: 'BALINDONG',
        BARANGAY: 'SALIPONGAN',
    },
    {
        CITY: 'BALINDONG',
        BARANGAY: 'TALUB',
    },
    {
        CITY: 'BALINDONG',
        BARANGAY: 'TANTUA RAYA',
    },
    {
        CITY: 'BALINDONG',
        BARANGAY: 'TOMAROMPONG',
    },
    {
        CITY: 'BALINDONG',
        BARANGAY: 'TUKA BUBONG',
    },
    {
        CITY: 'BAYANG',
        BARANGAY: 'BAGOAINGUD',
    },
    {
        CITY: 'BAYANG',
        BARANGAY: 'BAIRAN (POB.)',
    },
    {
        CITY: 'BAYANG',
        BARANGAY: 'BANDINGUN',
    },
    {
        CITY: 'BAYANG',
        BARANGAY: 'BIABI',
    },
    {
        CITY: 'BAYANG',
        BARANGAY: 'BIALAAN',
    },
    {
        CITY: 'BAYANG',
        BARANGAY: 'BUBONG LILOD',
    },
    {
        CITY: 'BAYANG',
        BARANGAY: 'BUBONG RAYA',
    },
    {
        CITY: 'BAYANG',
        BARANGAY: 'CADAYONAN',
    },
    {
        CITY: 'BAYANG',
        BARANGAY: 'CADINGILAN OCCIDENTAL',
    },
    {
        CITY: 'BAYANG',
        BARANGAY: 'CADINGILAN ORIENTAL',
    },
    {
        CITY: 'BAYANG',
        BARANGAY: 'CONDARAAN POB. (CONDARAAN DIMADAP)',
    },
    {
        CITY: 'BAYANG',
        BARANGAY: 'CORMATAN',
    },
    {
        CITY: 'BAYANG',
        BARANGAY: 'GANDAMATO',
    },
    {
        CITY: 'BAYANG',
        BARANGAY: 'ILIAN',
    },
    {
        CITY: 'BAYANG',
        BARANGAY: 'LALAPUNG CENTRAL',
    },
    {
        CITY: 'BAYANG',
        BARANGAY: 'LALAPUNG PROPER (POB.)',
    },
    {
        CITY: 'BAYANG',
        BARANGAY: 'LALAPUNG UPPER',
    },
    {
        CITY: 'BAYANG',
        BARANGAY: 'LINAO',
    },
    {
        CITY: 'BAYANG',
        BARANGAY: 'LINUK (POB.)',
    },
    {
        CITY: 'BAYANG',
        BARANGAY: 'LIONG',
    },
    {
        CITY: 'BAYANG',
        BARANGAY: 'LUMBAC',
    },
    {
        CITY: 'BAYANG',
        BARANGAY: 'LUMBAC CADAYONAN',
    },
    {
        CITY: 'BAYANG',
        BARANGAY: 'MALIWANAG',
    },
    {
        CITY: 'BAYANG',
        BARANGAY: 'MAPANTAO',
    },
    {
        CITY: 'BAYANG',
        BARANGAY: 'MIMBALAWAG',
    },
    {
        CITY: 'BAYANG',
        BARANGAY: 'PALAO',
    },
    {
        CITY: 'BAYANG',
        BARANGAY: 'PAMA-AN',
    },
    {
        CITY: 'BAYANG',
        BARANGAY: 'PAMACOTAN',
    },
    {
        CITY: 'BAYANG',
        BARANGAY: 'PANTAR',
    },
    {
        CITY: 'BAYANG',
        BARANGAY: 'PARAO',
    },
    {
        CITY: 'BAYANG',
        BARANGAY: 'PATONG',
    },
    {
        CITY: 'BAYANG',
        BARANGAY: 'POBLACION (BAYANG)',
    },
    {
        CITY: 'BAYANG',
        BARANGAY: 'POROTAN',
    },
    {
        CITY: 'BAYANG',
        BARANGAY: 'RANTIAN',
    },
    {
        CITY: 'BAYANG',
        BARANGAY: 'RAYA CADAYONAN',
    },
    {
        CITY: 'BAYANG',
        BARANGAY: 'RINABOR (POB.)',
    },
    {
        CITY: 'BAYANG',
        BARANGAY: 'SAMPORNA (POB.)',
    },
    {
        CITY: 'BAYANG',
        BARANGAY: 'SAPA',
    },
    {
        CITY: 'BAYANG',
        BARANGAY: 'SILID',
    },
    {
        CITY: 'BAYANG',
        BARANGAY: 'SUGOD',
    },
    {
        CITY: 'BAYANG',
        BARANGAY: 'SULTAN PANDAPATAN',
    },
    {
        CITY: 'BAYANG',
        BARANGAY: 'SUMBAG (POB.)',
    },
    {
        CITY: 'BAYANG',
        BARANGAY: 'TAGORANAO',
    },
    {
        CITY: 'BAYANG',
        BARANGAY: 'TANGCAL',
    },
    {
        CITY: 'BAYANG',
        BARANGAY: 'TANGCAL PROPER (POB.)',
    },
    {
        CITY: 'BAYANG',
        BARANGAY: 'TOMAROMPONG',
    },
    {
        CITY: 'BAYANG',
        BARANGAY: 'TOMONGCAL LIGI',
    },
    {
        CITY: 'BAYANG',
        BARANGAY: 'TOROGAN',
    },
    {
        CITY: 'BAYANG',
        BARANGAY: 'TUCA (POB.)',
    },
    {
        CITY: 'BINIDAYAN',
        BARANGAY: 'BADAK',
    },
    {
        CITY: 'BINIDAYAN',
        BARANGAY: 'BAGUIANGUN',
    },
    {
        CITY: 'BINIDAYAN',
        BARANGAY: 'BALUT MAITO',
    },
    {
        CITY: 'BINIDAYAN',
        BARANGAY: 'BASAK',
    },
    {
        CITY: 'BINIDAYAN',
        BARANGAY: 'BUBONG',
    },
    {
        CITY: 'BINIDAYAN',
        BARANGAY: 'BUBONGA-RANAO',
    },
    {
        CITY: 'BINIDAYAN',
        BARANGAY: 'DANSALAN DACSULA',
    },
    {
        CITY: 'BINIDAYAN',
        BARANGAY: 'INGUD',
    },
    {
        CITY: 'BINIDAYAN',
        BARANGAY: 'KIALILIDAN',
    },
    {
        CITY: 'BINIDAYAN',
        BARANGAY: 'LUMBAC',
    },
    {
        CITY: 'BINIDAYAN',
        BARANGAY: 'MACAGUILING',
    },
    {
        CITY: 'BINIDAYAN',
        BARANGAY: 'MADAYA',
    },
    {
        CITY: 'BINIDAYAN',
        BARANGAY: 'MAGONAYA',
    },
    {
        CITY: 'BINIDAYAN',
        BARANGAY: 'MAINDIG',
    },
    {
        CITY: 'BINIDAYAN',
        BARANGAY: 'MASOLUN',
    },
    {
        CITY: 'BINIDAYAN',
        BARANGAY: 'OLAMA',
    },
    {
        CITY: 'BINIDAYAN',
        BARANGAY: 'PAGALAMATAN (POB.)',
    },
    {
        CITY: 'BINIDAYAN',
        BARANGAY: 'PANTAR',
    },
    {
        CITY: 'BINIDAYAN',
        BARANGAY: 'PICALILANGAN',
    },
    {
        CITY: 'BINIDAYAN',
        BARANGAY: 'PICOTAAN',
    },
    {
        CITY: 'BINIDAYAN',
        BARANGAY: 'PINDOLONAN',
    },
    {
        CITY: 'BINIDAYAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BINIDAYAN',
        BARANGAY: 'SOLDARORO',
    },
    {
        CITY: 'BINIDAYAN',
        BARANGAY: 'TAMBAC',
    },
    {
        CITY: 'BINIDAYAN',
        BARANGAY: 'TIMBANGAN',
    },
    {
        CITY: 'BINIDAYAN',
        BARANGAY: 'TUCA',
    },
    {
        CITY: 'BUADIPOSO-BUNTONG',
        BARANGAY: 'BACOLOD',
    },
    {
        CITY: 'BUADIPOSO-BUNTONG',
        BARANGAY: 'BACOLOD',
    },
    {
        CITY: 'BUADIPOSO-BUNTONG',
        BARANGAY: 'BANGON',
    },
    {
        CITY: 'BUADIPOSO-BUNTONG',
        BARANGAY: 'BANGON PROPER',
    },
    {
        CITY: 'BUADIPOSO-BUNTONG',
        BARANGAY: 'BOTO RAGONDINGAN',
    },
    {
        CITY: 'BUADIPOSO-BUNTONG',
        BARANGAY: 'BUADIPOSO LILOD',
    },
    {
        CITY: 'BUADIPOSO-BUNTONG',
        BARANGAY: 'BUADIPOSO PROPER',
    },
    {
        CITY: 'BUADIPOSO-BUNTONG',
        BARANGAY: 'BUADIPOSO RAYA',
    },
    {
        CITY: 'BUADIPOSO-BUNTONG',
        BARANGAY: 'BUBONG',
    },
    {
        CITY: 'BUADIPOSO-BUNTONG',
        BARANGAY: 'BUNTONG PROPER',
    },
    {
        CITY: 'BUADIPOSO-BUNTONG',
        BARANGAY: 'CADAYONAN',
    },
    {
        CITY: 'BUADIPOSO-BUNTONG',
        BARANGAY: 'DANSALAN',
    },
    {
        CITY: 'BUADIPOSO-BUNTONG',
        BARANGAY: 'DATU TAMBARA',
    },
    {
        CITY: 'BUADIPOSO-BUNTONG',
        BARANGAY: 'DIRISAN',
    },
    {
        CITY: 'BUADIPOSO-BUNTONG',
        BARANGAY: 'GATA',
    },
    {
        CITY: 'BUADIPOSO-BUNTONG',
        BARANGAY: 'KALAKALA',
    },
    {
        CITY: 'BUADIPOSO-BUNTONG',
        BARANGAY: 'KATOGONAN',
    },
    {
        CITY: 'BUADIPOSO-BUNTONG',
        BARANGAY: 'LUMBAC',
    },
    {
        CITY: 'BUADIPOSO-BUNTONG',
        BARANGAY: 'LUMBATAN MANACAB',
    },
    {
        CITY: 'BUADIPOSO-BUNTONG',
        BARANGAY: 'LUMBATAN PATAINGUD',
    },
    {
        CITY: 'BUADIPOSO-BUNTONG',
        BARANGAY: 'LUNDUBAN (RAGONDINGAN)',
    },
    {
        CITY: 'BUADIPOSO-BUNTONG',
        BARANGAY: 'MANACAB (POB.)',
    },
    {
        CITY: 'BUADIPOSO-BUNTONG',
        BARANGAY: 'MINANGA (BUNTONG)',
    },
    {
        CITY: 'BUADIPOSO-BUNTONG',
        BARANGAY: 'PALING',
    },
    {
        CITY: 'BUADIPOSO-BUNTONG',
        BARANGAY: 'PINDOLONAN',
    },
    {
        CITY: 'BUADIPOSO-BUNTONG',
        BARANGAY: 'PUALAS',
    },
    {
        CITY: 'BUADIPOSO-BUNTONG',
        BARANGAY: 'RAGONDINGAN EAST',
    },
    {
        CITY: 'BUADIPOSO-BUNTONG',
        BARANGAY: 'RAGONDINGAN PROPER',
    },
    {
        CITY: 'BUADIPOSO-BUNTONG',
        BARANGAY: 'RAGONDINGAN WEST',
    },
    {
        CITY: 'BUADIPOSO-BUNTONG',
        BARANGAY: 'RAYA BUNTONG (BUNTONG EAST)',
    },
    {
        CITY: 'BUADIPOSO-BUNTONG',
        BARANGAY: 'SAPOT',
    },
    {
        CITY: 'BUADIPOSO-BUNTONG',
        BARANGAY: 'TANGCAL',
    },
    {
        CITY: 'BUADIPOSO-BUNTONG',
        BARANGAY: 'TARIK',
    },
    {
        CITY: 'BUADIPOSO-BUNTONG',
        BARANGAY: 'TUKA',
    },
    {
        CITY: 'BUBONG',
        BARANGAY: 'BACOLOD',
    },
    {
        CITY: 'BUBONG',
        BARANGAY: 'BAGOAINGUD',
    },
    {
        CITY: 'BUBONG',
        BARANGAY: 'BANSAYAN',
    },
    {
        CITY: 'BUBONG',
        BARANGAY: 'BASINGAN',
    },
    {
        CITY: 'BUBONG',
        BARANGAY: 'BATANGAN',
    },
    {
        CITY: 'BUBONG',
        BARANGAY: 'BUALAN',
    },
    {
        CITY: 'BUBONG',
        BARANGAY: 'BUBONGA DIDAGUN',
    },
    {
        CITY: 'BUBONG',
        BARANGAY: 'CARIGONGAN',
    },
    {
        CITY: 'BUBONG',
        BARANGAY: 'DALAON',
    },
    {
        CITY: 'BUBONG',
        BARANGAY: 'DIBAROSAN',
    },
    {
        CITY: 'BUBONG',
        BARANGAY: 'DILABAYAN',
    },
    {
        CITY: 'BUBONG',
        BARANGAY: 'DIMAPATOY',
    },
    {
        CITY: 'BUBONG',
        BARANGAY: 'DIMAYON',
    },
    {
        CITY: 'BUBONG',
        BARANGAY: 'DIMAYON PROPER',
    },
    {
        CITY: 'BUBONG',
        BARANGAY: 'DIOLANGAN',
    },
    {
        CITY: 'BUBONG',
        BARANGAY: 'GUIGUIKUN',
    },
    {
        CITY: 'BUBONG',
        BARANGAY: 'MADANDING',
    },
    {
        CITY: 'BUBONG',
        BARANGAY: 'MALUNGUN',
    },
    {
        CITY: 'BUBONG',
        BARANGAY: 'MASOROT',
    },
    {
        CITY: 'BUBONG',
        BARANGAY: 'MATAMPAY DIMARAO',
    },
    {
        CITY: 'BUBONG',
        BARANGAY: 'MIABALAWAG',
    },
    {
        CITY: 'BUBONG',
        BARANGAY: 'MONTIAAN',
    },
    {
        CITY: 'BUBONG',
        BARANGAY: 'PAGAYAWAN',
    },
    {
        CITY: 'BUBONG',
        BARANGAY: 'PALAO',
    },
    {
        CITY: 'BUBONG',
        BARANGAY: 'PANALAWAN',
    },
    {
        CITY: 'BUBONG',
        BARANGAY: 'PANTAR',
    },
    {
        CITY: 'BUBONG',
        BARANGAY: 'PENDOGOAN',
    },
    {
        CITY: 'BUBONG',
        BARANGAY: 'PINDOLONAN',
    },
    {
        CITY: 'BUBONG',
        BARANGAY: 'POBLACION (BUBONG)',
    },
    {
        CITY: 'BUBONG',
        BARANGAY: 'POLAYAGAN',
    },
    {
        CITY: 'BUBONG',
        BARANGAY: 'PUNUD',
    },
    {
        CITY: 'BUBONG',
        BARANGAY: 'RAMAIN BUBONG',
    },
    {
        CITY: 'BUBONG',
        BARANGAY: 'ROGERO',
    },
    {
        CITY: 'BUBONG',
        BARANGAY: 'SALIPONGAN',
    },
    {
        CITY: 'BUBONG',
        BARANGAY: 'SUNGGOD',
    },
    {
        CITY: 'BUBONG',
        BARANGAY: 'TABORO',
    },
    {
        CITY: 'BUTIG',
        BARANGAY: 'BAYABAO POBLACION',
    },
    {
        CITY: 'BUTIG',
        BARANGAY: 'BAYABAO POBLACION',
    },
    {
        CITY: 'BUTIG',
        BARANGAY: 'BUTIG PROPER',
    },
    {
        CITY: 'BUTIG',
        BARANGAY: 'CABASARAN',
    },
    {
        CITY: 'BUTIG',
        BARANGAY: 'CABASARAN',
    },
    {
        CITY: 'BUTIG',
        BARANGAY: 'COLOYAN TAMBO',
    },
    {
        CITY: 'BUTIG',
        BARANGAY: 'DILIMBAYAN',
    },
    {
        CITY: 'BUTIG',
        BARANGAY: 'DILIMBAYAN',
    },
    {
        CITY: 'BUTIG',
        BARANGAY: 'DOLANGAN',
    },
    {
        CITY: 'BUTIG',
        BARANGAY: 'DOLANGAN',
    },
    {
        CITY: 'BUTIG',
        BARANGAY: 'MALUNGUN',
    },
    {
        CITY: 'BUTIG',
        BARANGAY: 'MALUNGUN',
    },
    {
        CITY: 'BUTIG',
        BARANGAY: 'PINDOLONAN',
    },
    {
        CITY: 'BUTIG',
        BARANGAY: 'POKTAN',
    },
    {
        CITY: 'BUTIG',
        BARANGAY: 'POKTAN',
    },
    {
        CITY: 'BUTIG',
        BARANGAY: 'RAGAYAN',
    },
    {
        CITY: 'BUTIG',
        BARANGAY: 'RAYA',
    },
    {
        CITY: 'BUTIG',
        BARANGAY: 'RAYA',
    },
    {
        CITY: 'BUTIG',
        BARANGAY: 'SAMER',
    },
    {
        CITY: 'BUTIG',
        BARANGAY: 'SAMER',
    },
    {
        CITY: 'BUTIG',
        BARANGAY: 'SANDAB MADAYA',
    },
    {
        CITY: 'BUTIG',
        BARANGAY: 'SANDAB MADAYA',
    },
    {
        CITY: 'BUTIG',
        BARANGAY: 'SUNDIG',
    },
    {
        CITY: 'BUTIG',
        BARANGAY: 'SUNDIG',
    },
    {
        CITY: 'BUTIG',
        BARANGAY: 'TIMBAB',
    },
    {
        CITY: 'BUTIG',
        BARANGAY: 'TIMBAB',
    },
    {
        CITY: 'BUTIG',
        BARANGAY: 'TIOWI',
    },
    {
        CITY: 'BUTIG',
        BARANGAY: 'TIOWI',
    },
    {
        CITY: 'CALANOGAS',
        BARANGAY: 'BUBONGA RANAO',
    },
    {
        CITY: 'CALANOGAS',
        BARANGAY: 'CALALAOAN (POB.)',
    },
    {
        CITY: 'CALANOGAS',
        BARANGAY: 'GAS',
    },
    {
        CITY: 'CALANOGAS',
        BARANGAY: 'INOMA',
    },
    {
        CITY: 'CALANOGAS',
        BARANGAY: 'INUDARAN',
    },
    {
        CITY: 'CALANOGAS',
        BARANGAY: 'LUGUNA',
    },
    {
        CITY: 'CALANOGAS',
        BARANGAY: 'MIMBALAWAG',
    },
    {
        CITY: 'CALANOGAS',
        BARANGAY: 'NGINGIR',
    },
    {
        CITY: 'CALANOGAS',
        BARANGAY: 'PAGALONGAN',
    },
    {
        CITY: 'CALANOGAS',
        BARANGAY: 'PANGGAWALUPA',
    },
    {
        CITY: 'CALANOGAS',
        BARANGAY: 'PANTAON',
    },
    {
        CITY: 'CALANOGAS',
        BARANGAY: 'PIKSAN',
    },
    {
        CITY: 'CALANOGAS',
        BARANGAY: 'PINDOLONAN',
    },
    {
        CITY: 'CALANOGAS',
        BARANGAY: 'PUNUD',
    },
    {
        CITY: 'CALANOGAS',
        BARANGAY: 'TAGORANAO',
    },
    {
        CITY: 'CALANOGAS',
        BARANGAY: 'TALIBOBOKA',
    },
    {
        CITY: 'CALANOGAS',
        BARANGAY: 'TAMBAC',
    },
    {
        CITY: 'DITSAAN-RAMAIN',
        BARANGAY: 'BACLAYAN LILOD',
    },
    {
        CITY: 'DITSAAN-RAMAIN',
        BARANGAY: 'BACLAYAN RAYA',
    },
    {
        CITY: 'DITSAAN-RAMAIN',
        BARANGAY: 'BAGOAINGUD',
    },
    {
        CITY: 'DITSAAN-RAMAIN',
        BARANGAY: 'BARIMBINGAN',
    },
    {
        CITY: 'DITSAAN-RAMAIN',
        BARANGAY: 'BAYABAO',
    },
    {
        CITY: 'DITSAAN-RAMAIN',
        BARANGAY: 'BUADI ALAO',
    },
    {
        CITY: 'DITSAAN-RAMAIN',
        BARANGAY: 'BUADI BABAI',
    },
    {
        CITY: 'DITSAAN-RAMAIN',
        BARANGAY: 'BUADI OLOC',
    },
    {
        CITY: 'DITSAAN-RAMAIN',
        BARANGAY: 'BUAYAAN LILOD',
    },
    {
        CITY: 'DITSAAN-RAMAIN',
        BARANGAY: 'BUAYAAN MADANDING',
    },
    {
        CITY: 'DITSAAN-RAMAIN',
        BARANGAY: 'BUAYAAN RAYA',
    },
    {
        CITY: 'DITSAAN-RAMAIN',
        BARANGAY: 'BUBONG DANGIPRAMPIAI',
    },
    {
        CITY: 'DITSAAN-RAMAIN',
        BARANGAY: 'DADO',
    },
    {
        CITY: 'DITSAAN-RAMAIN',
        BARANGAY: 'DANGIMPRAMPIAI',
    },
    {
        CITY: 'DITSAAN-RAMAIN',
        BARANGAY: 'DARIMBANG',
    },
    {
        CITY: 'DITSAAN-RAMAIN',
        BARANGAY: 'DILAUSAN',
    },
    {
        CITY: 'DITSAAN-RAMAIN',
        BARANGAY: 'DITSAAN',
    },
    {
        CITY: 'DITSAAN-RAMAIN',
        BARANGAY: 'GADONGAN',
    },
    {
        CITY: 'DITSAAN-RAMAIN',
        BARANGAY: 'LINAMON',
    },
    {
        CITY: 'DITSAAN-RAMAIN',
        BARANGAY: 'LUMBATAN RAMAIN',
    },
    {
        CITY: 'DITSAAN-RAMAIN',
        BARANGAY: 'MAINDIG DITSAAN',
    },
    {
        CITY: 'DITSAAN-RAMAIN',
        BARANGAY: 'MANDARA',
    },
    {
        CITY: 'DITSAAN-RAMAIN',
        BARANGAY: 'MARANAO TIMBER (DALAMA)',
    },
    {
        CITY: 'DITSAAN-RAMAIN',
        BARANGAY: 'PAGALONGAN BUADIADINGAN',
    },
    {
        CITY: 'DITSAAN-RAMAIN',
        BARANGAY: 'PAGALONGAN GINAOPAN',
    },
    {
        CITY: 'DITSAAN-RAMAIN',
        BARANGAY: 'PAGALONGAN MASIOON',
    },
    {
        CITY: 'DITSAAN-RAMAIN',
        BARANGAY: 'PAGALONGAN PROPER',
    },
    {
        CITY: 'DITSAAN-RAMAIN',
        BARANGAY: 'POLO',
    },
    {
        CITY: 'DITSAAN-RAMAIN',
        BARANGAY: 'RAMAIN POBLACION',
    },
    {
        CITY: 'DITSAAN-RAMAIN',
        BARANGAY: 'RAMAIN PROPER',
    },
    {
        CITY: 'DITSAAN-RAMAIN',
        BARANGAY: 'RANTIAN',
    },
    {
        CITY: 'DITSAAN-RAMAIN',
        BARANGAY: 'SULTAN PANGADAPUN',
    },
    {
        CITY: 'DITSAAN-RAMAIN',
        BARANGAY: 'SUNDIGA BAYABAO',
    },
    {
        CITY: 'DITSAAN-RAMAIN',
        BARANGAY: 'TALUB',
    },
    {
        CITY: 'DITSAAN-RAMAIN',
        BARANGAY: 'UPPER PUGAAN',
    },
    {
        CITY: 'GANASSI',
        BARANGAY: 'BAGOAINGUD',
    },
    {
        CITY: 'GANASSI',
        BARANGAY: 'BALINTAD',
    },
    {
        CITY: 'GANASSI',
        BARANGAY: 'BALINTAD A',
    },
    {
        CITY: 'GANASSI',
        BARANGAY: 'BARIT',
    },
    {
        CITY: 'GANASSI',
        BARANGAY: 'BARORAO',
    },
    {
        CITY: 'GANASSI',
        BARANGAY: 'BATO BATORAY',
    },
    {
        CITY: 'GANASSI',
        BARANGAY: 'BAYA',
    },
    {
        CITY: 'GANASSI',
        BARANGAY: 'CAMPONG A RAYA',
    },
    {
        CITY: 'GANASSI',
        BARANGAY: 'CAMPONG SABELA',
    },
    {
        CITY: 'GANASSI',
        BARANGAY: 'DAPAAN',
    },
    {
        CITY: 'GANASSI',
        BARANGAY: 'GADONGAN',
    },
    {
        CITY: 'GANASSI',
        BARANGAY: 'GUI',
    },
    {
        CITY: 'GANASSI',
        BARANGAY: 'LINUK',
    },
    {
        CITY: 'GANASSI',
        BARANGAY: 'LUMBAC',
    },
    {
        CITY: 'GANASSI',
        BARANGAY: 'LUMBACAINGUD',
    },
    {
        CITY: 'GANASSI',
        BARANGAY: 'MACABAO',
    },
    {
        CITY: 'GANASSI',
        BARANGAY: 'MACAGUILING',
    },
    {
        CITY: 'GANASSI',
        BARANGAY: 'MASOLUN',
    },
    {
        CITY: 'GANASSI',
        BARANGAY: 'PAGALONGAN',
    },
    {
        CITY: 'GANASSI',
        BARANGAY: 'PAMALIAN',
    },
    {
        CITY: 'GANASSI',
        BARANGAY: 'PANGADAPUN',
    },
    {
        CITY: 'GANASSI',
        BARANGAY: 'PANGGAWALUPA',
    },
    {
        CITY: 'GANASSI',
        BARANGAY: 'PANTAON',
    },
    {
        CITY: 'GANASSI',
        BARANGAY: 'PANTAON A',
    },
    {
        CITY: 'GANASSI',
        BARANGAY: 'PARA-ABA',
    },
    {
        CITY: 'GANASSI',
        BARANGAY: 'PINDOLONAN',
    },
    {
        CITY: 'GANASSI',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'GANASSI',
        BARANGAY: 'SEKUN MATAMPAY',
    },
    {
        CITY: 'GANASSI',
        BARANGAY: 'SOGOD MADAYA',
    },
    {
        CITY: 'GANASSI',
        BARANGAY: 'TABUAN',
    },
    {
        CITY: 'GANASSI',
        BARANGAY: 'TAGANONOK',
    },
    {
        CITY: 'GANASSI',
        BARANGAY: 'TALIOGON',
    },
    {
        CITY: 'KAPAI',
        BARANGAY: 'BABAYOG',
    },
    {
        CITY: 'KAPAI',
        BARANGAY: 'CORMATAN',
    },
    {
        CITY: 'KAPAI',
        BARANGAY: 'DILABAYAN',
    },
    {
        CITY: 'KAPAI',
        BARANGAY: 'DILIMBAYAN',
    },
    {
        CITY: 'KAPAI',
        BARANGAY: 'DIMAGALING (DIMAGALIN PROPER)',
    },
    {
        CITY: 'KAPAI',
        BARANGAY: 'DIMUNDA',
    },
    {
        CITY: 'KAPAI',
        BARANGAY: 'DORONAN',
    },
    {
        CITY: 'KAPAI',
        BARANGAY: 'GADONGAN',
    },
    {
        CITY: 'KAPAI',
        BARANGAY: 'KASAYANAN',
    },
    {
        CITY: 'KAPAI',
        BARANGAY: 'KASAYANAN WEST',
    },
    {
        CITY: 'KAPAI',
        BARANGAY: 'KIBOLOS',
    },
    {
        CITY: 'KAPAI',
        BARANGAY: 'KINING',
    },
    {
        CITY: 'KAPAI',
        BARANGAY: 'LIDASAN',
    },
    {
        CITY: 'KAPAI',
        BARANGAY: 'MACADAR',
    },
    {
        CITY: 'KAPAI',
        BARANGAY: 'MALNA PROPER',
    },
    {
        CITY: 'KAPAI',
        BARANGAY: 'PAGALONGAN',
    },
    {
        CITY: 'KAPAI',
        BARANGAY: 'PANTAON',
    },
    {
        CITY: 'KAPAI',
        BARANGAY: 'PARAO',
    },
    {
        CITY: 'KAPAI',
        BARANGAY: 'PINDOLONAN',
    },
    {
        CITY: 'KAPAI',
        BARANGAY: 'POBLACION (KAPAI PROPER)',
    },
    {
        CITY: 'KAPATAGAN',
        BARANGAY: 'BAKIKIS',
    },
    {
        CITY: 'KAPATAGAN',
        BARANGAY: 'BARAO',
    },
    {
        CITY: 'KAPATAGAN',
        BARANGAY: 'BONGABONG',
    },
    {
        CITY: 'KAPATAGAN',
        BARANGAY: 'DAGUAN',
    },
    {
        CITY: 'KAPATAGAN',
        BARANGAY: 'INUDARAN',
    },
    {
        CITY: 'KAPATAGAN',
        BARANGAY: 'KABANIAKAWAN',
    },
    {
        CITY: 'KAPATAGAN',
        BARANGAY: 'KAPATAGAN',
    },
    {
        CITY: 'KAPATAGAN',
        BARANGAY: 'LUSAIN',
    },
    {
        CITY: 'KAPATAGAN',
        BARANGAY: 'MATIMOS',
    },
    {
        CITY: 'KAPATAGAN',
        BARANGAY: 'MINIMAO',
    },
    {
        CITY: 'KAPATAGAN',
        BARANGAY: 'PINANTAO',
    },
    {
        CITY: 'KAPATAGAN',
        BARANGAY: 'SALAMAN',
    },
    {
        CITY: 'KAPATAGAN',
        BARANGAY: 'SIGAYAN',
    },
    {
        CITY: 'KAPATAGAN',
        BARANGAY: 'TABUAN',
    },
    {
        CITY: 'KAPATAGAN',
        BARANGAY: 'UPPER IGABAY',
    },
    {
        CITY: 'LUMBA-BAYABAO',
        BARANGAY: 'BACOLOD I',
    },
    {
        CITY: 'LUMBA-BAYABAO',
        BARANGAY: 'BACOLOD II',
    },
    {
        CITY: 'LUMBA-BAYABAO',
        BARANGAY: 'BANTAYAO',
    },
    {
        CITY: 'LUMBA-BAYABAO',
        BARANGAY: 'BARIT',
    },
    {
        CITY: 'LUMBA-BAYABAO',
        BARANGAY: 'BAUGAN',
    },
    {
        CITY: 'LUMBA-BAYABAO',
        BARANGAY: 'BUAD LUMBAC',
    },
    {
        CITY: 'LUMBA-BAYABAO',
        BARANGAY: 'CABASARAN',
    },
    {
        CITY: 'LUMBA-BAYABAO',
        BARANGAY: 'CALILANGAN',
    },
    {
        CITY: 'LUMBA-BAYABAO',
        BARANGAY: 'CARANDANGAN-MIPAGA',
    },
    {
        CITY: 'LUMBA-BAYABAO',
        BARANGAY: 'CORMATAN LANGBAN',
    },
    {
        CITY: 'LUMBA-BAYABAO',
        BARANGAY: 'DIALONGANA',
    },
    {
        CITY: 'LUMBA-BAYABAO',
        BARANGAY: 'DILINDONGAN-CADAYONAN',
    },
    {
        CITY: 'LUMBA-BAYABAO',
        BARANGAY: 'GADONGAN',
    },
    {
        CITY: 'LUMBA-BAYABAO',
        BARANGAY: 'GALAWAN',
    },
    {
        CITY: 'LUMBA-BAYABAO',
        BARANGAY: 'GAMBAI',
    },
    {
        CITY: 'LUMBA-BAYABAO',
        BARANGAY: 'KASOLA',
    },
    {
        CITY: 'LUMBA-BAYABAO',
        BARANGAY: 'LALANGITUN',
    },
    {
        CITY: 'LUMBA-BAYABAO',
        BARANGAY: 'LAMA',
    },
    {
        CITY: 'LUMBA-BAYABAO',
        BARANGAY: 'LINDONGAN DIALONGANA',
    },
    {
        CITY: 'LUMBA-BAYABAO',
        BARANGAY: 'LOBO BASARA',
    },
    {
        CITY: 'LUMBA-BAYABAO',
        BARANGAY: 'LUMBAC BACAYAWAN',
    },
    {
        CITY: 'LUMBA-BAYABAO',
        BARANGAY: 'MACAGUILING',
    },
    {
        CITY: 'LUMBA-BAYABAO',
        BARANGAY: 'MAPANTAO',
    },
    {
        CITY: 'LUMBA-BAYABAO',
        BARANGAY: 'MAPOLING',
    },
    {
        CITY: 'LUMBA-BAYABAO',
        BARANGAY: 'MARIBO (POB.)',
    },
    {
        CITY: 'LUMBA-BAYABAO',
        BARANGAY: 'MINARING DILADIGAN',
    },
    {
        CITY: 'LUMBA-BAYABAO',
        BARANGAY: 'PAGAYAWAN',
    },
    {
        CITY: 'LUMBA-BAYABAO',
        BARANGAY: 'POSUDARAGAT',
    },
    {
        CITY: 'LUMBA-BAYABAO',
        BARANGAY: 'RUMAYAS',
    },
    {
        CITY: 'LUMBA-BAYABAO',
        BARANGAY: 'SABALA BANTAYAO',
    },
    {
        CITY: 'LUMBA-BAYABAO',
        BARANGAY: 'SALAMAN',
    },
    {
        CITY: 'LUMBA-BAYABAO',
        BARANGAY: 'SALOLODUN BERWAR',
    },
    {
        CITY: 'LUMBA-BAYABAO',
        BARANGAY: 'SARIGIDAN MADIAR',
    },
    {
        CITY: 'LUMBA-BAYABAO',
        BARANGAY: 'SUNGGOD',
    },
    {
        CITY: 'LUMBA-BAYABAO',
        BARANGAY: 'TALUAN',
    },
    {
        CITY: 'LUMBA-BAYABAO',
        BARANGAY: 'TAMLANG',
    },
    {
        CITY: 'LUMBA-BAYABAO',
        BARANGAY: 'TONGCOPAN',
    },
    {
        CITY: 'LUMBA-BAYABAO',
        BARANGAY: 'TUROGAN',
    },
    {
        CITY: 'LUMBACA-UNAYAN',
        BARANGAY: 'BANGON (DILAUSAN)',
    },
    {
        CITY: 'LUMBACA-UNAYAN',
        BARANGAY: 'BETA',
    },
    {
        CITY: 'LUMBACA-UNAYAN',
        BARANGAY: 'CALALON',
    },
    {
        CITY: 'LUMBACA-UNAYAN',
        BARANGAY: 'CALIPAPA',
    },
    {
        CITY: 'LUMBACA-UNAYAN',
        BARANGAY: 'DILAUSAN',
    },
    {
        CITY: 'LUMBACA-UNAYAN',
        BARANGAY: 'DIMAPAOK',
    },
    {
        CITY: 'LUMBACA-UNAYAN',
        BARANGAY: 'LUMBAC DILAUSAN',
    },
    {
        CITY: 'LUMBACA-UNAYAN',
        BARANGAY: 'ORIENTAL BETA',
    },
    {
        CITY: 'LUMBACA-UNAYAN',
        BARANGAY: 'TRINGUN',
    },
    {
        CITY: 'LUMBATAN',
        BARANGAY: 'ALOG',
    },
    {
        CITY: 'LUMBATAN',
        BARANGAY: 'ALOG',
    },
    {
        CITY: 'LUMBATAN',
        BARANGAY: 'BASAYUNGUN',
    },
    {
        CITY: 'LUMBATAN',
        BARANGAY: 'BASAYUNGUN',
    },
    {
        CITY: 'LUMBATAN',
        BARANGAY: 'BUAD',
    },
    {
        CITY: 'LUMBATAN',
        BARANGAY: 'BUAD',
    },
    {
        CITY: 'LUMBATAN',
        BARANGAY: 'BUBONG MACADAR',
    },
    {
        CITY: 'LUMBATAN',
        BARANGAY: 'BUBONG MACADAR',
    },
    {
        CITY: 'LUMBATAN',
        BARANGAY: 'BUDI',
    },
    {
        CITY: 'LUMBATAN',
        BARANGAY: 'BUDI',
    },
    {
        CITY: 'LUMBATAN',
        BARANGAY: 'DAGO-OK',
    },
    {
        CITY: 'LUMBATAN',
        BARANGAY: 'DAGO-OK',
    },
    {
        CITY: 'LUMBATAN',
        BARANGAY: 'DALAMA',
    },
    {
        CITY: 'LUMBATAN',
        BARANGAY: 'DALAMA',
    },
    {
        CITY: 'LUMBATAN',
        BARANGAY: 'DALIPUGA',
    },
    {
        CITY: 'LUMBATAN',
        BARANGAY: 'DALIPUGA',
    },
    {
        CITY: 'LUMBATAN',
        BARANGAY: 'LALAPUNG',
    },
    {
        CITY: 'LUMBATAN',
        BARANGAY: 'LALAPUNG',
    },
    {
        CITY: 'LUMBATAN',
        BARANGAY: 'LIGUE',
    },
    {
        CITY: 'LUMBATAN',
        BARANGAY: 'LIGUE',
    },
    {
        CITY: 'LUMBATAN',
        BARANGAY: 'LUMBAC',
    },
    {
        CITY: 'LUMBATAN',
        BARANGAY: 'LUMBAC',
    },
    {
        CITY: 'LUMBATAN',
        BARANGAY: 'LUMBAC BACAYAWAN',
    },
    {
        CITY: 'LUMBATAN',
        BARANGAY: 'LUMBAC BACAYAWAN',
    },
    {
        CITY: 'LUMBATAN',
        BARANGAY: 'LUNAY',
    },
    {
        CITY: 'LUMBATAN',
        BARANGAY: 'LUNAY',
    },
    {
        CITY: 'LUMBATAN',
        BARANGAY: 'MACADAR',
    },
    {
        CITY: 'LUMBATAN',
        BARANGAY: 'MACADAR',
    },
    {
        CITY: 'LUMBATAN',
        BARANGAY: 'MADAYA',
    },
    {
        CITY: 'LUMBATAN',
        BARANGAY: 'MADAYA',
    },
    {
        CITY: 'LUMBATAN',
        BARANGAY: 'MINANGA',
    },
    {
        CITY: 'LUMBATAN',
        BARANGAY: 'MINANGA',
    },
    {
        CITY: 'LUMBATAN',
        BARANGAY: 'PANTAR',
    },
    {
        CITY: 'LUMBATAN',
        BARANGAY: 'PANTAR',
    },
    {
        CITY: 'LUMBATAN',
        BARANGAY: 'PENARING',
    },
    {
        CITY: 'LUMBATAN',
        BARANGAY: 'PENARING',
    },
    {
        CITY: 'LUMBATAN',
        BARANGAY: 'PICOTAAN',
    },
    {
        CITY: 'LUMBATAN',
        BARANGAY: 'PICOTAAN',
    },
    {
        CITY: 'LUMBATAN',
        BARANGAY: 'POBLACION (LUMBATAN)',
    },
    {
        CITY: 'LUMBATAN',
        BARANGAY: 'POBLACION (LUMBATAN)',
    },
    {
        CITY: 'LUMBATAN',
        BARANGAY: 'TAMBAC',
    },
    {
        CITY: 'LUMBATAN',
        BARANGAY: 'TAMBAC',
    },
    {
        CITY: 'LUMBAYANAGUE',
        BARANGAY: 'BAGOAINGUD',
    },
    {
        CITY: 'LUMBAYANAGUE',
        BARANGAY: 'BAGOAINGUD',
    },
    {
        CITY: 'LUMBAYANAGUE',
        BARANGAY: 'BALAIGAY',
    },
    {
        CITY: 'LUMBAYANAGUE',
        BARANGAY: 'BALAIGAY',
    },
    {
        CITY: 'LUMBAYANAGUE',
        BARANGAY: 'BUALAN',
    },
    {
        CITY: 'LUMBAYANAGUE',
        BARANGAY: 'BUALAN',
    },
    {
        CITY: 'LUMBAYANAGUE',
        BARANGAY: 'CABUNTUNGAN',
    },
    {
        CITY: 'LUMBAYANAGUE',
        BARANGAY: 'CABUNTUNGAN',
    },
    {
        CITY: 'LUMBAYANAGUE',
        BARANGAY: 'CADAYONAN',
    },
    {
        CITY: 'LUMBAYANAGUE',
        BARANGAY: 'CADAYONAN',
    },
    {
        CITY: 'LUMBAYANAGUE',
        BARANGAY: 'CADINGILAN',
    },
    {
        CITY: 'LUMBAYANAGUE',
        BARANGAY: 'CADINGILAN',
    },
    {
        CITY: 'LUMBAYANAGUE',
        BARANGAY: 'CADINGILAN A',
    },
    {
        CITY: 'LUMBAYANAGUE',
        BARANGAY: 'CADINGILAN A',
    },
    {
        CITY: 'LUMBAYANAGUE',
        BARANGAY: 'CASALAYAN',
    },
    {
        CITY: 'LUMBAYANAGUE',
        BARANGAY: 'CASALAYAN',
    },
    {
        CITY: 'LUMBAYANAGUE',
        BARANGAY: 'DALA (DALAMA)',
    },
    {
        CITY: 'LUMBAYANAGUE',
        BARANGAY: 'DALA (DALAMA)',
    },
    {
        CITY: 'LUMBAYANAGUE',
        BARANGAY: 'DILIMBAYAN',
    },
    {
        CITY: 'LUMBAYANAGUE',
        BARANGAY: 'DILIMBAYAN',
    },
    {
        CITY: 'LUMBAYANAGUE',
        BARANGAY: 'DIROMOYOD',
    },
    {
        CITY: 'LUMBAYANAGUE',
        BARANGAY: 'DIROMOYOD',
    },
    {
        CITY: 'LUMBAYANAGUE',
        BARANGAY: 'KABASARAN (POB.)',
    },
    {
        CITY: 'LUMBAYANAGUE',
        BARANGAY: 'KABASARAN (POB.)',
    },
    {
        CITY: 'LUMBAYANAGUE',
        BARANGAY: 'LAMIN',
    },
    {
        CITY: 'LUMBAYANAGUE',
        BARANGAY: 'LAMIN',
    },
    {
        CITY: 'LUMBAYANAGUE',
        BARANGAY: 'MAPANTAO-BALANGAS',
    },
    {
        CITY: 'LUMBAYANAGUE',
        BARANGAY: 'MAPANTAO-BALANGAS',
    },
    {
        CITY: 'LUMBAYANAGUE',
        BARANGAY: 'MINIROS',
    },
    {
        CITY: 'LUMBAYANAGUE',
        BARANGAY: 'MINIROS',
    },
    {
        CITY: 'LUMBAYANAGUE',
        BARANGAY: 'NANAGUN',
    },
    {
        CITY: 'LUMBAYANAGUE',
        BARANGAY: 'NANAGUN',
    },
    {
        CITY: 'LUMBAYANAGUE',
        BARANGAY: 'PANTAON',
    },
    {
        CITY: 'LUMBAYANAGUE',
        BARANGAY: 'PANTAON',
    },
    {
        CITY: 'LUMBAYANAGUE',
        BARANGAY: 'PINDOLONAN',
    },
    {
        CITY: 'LUMBAYANAGUE',
        BARANGAY: 'PINDOLONAN',
    },
    {
        CITY: 'LUMBAYANAGUE',
        BARANGAY: 'PITATANGLAN',
    },
    {
        CITY: 'LUMBAYANAGUE',
        BARANGAY: 'PITATANGLAN',
    },
    {
        CITY: 'LUMBAYANAGUE',
        BARANGAY: 'POCTAN',
    },
    {
        CITY: 'LUMBAYANAGUE',
        BARANGAY: 'POCTAN',
    },
    {
        CITY: 'LUMBAYANAGUE',
        BARANGAY: 'SINGCARA',
    },
    {
        CITY: 'LUMBAYANAGUE',
        BARANGAY: 'SINGCARA',
    },
    {
        CITY: 'LUMBAYANAGUE',
        BARANGAY: 'WAGO',
    },
    {
        CITY: 'LUMBAYANAGUE',
        BARANGAY: 'WAGO',
    },
    {
        CITY: 'MADALUM',
        BARANGAY: 'ABAGA',
    },
    {
        CITY: 'MADALUM',
        BARANGAY: 'BACAYAWAN',
    },
    {
        CITY: 'MADALUM',
        BARANGAY: 'BAGOAINGUD',
    },
    {
        CITY: 'MADALUM',
        BARANGAY: 'BASAK',
    },
    {
        CITY: 'MADALUM',
        BARANGAY: 'BATO',
    },
    {
        CITY: 'MADALUM',
        BARANGAY: 'BUBONG',
    },
    {
        CITY: 'MADALUM',
        BARANGAY: 'CABASARAN',
    },
    {
        CITY: 'MADALUM',
        BARANGAY: 'CADAYONAN',
    },
    {
        CITY: 'MADALUM',
        BARANGAY: 'DANDAMUN',
    },
    {
        CITY: 'MADALUM',
        BARANGAY: 'DELAUSAN',
    },
    {
        CITY: 'MADALUM',
        BARANGAY: 'DIAMPACA',
    },
    {
        CITY: 'MADALUM',
        BARANGAY: 'DIBAROSAN',
    },
    {
        CITY: 'MADALUM',
        BARANGAY: 'GADONGAN',
    },
    {
        CITY: 'MADALUM',
        BARANGAY: 'GURAIN',
    },
    {
        CITY: 'MADALUM',
        BARANGAY: 'KORMATAN',
    },
    {
        CITY: 'MADALUM',
        BARANGAY: 'LIANGAN',
    },
    {
        CITY: 'MADALUM',
        BARANGAY: 'LIANGAN I',
    },
    {
        CITY: 'MADALUM',
        BARANGAY: 'LILITUN',
    },
    {
        CITY: 'MADALUM',
        BARANGAY: 'LINAO',
    },
    {
        CITY: 'MADALUM',
        BARANGAY: 'LINUK',
    },
    {
        CITY: 'MADALUM',
        BARANGAY: 'LUMBAC',
    },
    {
        CITY: 'MADALUM',
        BARANGAY: 'MADAYA',
    },
    {
        CITY: 'MADALUM',
        BARANGAY: 'PADIAN TOROGAN I',
    },
    {
        CITY: 'MADALUM',
        BARANGAY: 'PAGAYAWAN',
    },
    {
        CITY: 'MADALUM',
        BARANGAY: 'PARIDI-KALIMODAN',
    },
    {
        CITY: 'MADALUM',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'MADALUM',
        BARANGAY: 'PUNUD',
    },
    {
        CITY: 'MADALUM',
        BARANGAY: 'RACOTAN',
    },
    {
        CITY: 'MADALUM',
        BARANGAY: 'RAYA',
    },
    {
        CITY: 'MADALUM',
        BARANGAY: 'RIRAY',
    },
    {
        CITY: 'MADALUM',
        BARANGAY: 'SABANDING',
    },
    {
        CITY: 'MADALUM',
        BARANGAY: 'SALONGABANDING',
    },
    {
        CITY: 'MADALUM',
        BARANGAY: 'SOGOD KALOY',
    },
    {
        CITY: 'MADALUM',
        BARANGAY: 'SUGOD',
    },
    {
        CITY: 'MADALUM',
        BARANGAY: 'TAMPORONG',
    },
    {
        CITY: 'MADALUM',
        BARANGAY: 'TONGANTONGAN',
    },
    {
        CITY: 'MADALUM',
        BARANGAY: 'UDANGUN',
    },
    {
        CITY: 'MADAMBA',
        BARANGAY: 'BALAGUNUN',
    },
    {
        CITY: 'MADAMBA',
        BARANGAY: 'BALINTAD',
    },
    {
        CITY: 'MADAMBA',
        BARANGAY: 'BAWANG',
    },
    {
        CITY: 'MADAMBA',
        BARANGAY: 'BIABE',
    },
    {
        CITY: 'MADAMBA',
        BARANGAY: 'BUBONG UYAAN',
    },
    {
        CITY: 'MADAMBA',
        BARANGAY: 'CABASARAN',
    },
    {
        CITY: 'MADAMBA',
        BARANGAY: 'DIBARUSAN',
    },
    {
        CITY: 'MADAMBA',
        BARANGAY: 'ILIAN',
    },
    {
        CITY: 'MADAMBA',
        BARANGAY: 'LAKITAN',
    },
    {
        CITY: 'MADAMBA',
        BARANGAY: 'LIANGAN',
    },
    {
        CITY: 'MADAMBA',
        BARANGAY: 'LINUK',
    },
    {
        CITY: 'MADAMBA',
        BARANGAY: 'LUMBACA INGUD',
    },
    {
        CITY: 'MADAMBA',
        BARANGAY: 'MADAMBA',
    },
    {
        CITY: 'MADAMBA',
        BARANGAY: 'PAGAYONAN',
    },
    {
        CITY: 'MADAMBA',
        BARANGAY: 'PALAO',
    },
    {
        CITY: 'MADAMBA',
        BARANGAY: 'PANGADAPAN',
    },
    {
        CITY: 'MADAMBA',
        BARANGAY: 'PANTAON',
    },
    {
        CITY: 'MADAMBA',
        BARANGAY: 'PANTAR',
    },
    {
        CITY: 'MADAMBA',
        BARANGAY: 'PUNUD',
    },
    {
        CITY: 'MADAMBA',
        BARANGAY: 'TAMBO',
    },
    {
        CITY: 'MADAMBA',
        BARANGAY: 'TUBARAN',
    },
    {
        CITY: 'MADAMBA',
        BARANGAY: 'TUCA',
    },
    {
        CITY: 'MADAMBA',
        BARANGAY: 'TULAY',
    },
    {
        CITY: 'MADAMBA',
        BARANGAY: 'UYAAN PROPER (POB.)',
    },
    {
        CITY: 'MAGUING',
        BARANGAY: 'AGAGAN',
    },
    {
        CITY: 'MAGUING',
        BARANGAY: 'BALAGUNUN',
    },
    {
        CITY: 'MAGUING',
        BARANGAY: 'BALAWAG',
    },
    {
        CITY: 'MAGUING',
        BARANGAY: 'BALINTAO',
    },
    {
        CITY: 'MAGUING',
        BARANGAY: 'BATO-BATO',
    },
    {
        CITY: 'MAGUING',
        BARANGAY: 'BOLAO',
    },
    {
        CITY: 'MAGUING',
        BARANGAY: 'BOROCOT',
    },
    {
        CITY: 'MAGUING',
        BARANGAY: 'BORROWA',
    },
    {
        CITY: 'MAGUING',
        BARANGAY: 'BOTUD',
    },
    {
        CITY: 'MAGUING',
        BARANGAY: 'BUADIANGKAY',
    },
    {
        CITY: 'MAGUING',
        BARANGAY: 'BUBONG',
    },
    {
        CITY: 'MAGUING',
        BARANGAY: 'BUBONG BAYABAO',
    },
    {
        CITY: 'MAGUING',
        BARANGAY: 'CAMALIG',
    },
    {
        CITY: 'MAGUING',
        BARANGAY: 'CAMBONG',
    },
    {
        CITY: 'MAGUING',
        BARANGAY: 'DILAUSAN (POB.)',
    },
    {
        CITY: 'MAGUING',
        BARANGAY: 'DILIMBAYAN',
    },
    {
        CITY: 'MAGUING',
        BARANGAY: 'ILALAG',
    },
    {
        CITY: 'MAGUING',
        BARANGAY: 'KIANODAN',
    },
    {
        CITY: 'MAGUING',
        BARANGAY: 'LILOD BOROCOT',
    },
    {
        CITY: 'MAGUING',
        BARANGAY: 'LILOD MAGUING',
    },
    {
        CITY: 'MAGUING',
        BARANGAY: 'LUMBAC',
    },
    {
        CITY: 'MAGUING',
        BARANGAY: 'LUMBAC-DIMARAO',
    },
    {
        CITY: 'MAGUING',
        BARANGAY: 'MADANDING',
    },
    {
        CITY: 'MAGUING',
        BARANGAY: 'MADAYA',
    },
    {
        CITY: 'MAGUING',
        BARANGAY: 'MAGUING PROPER',
    },
    {
        CITY: 'MAGUING',
        BARANGAY: 'MALUNGUN',
    },
    {
        CITY: 'MAGUING',
        BARANGAY: 'MALUNGUN BOROCOT',
    },
    {
        CITY: 'MAGUING',
        BARANGAY: 'MALUNGUN PAGALONGAN',
    },
    {
        CITY: 'MAGUING',
        BARANGAY: 'PAGALONGAN',
    },
    {
        CITY: 'MAGUING',
        BARANGAY: 'PANAYANGAN',
    },
    {
        CITY: 'MAGUING',
        BARANGAY: 'PILIMOKNAN',
    },
    {
        CITY: 'MAGUING',
        BARANGAY: 'PINDOLONAN',
    },
    {
        CITY: 'MAGUING',
        BARANGAY: 'RAGAYAN (RUNGAYAN)',
    },
    {
        CITY: 'MAGUING',
        BARANGAY: 'SABALA DILAUSAN',
    },
    {
        CITY: 'MALABANG',
        BARANGAY: 'BACAYAWAN',
    },
    {
        CITY: 'MALABANG',
        BARANGAY: 'BADAK LUMAO',
    },
    {
        CITY: 'MALABANG',
        BARANGAY: 'BAGOAINGUD',
    },
    {
        CITY: 'MALABANG',
        BARANGAY: 'BANDAY',
    },
    {
        CITY: 'MALABANG',
        BARANGAY: 'BETAYAN',
    },
    {
        CITY: 'MALABANG',
        BARANGAY: 'BONIGA',
    },
    {
        CITY: 'MALABANG',
        BARANGAY: 'BPS VILLAGE',
    },
    {
        CITY: 'MALABANG',
        BARANGAY: 'BUNK HOUSE',
    },
    {
        CITY: 'MALABANG',
        BARANGAY: 'CABASARAN (SOUTH)',
    },
    {
        CITY: 'MALABANG',
        BARANGAY: 'CALIBAGAT',
    },
    {
        CITY: 'MALABANG',
        BARANGAY: 'CALUMBOG',
    },
    {
        CITY: 'MALABANG',
        BARANGAY: 'CAMPO MUSLIM',
    },
    {
        CITY: 'MALABANG',
        BARANGAY: 'CHINA TOWN (POB.)',
    },
    {
        CITY: 'MALABANG',
        BARANGAY: 'CORAHAB',
    },
    {
        CITY: 'MALABANG',
        BARANGAY: 'DIAMARO',
    },
    {
        CITY: 'MALABANG',
        BARANGAY: 'INANDAYAN',
    },
    {
        CITY: 'MALABANG',
        BARANGAY: 'JOSE ABAD SANTOS',
    },
    {
        CITY: 'MALABANG',
        BARANGAY: 'LAMIN',
    },
    {
        CITY: 'MALABANG',
        BARANGAY: 'MABLE',
    },
    {
        CITY: 'MALABANG',
        BARANGAY: 'MACURANDING',
    },
    {
        CITY: 'MALABANG',
        BARANGAY: 'MADAYA',
    },
    {
        CITY: 'MALABANG',
        BARANGAY: 'MANANAYO',
    },
    {
        CITY: 'MALABANG',
        BARANGAY: 'MANGGAHAN',
    },
    {
        CITY: 'MALABANG',
        BARANGAY: 'MASAO',
    },
    {
        CITY: 'MALABANG',
        BARANGAY: 'MATALIN',
    },
    {
        CITY: 'MALABANG',
        BARANGAY: 'MATAMPAY',
    },
    {
        CITY: 'MALABANG',
        BARANGAY: 'MATLING',
    },
    {
        CITY: 'MALABANG',
        BARANGAY: 'MONTAY',
    },
    {
        CITY: 'MALABANG',
        BARANGAY: 'PASIR',
    },
    {
        CITY: 'MALABANG',
        BARANGAY: 'PIALOT',
    },
    {
        CITY: 'MALABANG',
        BARANGAY: 'REBOCUN',
    },
    {
        CITY: 'MALABANG',
        BARANGAY: 'SARANG',
    },
    {
        CITY: 'MALABANG',
        BARANGAY: 'SUMBAGAROGONG',
    },
    {
        CITY: 'MALABANG',
        BARANGAY: 'TACUB',
    },
    {
        CITY: 'MALABANG',
        BARANGAY: 'TAMBARA',
    },
    {
        CITY: 'MALABANG',
        BARANGAY: 'TIONGCOP',
    },
    {
        CITY: 'MALABANG',
        BARANGAY: 'TUBOC',
    },
    {
        CITY: 'MARANTAO',
        BARANGAY: 'BACAYAWAN',
    },
    {
        CITY: 'MARANTAO',
        BARANGAY: 'BACONG',
    },
    {
        CITY: 'MARANTAO',
        BARANGAY: 'BANGA-PANTAR',
    },
    {
        CITY: 'MARANTAO',
        BARANGAY: 'BATAL-PUNUD',
    },
    {
        CITY: 'MARANTAO',
        BARANGAY: 'BUBONG MADANDING (BUBONG)',
    },
    {
        CITY: 'MARANTAO',
        BARANGAY: 'CAMALIG (POB.)',
    },
    {
        CITY: 'MARANTAO',
        BARANGAY: 'CAMALIG BANDARA INGUD',
    },
    {
        CITY: 'MARANTAO',
        BARANGAY: 'CAMALIG BUBONG',
    },
    {
        CITY: 'MARANTAO',
        BARANGAY: 'CAWAYAN',
    },
    {
        CITY: 'MARANTAO',
        BARANGAY: 'CAWAYAN BACOLOD',
    },
    {
        CITY: 'MARANTAO',
        BARANGAY: 'CAWAYAN KALAW',
    },
    {
        CITY: 'MARANTAO',
        BARANGAY: 'CAWAYAN LINUK',
    },
    {
        CITY: 'MARANTAO',
        BARANGAY: 'DAANAINGUD',
    },
    {
        CITY: 'MARANTAO',
        BARANGAY: 'ILIAN',
    },
    {
        CITY: 'MARANTAO',
        BARANGAY: 'INUDARAN CAMPONG',
    },
    {
        CITY: 'MARANTAO',
        BARANGAY: 'INUDARAN LOWAY',
    },
    {
        CITY: 'MARANTAO',
        BARANGAY: 'INUDARAN LUMBAC',
    },
    {
        CITY: 'MARANTAO',
        BARANGAY: 'KIALDAN',
    },
    {
        CITY: 'MARANTAO',
        BARANGAY: 'LUBO',
    },
    {
        CITY: 'MARANTAO',
        BARANGAY: 'LUMBAC KIALDAN',
    },
    {
        CITY: 'MARANTAO',
        BARANGAY: 'MANTAPOLI',
    },
    {
        CITY: 'MARANTAO',
        BARANGAY: 'MATAMPAY',
    },
    {
        CITY: 'MARANTAO',
        BARANGAY: 'MAUL',
    },
    {
        CITY: 'MARANTAO',
        BARANGAY: 'MAUL ILIAN',
    },
    {
        CITY: 'MARANTAO',
        BARANGAY: 'MAUL LUMBACA INGUD',
    },
    {
        CITY: 'MARANTAO',
        BARANGAY: 'NATARON',
    },
    {
        CITY: 'MARANTAO',
        BARANGAY: 'PAGALONGAN BACAYAWAN',
    },
    {
        CITY: 'MARANTAO',
        BARANGAY: 'PALAO',
    },
    {
        CITY: 'MARANTAO',
        BARANGAY: 'PATAIMAS',
    },
    {
        CITY: 'MARANTAO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'MARANTAO',
        BARANGAY: 'POONA MARANTAO',
    },
    {
        CITY: 'MARANTAO',
        BARANGAY: 'PUNUD PROPER',
    },
    {
        CITY: 'MARANTAO',
        BARANGAY: 'TACUB',
    },
    {
        CITY: 'MARANTAO',
        BARANGAY: 'TUCA KIALDAN',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'AMBOLONG',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'AMITO MARANTAO',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'BACOLOD CHICO PROPER',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'BANGA',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'BANGCO',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'BANGGOLO POBLACION',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'BANGON',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'BASAK MALUTLUT',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'BEYABA-DAMAG',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'BITO BUADI ITOWA',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'BITO BUADI PARBA',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'BOGANGA',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'BOTO AMBOLONG',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'BUADI SACAYO (GREEN)',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'BUBONG LUMBAC',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'BUBONGA CADAYONAN',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'BUBONGA LILOD MADAYA',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'BUBONGA MARAWI',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'BUBONGA PAGALAMATAN',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'BUBONGA PUNOD',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'CABASARAN',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'CABINGAN',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'CADAYONAN',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'CADAYONAN I',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'CALOCAN EAST',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'CALOCAN WEST',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'DAGUDUBAN',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'DANSALAN',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'DATU NAGA',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'DATU SA DANSALAN',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'DAYAWAN',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'DIMALUNA',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'DULAY',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'DULAY WEST',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'EAST BASAK',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'EMIE PUNUD',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'FORT',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'GADONGAN',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'GADONGAN MAPANTAO',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'GUIMBA (LILOD PROPER)',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'KAPANTARAN',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'KILALA',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'KORMATAN MATAMPAY',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'LILOD MADAYA (POB.)',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'LILOD SADUC',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'LOMIDONG',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'LUMBAC MARINAUT',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'LUMBACA MADAYA (POB.)',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'LUMBACA TOROS',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'MALIMONO',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'MARAWI POBLACION',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'MARINAUT EAST',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'MARINAUT WEST',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'MATAMPAY',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'MIPAGA PROPER',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'MONCADO COLONY',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'MONCADO KADINGILAN',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'MORIATAO LOKSADATO',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'NAVARRO (DATU SABER)',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'NORHAYA VILLAGE',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'OLAWA AMBOLONG',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'PAGALAMATAN GAMBAI',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'PAGAYAWAN',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'PANGGAO SADUC',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'PANTAON (LANGCAF)',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'PAPANDAYAN',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'PAPANDAYAN CANIOGAN',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'PARIDI',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'PATANI',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'PINDOLONAN',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'POONA MARANTAO',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'PUGAAN',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'RAPASUN MSU',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'RAYA MADAYA I',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'RAYA MADAYA II',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'RAYA SADUC',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'ROROGAGUS EAST',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'ROROGAGUS PROPER',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'SABALA MANAO',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'SABALA MANAO PROPER',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'SADUC PROPER',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'SAGONSONGAN',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'SANGCAY DANSALAN',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'SOMIORANG',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'SOUTH MADAYA PROPER',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'SUGOD PROPER',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'TAMPILONG',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'TIMBANGALAN',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'TOLALI',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'TONGANTONGAN-TUCA TIMBANGALAN',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'TOROS',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'TUCA',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'TUCA AMBOLONG',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'TUCA MARINAUT',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'WAWALAYAN CALOCAN',
    },
    {
        CITY: 'MARAWI',
        BARANGAY: 'WAWALAYAN MARINAUT',
    },
    {
        CITY: 'MAROGONG',
        BARANGAY: 'BAGUMBAYAN',
    },
    {
        CITY: 'MAROGONG',
        BARANGAY: 'BALUT',
    },
    {
        CITY: 'MAROGONG',
        BARANGAY: 'BITAYAN',
    },
    {
        CITY: 'MAROGONG',
        BARANGAY: 'BOLAWAN',
    },
    {
        CITY: 'MAROGONG',
        BARANGAY: 'BONGA',
    },
    {
        CITY: 'MAROGONG',
        BARANGAY: 'CABASARAN',
    },
    {
        CITY: 'MAROGONG',
        BARANGAY: 'CADAYONAN',
    },
    {
        CITY: 'MAROGONG',
        BARANGAY: 'CAHERA',
    },
    {
        CITY: 'MAROGONG',
        BARANGAY: 'CAIRANTANG',
    },
    {
        CITY: 'MAROGONG',
        BARANGAY: 'CALUMBOG',
    },
    {
        CITY: 'MAROGONG',
        BARANGAY: 'CANIBONGAN',
    },
    {
        CITY: 'MAROGONG',
        BARANGAY: 'DIRAGUN',
    },
    {
        CITY: 'MAROGONG',
        BARANGAY: 'MANTAILOCO',
    },
    {
        CITY: 'MAROGONG',
        BARANGAY: 'MAPANTAO',
    },
    {
        CITY: 'MAROGONG',
        BARANGAY: 'MAROGONG EAST',
    },
    {
        CITY: 'MAROGONG',
        BARANGAY: 'MAROGONG PROPER (POB.)',
    },
    {
        CITY: 'MAROGONG',
        BARANGAY: 'MAYAMAN',
    },
    {
        CITY: 'MAROGONG',
        BARANGAY: 'PABRICA',
    },
    {
        CITY: 'MAROGONG',
        BARANGAY: 'PAIGOAY CODA',
    },
    {
        CITY: 'MAROGONG',
        BARANGAY: 'PASAYANAN',
    },
    {
        CITY: 'MAROGONG',
        BARANGAY: 'PIANGOLOGAN',
    },
    {
        CITY: 'MAROGONG',
        BARANGAY: 'PURACAN',
    },
    {
        CITY: 'MAROGONG',
        BARANGAY: 'ROMAGONDONG',
    },
    {
        CITY: 'MAROGONG',
        BARANGAY: 'SARANG',
    },
    {
        CITY: 'MASIU',
        BARANGAY: 'ABDULLAH BUISAN',
    },
    {
        CITY: 'MASIU',
        BARANGAY: 'ALIP LALABUAN',
    },
    {
        CITY: 'MASIU',
        BARANGAY: 'ALUMPANG PAINO MIMBALAY',
    },
    {
        CITY: 'MASIU',
        BARANGAY: 'BUADI AMLOY',
    },
    {
        CITY: 'MASIU',
        BARANGAY: 'CARAMIAN ALIM RAYA',
    },
    {
        CITY: 'MASIU',
        BARANGAY: 'DALOG BALUT',
    },
    {
        CITY: 'MASIU',
        BARANGAY: 'GINDOLONGAN ALABAT',
    },
    {
        CITY: 'MASIU',
        BARANGAY: 'GONDARANGIN ASA ADIGAO',
    },
    {
        CITY: 'MASIU',
        BARANGAY: 'KALILANGAN',
    },
    {
        CITY: 'MASIU',
        BARANGAY: 'LAILA LUMBAC BACON',
    },
    {
        CITY: 'MASIU',
        BARANGAY: 'LAKADUN',
    },
    {
        CITY: 'MASIU',
        BARANGAY: 'LANCO DIMAPATOY',
    },
    {
        CITY: 'MASIU',
        BARANGAY: 'LOMIGIS SUCOD',
    },
    {
        CITY: 'MASIU',
        BARANGAY: 'LUMBACA INGUD',
    },
    {
        CITY: 'MASIU',
        BARANGAY: 'MACABANGAN IMBALA',
    },
    {
        CITY: 'MASIU',
        BARANGAY: 'MACADAAG TALAGUIAN',
    },
    {
        CITY: 'MASIU',
        BARANGAY: 'MACALUPANG LUMBAC CARAMIAN',
    },
    {
        CITY: 'MASIU',
        BARANGAY: 'MACOMPARA APA MIMBALAY',
    },
    {
        CITY: 'MASIU',
        BARANGAY: 'MAGAYO BAGOAINGUD',
    },
    {
        CITY: 'MASIU',
        BARANGAY: 'MAI DITIMBANG BALINDONG',
    },
    {
        CITY: 'MASIU',
        BARANGAY: 'MAI SINDAOLOAN DANSALAN',
    },
    {
        CITY: 'MASIU',
        BARANGAY: 'MANALOCON TALUB',
    },
    {
        CITY: 'MASIU',
        BARANGAY: 'MARANAT BONTALIS',
    },
    {
        CITY: 'MASIU',
        BARANGAY: 'MATAO ARAZA',
    },
    {
        CITY: 'MASIU',
        BARANGAY: 'MOCAMAD TANGUL',
    },
    {
        CITY: 'MASIU',
        BARANGAY: 'MORIATAO-BAI LABAY',
    },
    {
        CITY: 'MASIU',
        BARANGAY: 'PANTAO',
    },
    {
        CITY: 'MASIU',
        BARANGAY: 'PUTAD MARANDANG BUISAN',
    },
    {
        CITY: 'MASIU',
        BARANGAY: 'SAMBOWANG ATAWA',
    },
    {
        CITY: 'MASIU',
        BARANGAY: 'SAWIR',
    },
    {
        CITY: 'MASIU',
        BARANGAY: 'TALUB LANGI',
    },
    {
        CITY: 'MASIU',
        BARANGAY: 'TAMBORO CORMATAN',
    },
    {
        CITY: 'MASIU',
        BARANGAY: 'TOMAMBILING LUMBACA INGUD',
    },
    {
        CITY: 'MASIU',
        BARANGAY: 'TOWANAO ARANGGA',
    },
    {
        CITY: 'MASIU',
        BARANGAY: 'UNDA DAYAWAN',
    },
    {
        CITY: 'MULONDO',
        BARANGAY: 'BAGOAINGUD',
    },
    {
        CITY: 'MULONDO',
        BARANGAY: 'BANGON',
    },
    {
        CITY: 'MULONDO',
        BARANGAY: 'BUADI-ABALA',
    },
    {
        CITY: 'MULONDO',
        BARANGAY: 'BUADI-BAYAWA',
    },
    {
        CITY: 'MULONDO',
        BARANGAY: 'BUADI-INSUBA',
    },
    {
        CITY: 'MULONDO',
        BARANGAY: 'BUBONG',
    },
    {
        CITY: 'MULONDO',
        BARANGAY: 'BUBONGA GUILOPA',
    },
    {
        CITY: 'MULONDO',
        BARANGAY: 'CABASARAN',
    },
    {
        CITY: 'MULONDO',
        BARANGAY: 'CAIRATAN',
    },
    {
        CITY: 'MULONDO',
        BARANGAY: 'CORMATAN',
    },
    {
        CITY: 'MULONDO',
        BARANGAY: 'DALAMA',
    },
    {
        CITY: 'MULONDO',
        BARANGAY: 'DANSALAN',
    },
    {
        CITY: 'MULONDO',
        BARANGAY: 'DIMARAO',
    },
    {
        CITY: 'MULONDO',
        BARANGAY: 'GUILOPA',
    },
    {
        CITY: 'MULONDO',
        BARANGAY: 'ILIAN',
    },
    {
        CITY: 'MULONDO',
        BARANGAY: 'KITAMBUGUN',
    },
    {
        CITY: 'MULONDO',
        BARANGAY: 'LAMA (BAGOAINGUD)',
    },
    {
        CITY: 'MULONDO',
        BARANGAY: 'LILOD',
    },
    {
        CITY: 'MULONDO',
        BARANGAY: 'LILOD RAYBALAI',
    },
    {
        CITY: 'MULONDO',
        BARANGAY: 'LUMBAC (LUMBAC BUBONG)',
    },
    {
        CITY: 'MULONDO',
        BARANGAY: 'LUMBACA INGUD',
    },
    {
        CITY: 'MULONDO',
        BARANGAY: 'MADAYA',
    },
    {
        CITY: 'MULONDO',
        BARANGAY: 'PINDOLONAN',
    },
    {
        CITY: 'MULONDO',
        BARANGAY: 'POBLACION (DADO)',
    },
    {
        CITY: 'MULONDO',
        BARANGAY: 'SALIPONGAN',
    },
    {
        CITY: 'MULONDO',
        BARANGAY: 'SUGAN',
    },
    {
        CITY: 'PAGAYAWAN',
        BARANGAY: 'AYONG',
    },
    {
        CITY: 'PAGAYAWAN',
        BARANGAY: 'BANDARA INGUD',
    },
    {
        CITY: 'PAGAYAWAN',
        BARANGAY: 'BANGON (POB.)',
    },
    {
        CITY: 'PAGAYAWAN',
        BARANGAY: 'BIALA-AN',
    },
    {
        CITY: 'PAGAYAWAN',
        BARANGAY: 'DIAMPACA',
    },
    {
        CITY: 'PAGAYAWAN',
        BARANGAY: 'GUIARONG',
    },
    {
        CITY: 'PAGAYAWAN',
        BARANGAY: 'ILIAN',
    },
    {
        CITY: 'PAGAYAWAN',
        BARANGAY: 'KALALUDAN',
    },
    {
        CITY: 'PAGAYAWAN',
        BARANGAY: 'LININDINGAN',
    },
    {
        CITY: 'PAGAYAWAN',
        BARANGAY: 'MADANG',
    },
    {
        CITY: 'PAGAYAWAN',
        BARANGAY: 'MAPANTAO',
    },
    {
        CITY: 'PAGAYAWAN',
        BARANGAY: 'NGINGIR (KABASARAN)',
    },
    {
        CITY: 'PAGAYAWAN',
        BARANGAY: 'PADAS',
    },
    {
        CITY: 'PAGAYAWAN',
        BARANGAY: 'PAIGOAY',
    },
    {
        CITY: 'PAGAYAWAN',
        BARANGAY: 'PINALANGCA',
    },
    {
        CITY: 'PAGAYAWAN',
        BARANGAY: 'POBLACION (LUMBAC)',
    },
    {
        CITY: 'PAGAYAWAN',
        BARANGAY: 'RANGIRAN',
    },
    {
        CITY: 'PAGAYAWAN',
        BARANGAY: 'RUBOKUN',
    },
    {
        CITY: 'PIAGAPO',
        BARANGAY: 'APOSONG',
    },
    {
        CITY: 'PIAGAPO',
        BARANGAY: 'BAGOAINGUD',
    },
    {
        CITY: 'PIAGAPO',
        BARANGAY: 'BANGCO (POB.)',
    },
    {
        CITY: 'PIAGAPO',
        BARANGAY: 'BANSAYAN',
    },
    {
        CITY: 'PIAGAPO',
        BARANGAY: 'BASAK',
    },
    {
        CITY: 'PIAGAPO',
        BARANGAY: 'BOBO',
    },
    {
        CITY: 'PIAGAPO',
        BARANGAY: 'BUALAN',
    },
    {
        CITY: 'PIAGAPO',
        BARANGAY: 'BUBONG ILIAN',
    },
    {
        CITY: 'PIAGAPO',
        BARANGAY: 'BUBONG TAWA-AN',
    },
    {
        CITY: 'PIAGAPO',
        BARANGAY: 'BUBONGA MAMAANUN',
    },
    {
        CITY: 'PIAGAPO',
        BARANGAY: 'GACAP',
    },
    {
        CITY: 'PIAGAPO',
        BARANGAY: 'ILIAN',
    },
    {
        CITY: 'PIAGAPO',
        BARANGAY: 'ILIAN POBLACION',
    },
    {
        CITY: 'PIAGAPO',
        BARANGAY: 'KALANGANAN',
    },
    {
        CITY: 'PIAGAPO',
        BARANGAY: 'KATUMBACAN',
    },
    {
        CITY: 'PIAGAPO',
        BARANGAY: 'LININDING',
    },
    {
        CITY: 'PIAGAPO',
        BARANGAY: 'LUMBACA MAMAAN',
    },
    {
        CITY: 'PIAGAPO',
        BARANGAY: 'MAMAANUN',
    },
    {
        CITY: 'PIAGAPO',
        BARANGAY: 'MENTRING',
    },
    {
        CITY: 'PIAGAPO',
        BARANGAY: 'OLANGO',
    },
    {
        CITY: 'PIAGAPO',
        BARANGAY: 'PALACAT',
    },
    {
        CITY: 'PIAGAPO',
        BARANGAY: 'PALAO',
    },
    {
        CITY: 'PIAGAPO',
        BARANGAY: 'PALING',
    },
    {
        CITY: 'PIAGAPO',
        BARANGAY: 'PANTAON',
    },
    {
        CITY: 'PIAGAPO',
        BARANGAY: 'PANTAR',
    },
    {
        CITY: 'PIAGAPO',
        BARANGAY: 'PARIDI',
    },
    {
        CITY: 'PIAGAPO',
        BARANGAY: 'PINDOLONAN',
    },
    {
        CITY: 'PIAGAPO',
        BARANGAY: 'RADAPAN',
    },
    {
        CITY: 'PIAGAPO',
        BARANGAY: 'RADAPAN POBLACION',
    },
    {
        CITY: 'PIAGAPO',
        BARANGAY: 'RANTIAN',
    },
    {
        CITY: 'PIAGAPO',
        BARANGAY: 'SAPINGIT',
    },
    {
        CITY: 'PIAGAPO',
        BARANGAY: 'TALAO',
    },
    {
        CITY: 'PIAGAPO',
        BARANGAY: 'TAMBO',
    },
    {
        CITY: 'PIAGAPO',
        BARANGAY: 'TAPOCAN',
    },
    {
        CITY: 'PIAGAPO',
        BARANGAY: 'TAPORUG',
    },
    {
        CITY: 'PIAGAPO',
        BARANGAY: 'TAWAAN',
    },
    {
        CITY: 'PIAGAPO',
        BARANGAY: 'UDALO',
    },
    {
        CITY: 'PICONG',
        BARANGAY: 'ANAS',
    },
    {
        CITY: 'PICONG',
        BARANGAY: 'BARA-AS',
    },
    {
        CITY: 'PICONG',
        BARANGAY: 'BIASONG',
    },
    {
        CITY: 'PICONG',
        BARANGAY: 'BULANGOS',
    },
    {
        CITY: 'PICONG',
        BARANGAY: 'DURIAN',
    },
    {
        CITY: 'PICONG',
        BARANGAY: 'ILIAN',
    },
    {
        CITY: 'PICONG',
        BARANGAY: 'LIANGAN (POB.)',
    },
    {
        CITY: 'PICONG',
        BARANGAY: 'MAGANDING',
    },
    {
        CITY: 'PICONG',
        BARANGAY: 'MALADI',
    },
    {
        CITY: 'PICONG',
        BARANGAY: 'MAPANTAO',
    },
    {
        CITY: 'PICONG',
        BARANGAY: 'MICALUBO',
    },
    {
        CITY: 'PICONG',
        BARANGAY: 'MIMBALAWAG',
    },
    {
        CITY: 'PICONG',
        BARANGAY: 'PINDOLONAN',
    },
    {
        CITY: 'PICONG',
        BARANGAY: 'PUNONG',
    },
    {
        CITY: 'PICONG',
        BARANGAY: 'RAMITAN',
    },
    {
        CITY: 'PICONG',
        BARANGAY: 'TOROGAN',
    },
    {
        CITY: 'PICONG',
        BARANGAY: 'TUAL',
    },
    {
        CITY: 'PICONG',
        BARANGAY: 'TUCA',
    },
    {
        CITY: 'PICONG',
        BARANGAY: 'UBANOBAN',
    },
    {
        CITY: 'POONA-BAYABAO',
        BARANGAY: 'ATARAGADONG',
    },
    {
        CITY: 'POONA-BAYABAO',
        BARANGAY: 'BANGON',
    },
    {
        CITY: 'POONA-BAYABAO',
        BARANGAY: 'BANSAYAN',
    },
    {
        CITY: 'POONA-BAYABAO',
        BARANGAY: 'BUALAN',
    },
    {
        CITY: 'POONA-BAYABAO',
        BARANGAY: 'BUBONG-DIMUNDA',
    },
    {
        CITY: 'POONA-BAYABAO',
        BARANGAY: 'BUGARAN',
    },
    {
        CITY: 'POONA-BAYABAO',
        BARANGAY: 'CADAYONAN',
    },
    {
        CITY: 'POONA-BAYABAO',
        BARANGAY: 'CALILANGAN DICALA',
    },
    {
        CITY: 'POONA-BAYABAO',
        BARANGAY: 'CALUPAAN',
    },
    {
        CITY: 'POONA-BAYABAO',
        BARANGAY: 'DILAUSAN',
    },
    {
        CITY: 'POONA-BAYABAO',
        BARANGAY: 'DIMAYON',
    },
    {
        CITY: 'POONA-BAYABAO',
        BARANGAY: 'DONGCOAN',
    },
    {
        CITY: 'POONA-BAYABAO',
        BARANGAY: 'GADONGAN',
    },
    {
        CITY: 'POONA-BAYABAO',
        BARANGAY: 'LIANGAN',
    },
    {
        CITY: 'POONA-BAYABAO',
        BARANGAY: 'LUMBAC',
    },
    {
        CITY: 'POONA-BAYABAO',
        BARANGAY: 'LUMBACA INGUD',
    },
    {
        CITY: 'POONA-BAYABAO',
        BARANGAY: 'MADANDING',
    },
    {
        CITY: 'POONA-BAYABAO',
        BARANGAY: 'PANTAO',
    },
    {
        CITY: 'POONA-BAYABAO',
        BARANGAY: 'POBLACION (GATA PROPER)',
    },
    {
        CITY: 'POONA-BAYABAO',
        BARANGAY: 'PUNUD',
    },
    {
        CITY: 'POONA-BAYABAO',
        BARANGAY: 'RAGAYAN',
    },
    {
        CITY: 'POONA-BAYABAO',
        BARANGAY: 'ROGAN CAIRAN',
    },
    {
        CITY: 'POONA-BAYABAO',
        BARANGAY: 'ROGAN TANDIONG DIMAYON',
    },
    {
        CITY: 'POONA-BAYABAO',
        BARANGAY: 'TALAGUIAN',
    },
    {
        CITY: 'POONA-BAYABAO',
        BARANGAY: 'TAPOROG',
    },
    {
        CITY: 'PUALAS',
        BARANGAY: 'BADAK',
    },
    {
        CITY: 'PUALAS',
        BARANGAY: 'BANTAYAN',
    },
    {
        CITY: 'PUALAS',
        BARANGAY: 'BASAGAD',
    },
    {
        CITY: 'PUALAS',
        BARANGAY: 'BOLINSONG',
    },
    {
        CITY: 'PUALAS',
        BARANGAY: 'BORING',
    },
    {
        CITY: 'PUALAS',
        BARANGAY: 'BUALAN',
    },
    {
        CITY: 'PUALAS',
        BARANGAY: 'DANUGAN',
    },
    {
        CITY: 'PUALAS',
        BARANGAY: 'DAPAO',
    },
    {
        CITY: 'PUALAS',
        BARANGAY: 'DIAMLA',
    },
    {
        CITY: 'PUALAS',
        BARANGAY: 'GADONGAN',
    },
    {
        CITY: 'PUALAS',
        BARANGAY: 'INGUD',
    },
    {
        CITY: 'PUALAS',
        BARANGAY: 'LINUK',
    },
    {
        CITY: 'PUALAS',
        BARANGAY: 'LUMBAC',
    },
    {
        CITY: 'PUALAS',
        BARANGAY: 'MALIGO',
    },
    {
        CITY: 'PUALAS',
        BARANGAY: 'MASAO',
    },
    {
        CITY: 'PUALAS',
        BARANGAY: 'NOTONG',
    },
    {
        CITY: 'PUALAS',
        BARANGAY: 'PORUG',
    },
    {
        CITY: 'PUALAS',
        BARANGAY: 'ROMAGONDONG',
    },
    {
        CITY: 'PUALAS',
        BARANGAY: 'TAMBO (POB.)',
    },
    {
        CITY: 'PUALAS',
        BARANGAY: 'TAMLANG',
    },
    {
        CITY: 'PUALAS',
        BARANGAY: 'TOMAROMPONG',
    },
    {
        CITY: 'PUALAS',
        BARANGAY: 'TUKA',
    },
    {
        CITY: 'PUALAS',
        BARANGAY: 'YARAN',
    },
    {
        CITY: 'SAGUIARAN',
        BARANGAY: 'ALINUN',
    },
    {
        CITY: 'SAGUIARAN',
        BARANGAY: 'BAGOAINGUD',
    },
    {
        CITY: 'SAGUIARAN',
        BARANGAY: 'BASAK MAITO',
    },
    {
        CITY: 'SAGUIARAN',
        BARANGAY: 'BATANGAN',
    },
    {
        CITY: 'SAGUIARAN',
        BARANGAY: 'BUBONG',
    },
    {
        CITY: 'SAGUIARAN',
        BARANGAY: 'CADAYON',
    },
    {
        CITY: 'SAGUIARAN',
        BARANGAY: 'CADINGILAN',
    },
    {
        CITY: 'SAGUIARAN',
        BARANGAY: 'COMONAL',
    },
    {
        CITY: 'SAGUIARAN',
        BARANGAY: 'DILAUSAN',
    },
    {
        CITY: 'SAGUIARAN',
        BARANGAY: 'DILIMBAYAN',
    },
    {
        CITY: 'SAGUIARAN',
        BARANGAY: 'GADONGAN',
    },
    {
        CITY: 'SAGUIARAN',
        BARANGAY: 'LIMOGAO',
    },
    {
        CITY: 'SAGUIARAN',
        BARANGAY: 'LINAO',
    },
    {
        CITY: 'SAGUIARAN',
        BARANGAY: 'LUMBAC TOROS',
    },
    {
        CITY: 'SAGUIARAN',
        BARANGAY: 'LUMBAYANAGUE',
    },
    {
        CITY: 'SAGUIARAN',
        BARANGAY: 'MALIWANAG',
    },
    {
        CITY: 'SAGUIARAN',
        BARANGAY: 'MAPANTAO',
    },
    {
        CITY: 'SAGUIARAN',
        BARANGAY: 'MIPAGA',
    },
    {
        CITY: 'SAGUIARAN',
        BARANGAY: 'NATANGCOPAN',
    },
    {
        CITY: 'SAGUIARAN',
        BARANGAY: 'PAGALAMATAN',
    },
    {
        CITY: 'SAGUIARAN',
        BARANGAY: 'PAMACOTAN',
    },
    {
        CITY: 'SAGUIARAN',
        BARANGAY: 'PANGGAO',
    },
    {
        CITY: 'SAGUIARAN',
        BARANGAY: 'PANTAO RAYA',
    },
    {
        CITY: 'SAGUIARAN',
        BARANGAY: 'PANTAON',
    },
    {
        CITY: 'SAGUIARAN',
        BARANGAY: 'PATPANGKAT',
    },
    {
        CITY: 'SAGUIARAN',
        BARANGAY: 'PAWAK',
    },
    {
        CITY: 'SAGUIARAN',
        BARANGAY: 'PINDOLONAN',
    },
    {
        CITY: 'SAGUIARAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SAGUIARAN',
        BARANGAY: 'SALOCAD',
    },
    {
        CITY: 'SAGUIARAN',
        BARANGAY: 'SUNGCOD',
    },
    {
        CITY: 'SULTAN-DUMALONDONG',
        BARANGAY: 'BACAYAWAN',
    },
    {
        CITY: 'SULTAN-DUMALONDONG',
        BARANGAY: 'BUTA (SUMALINDAO)',
    },
    {
        CITY: 'SULTAN-DUMALONDONG',
        BARANGAY: 'DINGANUN GUILOPA (DINGUNUN)',
    },
    {
        CITY: 'SULTAN-DUMALONDONG',
        BARANGAY: 'LUMBAC',
    },
    {
        CITY: 'SULTAN-DUMALONDONG',
        BARANGAY: 'MALALIS',
    },
    {
        CITY: 'SULTAN-DUMALONDONG',
        BARANGAY: 'PAGALONGAN',
    },
    {
        CITY: 'SULTAN-DUMALONDONG',
        BARANGAY: 'TAGORANAO',
    },
    {
        CITY: 'TAGOLOAN-II',
        BARANGAY: 'BAGOAINGUD',
    },
    {
        CITY: 'TAGOLOAN-II',
        BARANGAY: 'BANTALAN',
    },
    {
        CITY: 'TAGOLOAN-II',
        BARANGAY: 'BAYOG',
    },
    {
        CITY: 'TAGOLOAN-II',
        BARANGAY: 'CADAYONAN',
    },
    {
        CITY: 'TAGOLOAN-II',
        BARANGAY: 'DAGONALAN',
    },
    {
        CITY: 'TAGOLOAN-II',
        BARANGAY: 'DIMALAMA',
    },
    {
        CITY: 'TAGOLOAN-II',
        BARANGAY: 'GAYAKAY',
    },
    {
        CITY: 'TAGOLOAN-II',
        BARANGAY: 'INODARAN',
    },
    {
        CITY: 'TAGOLOAN-II',
        BARANGAY: 'KALILANGAN',
    },
    {
        CITY: 'TAGOLOAN-II',
        BARANGAY: 'KIANIBONG',
    },
    {
        CITY: 'TAGOLOAN-II',
        BARANGAY: 'KINGAN',
    },
    {
        CITY: 'TAGOLOAN-II',
        BARANGAY: 'KITAON',
    },
    {
        CITY: 'TAGOLOAN-II',
        BARANGAY: 'MAIMBAGUIANG',
    },
    {
        CITY: 'TAGOLOAN-II',
        BARANGAY: 'MALINAO',
    },
    {
        CITY: 'TAGOLOAN-II',
        BARANGAY: 'MALINGON',
    },
    {
        CITY: 'TAGOLOAN-II',
        BARANGAY: 'MAMA-AN PAGALONGAN',
    },
    {
        CITY: 'TAGOLOAN-II',
        BARANGAY: 'MARAWI',
    },
    {
        CITY: 'TAGOLOAN-II',
        BARANGAY: 'SIGAYAN',
    },
    {
        CITY: 'TAGOLOAN-II',
        BARANGAY: 'TAGOLOAN POBLACION',
    },
    {
        CITY: 'TAMPARAN',
        BARANGAY: 'BALUTMADIAR',
    },
    {
        CITY: 'TAMPARAN',
        BARANGAY: 'BANGON',
    },
    {
        CITY: 'TAMPARAN',
        BARANGAY: 'BERUAR',
    },
    {
        CITY: 'TAMPARAN',
        BARANGAY: 'BOCALAN',
    },
    {
        CITY: 'TAMPARAN',
        BARANGAY: 'CABASARAN',
    },
    {
        CITY: 'TAMPARAN',
        BARANGAY: 'DASOMALONG',
    },
    {
        CITY: 'TAMPARAN',
        BARANGAY: 'DILAUSAN',
    },
    {
        CITY: 'TAMPARAN',
        BARANGAY: 'GINAOPAN',
    },
    {
        CITY: 'TAMPARAN',
        BARANGAY: 'LALABUAN',
    },
    {
        CITY: 'TAMPARAN',
        BARANGAY: 'LILOD TAMPARAN',
    },
    {
        CITY: 'TAMPARAN',
        BARANGAY: 'LILOD TUBOK',
    },
    {
        CITY: 'TAMPARAN',
        BARANGAY: 'LINDONGAN',
    },
    {
        CITY: 'TAMPARAN',
        BARANGAY: 'LINUK',
    },
    {
        CITY: 'TAMPARAN',
        BARANGAY: 'LINUK ORIENTAL',
    },
    {
        CITY: 'TAMPARAN',
        BARANGAY: 'LUMBAC',
    },
    {
        CITY: 'TAMPARAN',
        BARANGAY: 'LUMBACA INGUD',
    },
    {
        CITY: 'TAMPARAN',
        BARANGAY: 'LUMBACA LILOD',
    },
    {
        CITY: 'TAMPARAN',
        BARANGAY: 'LUMBACAINGUD SOUTH',
    },
    {
        CITY: 'TAMPARAN',
        BARANGAY: 'MAIDAN LINUK',
    },
    {
        CITY: 'TAMPARAN',
        BARANGAY: 'MALA-ABANGON',
    },
    {
        CITY: 'TAMPARAN',
        BARANGAY: 'MALIWANAG',
    },
    {
        CITY: 'TAMPARAN',
        BARANGAY: 'MARIATAO DATU',
    },
    {
        CITY: 'TAMPARAN',
        BARANGAY: 'MINANGA',
    },
    {
        CITY: 'TAMPARAN',
        BARANGAY: 'MIONDAS',
    },
    {
        CITY: 'TAMPARAN',
        BARANGAY: 'NEW LUMBACAINGUD',
    },
    {
        CITY: 'TAMPARAN',
        BARANGAY: 'OCCIDENTAL LINUK',
    },
    {
        CITY: 'TAMPARAN',
        BARANGAY: 'PAGALAMATAN LINUK',
    },
    {
        CITY: 'TAMPARAN',
        BARANGAY: 'PAGAYAWAN',
    },
    {
        CITY: 'TAMPARAN',
        BARANGAY: 'PICARABAWAN',
    },
    {
        CITY: 'TAMPARAN',
        BARANGAY: 'PIMBAGO-PAGALONGAN',
    },
    {
        CITY: 'TAMPARAN',
        BARANGAY: 'PINDOLONAN MARIATAO SARIP',
    },
    {
        CITY: 'TAMPARAN',
        BARANGAY: 'POBLACION I',
    },
    {
        CITY: 'TAMPARAN',
        BARANGAY: 'POBLACION II',
    },
    {
        CITY: 'TAMPARAN',
        BARANGAY: 'POBLACION III',
    },
    {
        CITY: 'TAMPARAN',
        BARANGAY: 'POBLACION IV',
    },
    {
        CITY: 'TAMPARAN',
        BARANGAY: 'RAYA BUADI BARAO',
    },
    {
        CITY: 'TAMPARAN',
        BARANGAY: 'RAYA NIONDAS',
    },
    {
        CITY: 'TAMPARAN',
        BARANGAY: 'RAYA TAMPARAN',
    },
    {
        CITY: 'TAMPARAN',
        BARANGAY: 'SALONGABANDING',
    },
    {
        CITY: 'TAMPARAN',
        BARANGAY: 'SAMINUNGGAY',
    },
    {
        CITY: 'TAMPARAN',
        BARANGAY: 'TALUB',
    },
    {
        CITY: 'TAMPARAN',
        BARANGAY: 'TATAYAWAN NORTH',
    },
    {
        CITY: 'TAMPARAN',
        BARANGAY: 'TATAYAWAN SOUTH',
    },
    {
        CITY: 'TAMPARAN',
        BARANGAY: 'TUBOK',
    },
    {
        CITY: 'TARAKA',
        BARANGAY: 'BANDERA BUISAN',
    },
    {
        CITY: 'TARAKA',
        BARANGAY: 'BORIONGAN',
    },
    {
        CITY: 'TARAKA',
        BARANGAY: 'BOROWA',
    },
    {
        CITY: 'TARAKA',
        BARANGAY: 'BUADI AMAO',
    },
    {
        CITY: 'TARAKA',
        BARANGAY: 'BUADI AMUNTA',
    },
    {
        CITY: 'TARAKA',
        BARANGAY: 'BUADI AMUNUD',
    },
    {
        CITY: 'TARAKA',
        BARANGAY: 'BUADI ARORAO',
    },
    {
        CITY: 'TARAKA',
        BARANGAY: 'BUADI ATOPA',
    },
    {
        CITY: 'TARAKA',
        BARANGAY: 'BUADI DAYOMANGGA',
    },
    {
        CITY: 'TARAKA',
        BARANGAY: 'BUADI DINGUN',
    },
    {
        CITY: 'TARAKA',
        BARANGAY: 'BUADI ONGCALO',
    },
    {
        CITY: 'TARAKA',
        BARANGAY: 'BUCALAN',
    },
    {
        CITY: 'TARAKA',
        BARANGAY: 'CADAYONAN BAGUMBAYAN',
    },
    {
        CITY: 'TARAKA',
        BARANGAY: 'CARAMAT',
    },
    {
        CITY: 'TARAKA',
        BARANGAY: 'CARANDANGAN CALOPAAN',
    },
    {
        CITY: 'TARAKA',
        BARANGAY: 'DATU MA-AS',
    },
    {
        CITY: 'TARAKA',
        BARANGAY: 'DILABAYAN',
    },
    {
        CITY: 'TARAKA',
        BARANGAY: 'DIMAYON',
    },
    {
        CITY: 'TARAKA',
        BARANGAY: 'GAPAO BALINDONG',
    },
    {
        CITY: 'TARAKA',
        BARANGAY: 'ILIAN',
    },
    {
        CITY: 'TARAKA',
        BARANGAY: 'LUMASA',
    },
    {
        CITY: 'TARAKA',
        BARANGAY: 'LUMASA PROPER (SALVADOR CONCHA)',
    },
    {
        CITY: 'TARAKA',
        BARANGAY: 'LUMBAC BAGOAINGUD',
    },
    {
        CITY: 'TARAKA',
        BARANGAY: 'LUMBAC BUBONG MAINDANG',
    },
    {
        CITY: 'TARAKA',
        BARANGAY: 'LUMBAC PITAKUS',
    },
    {
        CITY: 'TARAKA',
        BARANGAY: 'MALUNGUN',
    },
    {
        CITY: 'TARAKA',
        BARANGAY: 'MANGAYAO',
    },
    {
        CITY: 'TARAKA',
        BARANGAY: 'MARUHOM',
    },
    {
        CITY: 'TARAKA',
        BARANGAY: 'MASOLUN',
    },
    {
        CITY: 'TARAKA',
        BARANGAY: 'MORIATAO LOKSA DATU',
    },
    {
        CITY: 'TARAKA',
        BARANGAY: 'PAGALAMATAN',
    },
    {
        CITY: 'TARAKA',
        BARANGAY: 'PINDOLONAN',
    },
    {
        CITY: 'TARAKA',
        BARANGAY: 'PITAKUS',
    },
    {
        CITY: 'TARAKA',
        BARANGAY: 'RIRIK',
    },
    {
        CITY: 'TARAKA',
        BARANGAY: 'SALIPONGAN',
    },
    {
        CITY: 'TARAKA',
        BARANGAY: 'SAMBOLAWAN',
    },
    {
        CITY: 'TARAKA',
        BARANGAY: 'SAMPORNA SALAMATOLLAH',
    },
    {
        CITY: 'TARAKA',
        BARANGAY: 'SIGAYAN PROPER',
    },
    {
        CITY: 'TARAKA',
        BARANGAY: 'SOMIORANG BANDINGUN',
    },
    {
        CITY: 'TARAKA',
        BARANGAY: 'SUNDING',
    },
    {
        CITY: 'TARAKA',
        BARANGAY: 'SUNGGOD',
    },
    {
        CITY: 'TARAKA',
        BARANGAY: 'SUPANGAN',
    },
    {
        CITY: 'TARAKA',
        BARANGAY: 'TUPA-AN BUADIATUPA',
    },
    {
        CITY: 'TUBARAN',
        BARANGAY: 'ALOG',
    },
    {
        CITY: 'TUBARAN',
        BARANGAY: 'BAGIANGUN',
    },
    {
        CITY: 'TUBARAN',
        BARANGAY: 'BETA',
    },
    {
        CITY: 'TUBARAN',
        BARANGAY: 'CAMPO',
    },
    {
        CITY: 'TUBARAN',
        BARANGAY: 'DATUMANONG',
    },
    {
        CITY: 'TUBARAN',
        BARANGAY: 'DINAIGAN',
    },
    {
        CITY: 'TUBARAN',
        BARANGAY: 'GADONGAN',
    },
    {
        CITY: 'TUBARAN',
        BARANGAY: 'GAPUT',
    },
    {
        CITY: 'TUBARAN',
        BARANGAY: 'GUIARONG',
    },
    {
        CITY: 'TUBARAN',
        BARANGAY: 'MADAYA',
    },
    {
        CITY: 'TUBARAN',
        BARANGAY: 'MALAGANDING',
    },
    {
        CITY: 'TUBARAN',
        BARANGAY: 'METADICOP',
    },
    {
        CITY: 'TUBARAN',
        BARANGAY: 'MINDAMUDAG',
    },
    {
        CITY: 'TUBARAN',
        BARANGAY: 'PAGALAMATAN',
    },
    {
        CITY: 'TUBARAN',
        BARANGAY: 'PAIGOAY-PIMBATAAN',
    },
    {
        CITY: 'TUBARAN',
        BARANGAY: 'POBLACION (BURIBID)',
    },
    {
        CITY: 'TUBARAN',
        BARANGAY: 'POLO',
    },
    {
        CITY: 'TUBARAN',
        BARANGAY: 'RIANTARAN',
    },
    {
        CITY: 'TUBARAN',
        BARANGAY: 'TANGCAL',
    },
    {
        CITY: 'TUBARAN',
        BARANGAY: 'TUBARAN PROPER',
    },
    {
        CITY: 'TUBARAN',
        BARANGAY: 'WAGO',
    },
    {
        CITY: 'TUGAYA',
        BARANGAY: 'BAGOAINGUD',
    },
    {
        CITY: 'TUGAYA',
        BARANGAY: 'BUADI ALAWANG',
    },
    {
        CITY: 'TUGAYA',
        BARANGAY: 'BUADI DICO',
    },
    {
        CITY: 'TUGAYA',
        BARANGAY: 'BUBONG',
    },
    {
        CITY: 'TUGAYA',
        BARANGAY: 'CAMPONG TALAO',
    },
    {
        CITY: 'TUGAYA',
        BARANGAY: 'CAYAGAN',
    },
    {
        CITY: 'TUGAYA',
        BARANGAY: 'DANDANUN',
    },
    {
        CITY: 'TUGAYA',
        BARANGAY: 'DILIMBAYAN',
    },
    {
        CITY: 'TUGAYA',
        BARANGAY: 'GURAIN',
    },
    {
        CITY: 'TUGAYA',
        BARANGAY: 'LUMBAC',
    },
    {
        CITY: 'TUGAYA',
        BARANGAY: 'MAIDAN',
    },
    {
        CITY: 'TUGAYA',
        BARANGAY: 'MAPANTAO',
    },
    {
        CITY: 'TUGAYA',
        BARANGAY: 'PAGALAMATAN',
    },
    {
        CITY: 'TUGAYA',
        BARANGAY: 'PANDIARANAO',
    },
    {
        CITY: 'TUGAYA',
        BARANGAY: 'PINDOLONAN I',
    },
    {
        CITY: 'TUGAYA',
        BARANGAY: 'PINDOLONAN II',
    },
    {
        CITY: 'TUGAYA',
        BARANGAY: 'POBLACION (INGUD)',
    },
    {
        CITY: 'TUGAYA',
        BARANGAY: 'PUTAD',
    },
    {
        CITY: 'TUGAYA',
        BARANGAY: 'RAYA',
    },
    {
        CITY: 'TUGAYA',
        BARANGAY: 'SUGOD I',
    },
    {
        CITY: 'TUGAYA',
        BARANGAY: 'SUGOD MAWATAN',
    },
    {
        CITY: 'TUGAYA',
        BARANGAY: 'SUMBAGA ROGONG',
    },
    {
        CITY: 'TUGAYA',
        BARANGAY: 'TANGCAL',
    },
    {
        CITY: 'WAO',
        BARANGAY: 'AMOYONG',
    },
    {
        CITY: 'WAO',
        BARANGAY: 'BALATIN',
    },
    {
        CITY: 'WAO',
        BARANGAY: 'BANGA',
    },
    {
        CITY: 'WAO',
        BARANGAY: 'BO-OT',
    },
    {
        CITY: 'WAO',
        BARANGAY: 'BUNTONGUN',
    },
    {
        CITY: 'WAO',
        BARANGAY: 'CEBUANO GROUP',
    },
    {
        CITY: 'WAO',
        BARANGAY: 'CHRISTIAN VILLAGE',
    },
    {
        CITY: 'WAO',
        BARANGAY: 'EASTERN WAO',
    },
    {
        CITY: 'WAO',
        BARANGAY: 'EXTENSION POBLACION',
    },
    {
        CITY: 'WAO',
        BARANGAY: 'GATA',
    },
    {
        CITY: 'WAO',
        BARANGAY: 'KABATANGAN',
    },
    {
        CITY: 'WAO',
        BARANGAY: 'KADINGILAN',
    },
    {
        CITY: 'WAO',
        BARANGAY: 'KATUTUNGAN (POB.)',
    },
    {
        CITY: 'WAO',
        BARANGAY: 'KILIKILI EAST',
    },
    {
        CITY: 'WAO',
        BARANGAY: 'KILIKILI WEST',
    },
    {
        CITY: 'WAO',
        BARANGAY: 'MALAIGANG',
    },
    {
        CITY: 'WAO',
        BARANGAY: 'MANILA GROUP',
    },
    {
        CITY: 'WAO',
        BARANGAY: 'MILAYA',
    },
    {
        CITY: 'WAO',
        BARANGAY: 'MIMBUAYA',
    },
    {
        CITY: 'WAO',
        BARANGAY: 'MUSLIM VILLAGE',
    },
    {
        CITY: 'WAO',
        BARANGAY: 'PAGALONGAN',
    },
    {
        CITY: 'WAO',
        BARANGAY: 'PANANG',
    },
    {
        CITY: 'WAO',
        BARANGAY: 'PARK AREA (POB.)',
    },
    {
        CITY: 'WAO',
        BARANGAY: 'PILINTANGAN',
    },
    {
        CITY: 'WAO',
        BARANGAY: 'SERRAN VILLAGE',
    },
    {
        CITY: 'WAO',
        BARANGAY: 'WESTERN WAO (POB.)',
    },
    {
        CITY: 'BONGAO',
        BARANGAY: 'BONGAO POBLACION',
    },
    {
        CITY: 'BONGAO',
        BARANGAY: 'BONGAO-POBLACION',
    },
    {
        CITY: 'BONGAO',
        BARANGAY: 'IPIL',
    },
    {
        CITY: 'BONGAO',
        BARANGAY: 'KAMAGONG',
    },
    {
        CITY: 'BONGAO',
        BARANGAY: 'KARUNGDONG',
    },
    {
        CITY: 'BONGAO',
        BARANGAY: 'LAGASAN',
    },
    {
        CITY: 'BONGAO',
        BARANGAY: 'LAKIT LAKIT',
    },
    {
        CITY: 'BONGAO',
        BARANGAY: 'LAMION',
    },
    {
        CITY: 'BONGAO',
        BARANGAY: 'LAPID LAPID',
    },
    {
        CITY: 'BONGAO',
        BARANGAY: 'LATO LATO',
    },
    {
        CITY: 'BONGAO',
        BARANGAY: 'LUUK PANDAN',
    },
    {
        CITY: 'BONGAO',
        BARANGAY: 'LUUK TULAY',
    },
    {
        CITY: 'BONGAO',
        BARANGAY: 'MALASSA',
    },
    {
        CITY: 'BONGAO',
        BARANGAY: 'MANDULAN',
    },
    {
        CITY: 'BONGAO',
        BARANGAY: 'MASANTONG',
    },
    {
        CITY: 'BONGAO',
        BARANGAY: 'MONTAY MONTAY',
    },
    {
        CITY: 'BONGAO',
        BARANGAY: 'NALIL',
    },
    {
        CITY: 'BONGAO',
        BARANGAY: 'PABABAG',
    },
    {
        CITY: 'BONGAO',
        BARANGAY: 'PAG-ASA',
    },
    {
        CITY: 'BONGAO',
        BARANGAY: 'PAGASINAN',
    },
    {
        CITY: 'BONGAO',
        BARANGAY: 'PAGATPAT',
    },
    {
        CITY: 'BONGAO',
        BARANGAY: 'PAHUT',
    },
    {
        CITY: 'BONGAO',
        BARANGAY: 'PAKIAS',
    },
    {
        CITY: 'BONGAO',
        BARANGAY: 'PANIONGAN',
    },
    {
        CITY: 'BONGAO',
        BARANGAY: 'PASIAGAN',
    },
    {
        CITY: 'BONGAO',
        BARANGAY: 'SANGA-SANGA',
    },
    {
        CITY: 'BONGAO',
        BARANGAY: 'SILUBOG',
    },
    {
        CITY: 'BONGAO',
        BARANGAY: 'SIMANDAGIT',
    },
    {
        CITY: 'BONGAO',
        BARANGAY: 'SUMANGAT',
    },
    {
        CITY: 'BONGAO',
        BARANGAY: 'TARAWAKAN',
    },
    {
        CITY: 'BONGAO',
        BARANGAY: 'TONGSINAH',
    },
    {
        CITY: 'BONGAO',
        BARANGAY: 'TUBIG BASAG',
    },
    {
        CITY: 'BONGAO',
        BARANGAY: 'TUBIG TANAH',
    },
    {
        CITY: 'BONGAO',
        BARANGAY: 'TUBIG-BOH',
    },
    {
        CITY: 'BONGAO',
        BARANGAY: 'TUBIG-MAMPALLAM',
    },
    {
        CITY: 'BONGAO',
        BARANGAY: 'UNGUS-UNGUS',
    },
    {
        CITY: 'LANGUYAN',
        BARANGAY: 'ADNIN',
    },
    {
        CITY: 'LANGUYAN',
        BARANGAY: 'BAKAW-BAKAW',
    },
    {
        CITY: 'LANGUYAN',
        BARANGAY: 'BAKONG',
    },
    {
        CITY: 'LANGUYAN',
        BARANGAY: 'BAS-BAS PROPER',
    },
    {
        CITY: 'LANGUYAN',
        BARANGAY: 'BASLIKUD',
    },
    {
        CITY: 'LANGUYAN',
        BARANGAY: 'BASNUNUK',
    },
    {
        CITY: 'LANGUYAN',
        BARANGAY: 'DARUSSALAM',
    },
    {
        CITY: 'LANGUYAN',
        BARANGAY: 'JAKARTA (LOOKAN LATUAN)',
    },
    {
        CITY: 'LANGUYAN',
        BARANGAY: 'KALUPAG',
    },
    {
        CITY: 'LANGUYAN',
        BARANGAY: 'KINIKTAL',
    },
    {
        CITY: 'LANGUYAN',
        BARANGAY: 'LANGUYAN PROPER (POB.)',
    },
    {
        CITY: 'LANGUYAN',
        BARANGAY: 'MARANG-MARANG',
    },
    {
        CITY: 'LANGUYAN',
        BARANGAY: 'MARANING',
    },
    {
        CITY: 'LANGUYAN',
        BARANGAY: 'PARANG PANTAY',
    },
    {
        CITY: 'LANGUYAN',
        BARANGAY: 'SIKULLIS',
    },
    {
        CITY: 'LANGUYAN',
        BARANGAY: 'SIMALAK',
    },
    {
        CITY: 'LANGUYAN',
        BARANGAY: 'TUBIG DAKULA',
    },
    {
        CITY: 'LANGUYAN',
        BARANGAY: 'TUHOG-TUHOG',
    },
    {
        CITY: 'LANGUYAN',
        BARANGAY: 'TUMAHUBONG',
    },
    {
        CITY: 'LANGUYAN',
        BARANGAY: 'TUMBAGAAN',
    },
    {
        CITY: 'MAPUN',
        BARANGAY: 'BOKI',
    },
    {
        CITY: 'MAPUN',
        BARANGAY: 'DUHUL BATU',
    },
    {
        CITY: 'MAPUN',
        BARANGAY: 'EROK-EROK',
    },
    {
        CITY: 'MAPUN',
        BARANGAY: 'GUPPAH',
    },
    {
        CITY: 'MAPUN',
        BARANGAY: 'KOMPANG',
    },
    {
        CITY: 'MAPUN',
        BARANGAY: 'LIYUBUD',
    },
    {
        CITY: 'MAPUN',
        BARANGAY: 'LUBBAK PARANG',
    },
    {
        CITY: 'MAPUN',
        BARANGAY: 'LUPA PULA (POB.)',
    },
    {
        CITY: 'MAPUN',
        BARANGAY: 'MAHALO',
    },
    {
        CITY: 'MAPUN',
        BARANGAY: 'PAWAN',
    },
    {
        CITY: 'MAPUN',
        BARANGAY: 'SAPA',
    },
    {
        CITY: 'MAPUN',
        BARANGAY: 'SIKUB',
    },
    {
        CITY: 'MAPUN',
        BARANGAY: 'TABULIAN',
    },
    {
        CITY: 'MAPUN',
        BARANGAY: 'TANDUAN',
    },
    {
        CITY: 'MAPUN',
        BARANGAY: 'UMUS MATAHA',
    },
    {
        CITY: 'PANGLIMA-SUGALA',
        BARANGAY: 'BALIMBING PROPER',
    },
    {
        CITY: 'PANGLIMA-SUGALA',
        BARANGAY: 'BATU-BATU (POB.)',
    },
    {
        CITY: 'PANGLIMA-SUGALA',
        BARANGAY: 'BAUNO GARING',
    },
    {
        CITY: 'PANGLIMA-SUGALA',
        BARANGAY: 'BELATAN HALU',
    },
    {
        CITY: 'PANGLIMA-SUGALA',
        BARANGAY: 'BUAN',
    },
    {
        CITY: 'PANGLIMA-SUGALA',
        BARANGAY: 'DUNGON',
    },
    {
        CITY: 'PANGLIMA-SUGALA',
        BARANGAY: 'KARAHA',
    },
    {
        CITY: 'PANGLIMA-SUGALA',
        BARANGAY: 'KULAPE',
    },
    {
        CITY: 'PANGLIMA-SUGALA',
        BARANGAY: 'LIYABURAN',
    },
    {
        CITY: 'PANGLIMA-SUGALA',
        BARANGAY: 'LUUK BUNTAL',
    },
    {
        CITY: 'PANGLIMA-SUGALA',
        BARANGAY: 'MAGSAGGAW',
    },
    {
        CITY: 'PANGLIMA-SUGALA',
        BARANGAY: 'MALACCA',
    },
    {
        CITY: 'PANGLIMA-SUGALA',
        BARANGAY: 'PARANGAN',
    },
    {
        CITY: 'PANGLIMA-SUGALA',
        BARANGAY: 'SUMANGDAY',
    },
    {
        CITY: 'PANGLIMA-SUGALA',
        BARANGAY: 'TABUNAN',
    },
    {
        CITY: 'PANGLIMA-SUGALA',
        BARANGAY: 'TUNDON',
    },
    {
        CITY: 'PANGLIMA-SUGALA',
        BARANGAY: 'TUNGBANGKAW',
    },
    {
        CITY: 'SAPA-SAPA',
        BARANGAY: 'BALDATAL ISLAM',
    },
    {
        CITY: 'SAPA-SAPA',
        BARANGAY: 'BUTUN',
    },
    {
        CITY: 'SAPA-SAPA',
        BARANGAY: 'DALO-DALO',
    },
    {
        CITY: 'SAPA-SAPA',
        BARANGAY: 'KOHEC',
    },
    {
        CITY: 'SAPA-SAPA',
        BARANGAY: 'LAKIT-LAKIT',
    },
    {
        CITY: 'SAPA-SAPA',
        BARANGAY: 'LATUAN (SUASANG)',
    },
    {
        CITY: 'SAPA-SAPA',
        BARANGAY: 'LOOK NATUH',
    },
    {
        CITY: 'SAPA-SAPA',
        BARANGAY: 'LOOKAN BANARAN',
    },
    {
        CITY: 'SAPA-SAPA',
        BARANGAY: 'LOOKAN LATUAN',
    },
    {
        CITY: 'SAPA-SAPA',
        BARANGAY: 'MALANTA',
    },
    {
        CITY: 'SAPA-SAPA',
        BARANGAY: 'MANTABUAN TABUNAN',
    },
    {
        CITY: 'SAPA-SAPA',
        BARANGAY: 'NUNUK LIKUD SIKUBONG',
    },
    {
        CITY: 'SAPA-SAPA',
        BARANGAY: 'PALATE GADJAMINAH',
    },
    {
        CITY: 'SAPA-SAPA',
        BARANGAY: 'PAMASAN',
    },
    {
        CITY: 'SAPA-SAPA',
        BARANGAY: 'SAPAAT',
    },
    {
        CITY: 'SAPA-SAPA',
        BARANGAY: 'SAPA-SAPA (POB.)',
    },
    {
        CITY: 'SAPA-SAPA',
        BARANGAY: 'SUKAH-SUKAH',
    },
    {
        CITY: 'SAPA-SAPA',
        BARANGAY: 'TABUNAN LIKUD SIKUBONG',
    },
    {
        CITY: 'SAPA-SAPA',
        BARANGAY: 'TANGNGAH (LALUNG SIKUBONG)',
    },
    {
        CITY: 'SAPA-SAPA',
        BARANGAY: 'TAPIAN BOHE NORTH',
    },
    {
        CITY: 'SAPA-SAPA',
        BARANGAY: 'TAPIAN BOHE SOUTH',
    },
    {
        CITY: 'SAPA-SAPA',
        BARANGAY: 'TONGGUSONG BANARAN',
    },
    {
        CITY: 'SAPA-SAPA',
        BARANGAY: 'TUP-TUP BANARAN',
    },
    {
        CITY: 'SIBUTU',
        BARANGAY: 'AMBULONG SAPAL',
    },
    {
        CITY: 'SIBUTU',
        BARANGAY: 'DATU AMILHAMJA JAAFAR',
    },
    {
        CITY: 'SIBUTU',
        BARANGAY: 'HADJI IMAM BIDIN',
    },
    {
        CITY: 'SIBUTU',
        BARANGAY: 'HADJI MOHTAR SULAYMAN',
    },
    {
        CITY: 'SIBUTU',
        BARANGAY: 'HADJI TAHA',
    },
    {
        CITY: 'SIBUTU',
        BARANGAY: 'IMAM HADJI MOHAMMAD',
    },
    {
        CITY: 'SIBUTU',
        BARANGAY: 'LIGAYAN',
    },
    {
        CITY: 'SIBUTU',
        BARANGAY: 'NUNUKAN',
    },
    {
        CITY: 'SIBUTU',
        BARANGAY: 'SHEIK MAKDUM',
    },
    {
        CITY: 'SIBUTU',
        BARANGAY: 'SIBUTU (POB.)',
    },
    {
        CITY: 'SIBUTU',
        BARANGAY: 'TALISAY',
    },
    {
        CITY: 'SIBUTU',
        BARANGAY: 'TANDU BANAK',
    },
    {
        CITY: 'SIBUTU',
        BARANGAY: 'TAUNGOH',
    },
    {
        CITY: 'SIBUTU',
        BARANGAY: 'TONGEHAT',
    },
    {
        CITY: 'SIBUTU',
        BARANGAY: 'TONGSIBALO',
    },
    {
        CITY: 'SIBUTU',
        BARANGAY: 'UNGUS-UNGUS',
    },
    {
        CITY: 'SIMUNUL',
        BARANGAY: 'BAGID',
    },
    {
        CITY: 'SIMUNUL',
        BARANGAY: 'BAKONG',
    },
    {
        CITY: 'SIMUNUL',
        BARANGAY: 'DOH-TONG',
    },
    {
        CITY: 'SIMUNUL',
        BARANGAY: 'LUUK DATAN',
    },
    {
        CITY: 'SIMUNUL',
        BARANGAY: 'MANUK MANGKAW',
    },
    {
        CITY: 'SIMUNUL',
        BARANGAY: 'MARUWA',
    },
    {
        CITY: 'SIMUNUL',
        BARANGAY: 'MONGKAY',
    },
    {
        CITY: 'SIMUNUL',
        BARANGAY: 'PAGASINAN',
    },
    {
        CITY: 'SIMUNUL',
        BARANGAY: 'PANGLIMA MASTUL',
    },
    {
        CITY: 'SIMUNUL',
        BARANGAY: 'SUKAH-BULAN',
    },
    {
        CITY: 'SIMUNUL',
        BARANGAY: 'TAMPAKAN (POB.)',
    },
    {
        CITY: 'SIMUNUL',
        BARANGAY: 'TIMUNDON',
    },
    {
        CITY: 'SIMUNUL',
        BARANGAY: 'TONGGOSONG',
    },
    {
        CITY: 'SIMUNUL',
        BARANGAY: 'TUBIG INDANGAN',
    },
    {
        CITY: 'SIMUNUL',
        BARANGAY: 'UBOL',
    },
    {
        CITY: 'SITANGKAI',
        BARANGAY: 'DATU BAGUINDA PUTIH',
    },
    {
        CITY: 'SITANGKAI',
        BARANGAY: 'IMAM SAPIE',
    },
    {
        CITY: 'SITANGKAI',
        BARANGAY: 'NORTH LARAP',
    },
    {
        CITY: 'SITANGKAI',
        BARANGAY: 'PANGLIMA ALARI',
    },
    {
        CITY: 'SITANGKAI',
        BARANGAY: 'SIPANGKOT',
    },
    {
        CITY: 'SITANGKAI',
        BARANGAY: 'SITANGKAI POBLACION',
    },
    {
        CITY: 'SITANGKAI',
        BARANGAY: 'SOUTH LARAP (LARAP)',
    },
    {
        CITY: 'SITANGKAI',
        BARANGAY: 'TONGMAGENG',
    },
    {
        CITY: 'SITANGKAI',
        BARANGAY: 'TONGUSONG',
    },
    {
        CITY: 'SOUTH-UBIAN',
        BARANGAY: 'BABAGAN',
    },
    {
        CITY: 'SOUTH-UBIAN',
        BARANGAY: 'BENGKOL',
    },
    {
        CITY: 'SOUTH-UBIAN',
        BARANGAY: 'BINTAWLAN',
    },
    {
        CITY: 'SOUTH-UBIAN',
        BARANGAY: 'BOHE',
    },
    {
        CITY: 'SOUTH-UBIAN',
        BARANGAY: 'BUBUAN',
    },
    {
        CITY: 'SOUTH-UBIAN',
        BARANGAY: 'BUNAY BUNAY CENTER',
    },
    {
        CITY: 'SOUTH-UBIAN',
        BARANGAY: 'BUNAY BUNAY LOOKAN',
    },
    {
        CITY: 'SOUTH-UBIAN',
        BARANGAY: 'BUNAY BUNAY TONG',
    },
    {
        CITY: 'SOUTH-UBIAN',
        BARANGAY: 'EAST TALISAY',
    },
    {
        CITY: 'SOUTH-UBIAN',
        BARANGAY: 'LAHAD DAMPONG',
    },
    {
        CITY: 'SOUTH-UBIAN',
        BARANGAY: 'LAITAN',
    },
    {
        CITY: 'SOUTH-UBIAN',
        BARANGAY: 'LAMBI-LAMBIAN',
    },
    {
        CITY: 'SOUTH-UBIAN',
        BARANGAY: 'LAUD',
    },
    {
        CITY: 'SOUTH-UBIAN',
        BARANGAY: 'LIKUD DAMPONG',
    },
    {
        CITY: 'SOUTH-UBIAN',
        BARANGAY: 'LIKUD TABAWAN',
    },
    {
        CITY: 'SOUTH-UBIAN',
        BARANGAY: 'NUNUK',
    },
    {
        CITY: 'SOUTH-UBIAN',
        BARANGAY: 'NUSA',
    },
    {
        CITY: 'SOUTH-UBIAN',
        BARANGAY: 'NUSA-NUSA',
    },
    {
        CITY: 'SOUTH-UBIAN',
        BARANGAY: 'PAMPANG',
    },
    {
        CITY: 'SOUTH-UBIAN',
        BARANGAY: 'PUTAT',
    },
    {
        CITY: 'SOUTH-UBIAN',
        BARANGAY: 'SOLLOGAN',
    },
    {
        CITY: 'SOUTH-UBIAN',
        BARANGAY: 'TALISAY',
    },
    {
        CITY: 'SOUTH-UBIAN',
        BARANGAY: 'TAMPAKAN DAMPONG',
    },
    {
        CITY: 'SOUTH-UBIAN',
        BARANGAY: 'TANGNGAH',
    },
    {
        CITY: 'SOUTH-UBIAN',
        BARANGAY: 'TINDA-TINDAHAN',
    },
    {
        CITY: 'SOUTH-UBIAN',
        BARANGAY: 'TONG TAMPAKAN',
    },
    {
        CITY: 'SOUTH-UBIAN',
        BARANGAY: 'TUBIG DAYANG',
    },
    {
        CITY: 'SOUTH-UBIAN',
        BARANGAY: 'TUBIG DAYANG CENTER',
    },
    {
        CITY: 'SOUTH-UBIAN',
        BARANGAY: 'TUBIG DAYANG RIVERSIDE',
    },
    {
        CITY: 'SOUTH-UBIAN',
        BARANGAY: 'TUKKAI',
    },
    {
        CITY: 'SOUTH-UBIAN',
        BARANGAY: 'UNAS-UNAS',
    },
    {
        CITY: 'TANDUBAS',
        BARANGAY: 'BALIUNGAN',
    },
    {
        CITY: 'TANDUBAS',
        BARANGAY: 'BALLAK',
    },
    {
        CITY: 'TANDUBAS',
        BARANGAY: 'BUTUN',
    },
    {
        CITY: 'TANDUBAS',
        BARANGAY: 'HIMBAH',
    },
    {
        CITY: 'TANDUBAS',
        BARANGAY: 'KAKOONG',
    },
    {
        CITY: 'TANDUBAS',
        BARANGAY: 'KALANG-KALANG',
    },
    {
        CITY: 'TANDUBAS',
        BARANGAY: 'KEPENG',
    },
    {
        CITY: 'TANDUBAS',
        BARANGAY: 'LAHAY-LAHAY',
    },
    {
        CITY: 'TANDUBAS',
        BARANGAY: 'NAUNGAN',
    },
    {
        CITY: 'TANDUBAS',
        BARANGAY: 'SALAMAT',
    },
    {
        CITY: 'TANDUBAS',
        BARANGAY: 'SALLANGAN',
    },
    {
        CITY: 'TANDUBAS',
        BARANGAY: 'SAPA',
    },
    {
        CITY: 'TANDUBAS',
        BARANGAY: 'SIBAKLOON',
    },
    {
        CITY: 'TANDUBAS',
        BARANGAY: 'SILANTUP',
    },
    {
        CITY: 'TANDUBAS',
        BARANGAY: 'TANDUBATO',
    },
    {
        CITY: 'TANDUBAS',
        BARANGAY: 'TANGNGAH (TANGNGAH UNGUS MATATA)',
    },
    {
        CITY: 'TANDUBAS',
        BARANGAY: 'TAPIAN',
    },
    {
        CITY: 'TANDUBAS',
        BARANGAY: 'TAPIAN SUKAH',
    },
    {
        CITY: 'TANDUBAS',
        BARANGAY: 'TARUK',
    },
    {
        CITY: 'TANDUBAS',
        BARANGAY: 'TONGBANGKAW',
    },
    {
        CITY: 'TURTLE-ISLANDS',
        BARANGAY: 'LIKUD BAKKAO',
    },
    {
        CITY: 'TURTLE-ISLANDS',
        BARANGAY: 'TAGANAK POBLACION',
    },
    {
        CITY: 'HADJI-PANGLIMA-TAHIL',
        BARANGAY: 'BANGAS (POB.)',
    },
    {
        CITY: 'HADJI-PANGLIMA-TAHIL',
        BARANGAY: 'BUBUAN',
    },
    {
        CITY: 'HADJI-PANGLIMA-TAHIL',
        BARANGAY: 'KABUUKAN',
    },
    {
        CITY: 'HADJI-PANGLIMA-TAHIL',
        BARANGAY: 'PAG-ASINAN',
    },
    {
        CITY: 'HADJI-PANGLIMA-TAHIL',
        BARANGAY: 'TEOMABAL',
    },
    {
        CITY: 'INDANAN',
        BARANGAY: 'ADJID',
    },
    {
        CITY: 'INDANAN',
        BARANGAY: 'BANGALAN',
    },
    {
        CITY: 'INDANAN',
        BARANGAY: 'BATO-BATO',
    },
    {
        CITY: 'INDANAN',
        BARANGAY: 'BUANZA',
    },
    {
        CITY: 'INDANAN',
        BARANGAY: 'BUD-TARAN',
    },
    {
        CITY: 'INDANAN',
        BARANGAY: 'BUNUT',
    },
    {
        CITY: 'INDANAN',
        BARANGAY: 'JATI-TUNGGAL',
    },
    {
        CITY: 'INDANAN',
        BARANGAY: 'KABBON MAAS',
    },
    {
        CITY: 'INDANAN',
        BARANGAY: 'KAGAY',
    },
    {
        CITY: 'INDANAN',
        BARANGAY: 'KAJATIAN',
    },
    {
        CITY: 'INDANAN',
        BARANGAY: 'KAN ISLAM',
    },
    {
        CITY: 'INDANAN',
        BARANGAY: 'KANDANG TUKAY',
    },
    {
        CITY: 'INDANAN',
        BARANGAY: 'KARAWAN',
    },
    {
        CITY: 'INDANAN',
        BARANGAY: 'KATIAN',
    },
    {
        CITY: 'INDANAN',
        BARANGAY: 'KUPPONG',
    },
    {
        CITY: 'INDANAN',
        BARANGAY: 'LAMBAYONG',
    },
    {
        CITY: 'INDANAN',
        BARANGAY: 'LANGPAS',
    },
    {
        CITY: 'INDANAN',
        BARANGAY: 'LICUP',
    },
    {
        CITY: 'INDANAN',
        BARANGAY: 'MALIMBAYA',
    },
    {
        CITY: 'INDANAN',
        BARANGAY: 'MANGGIS',
    },
    {
        CITY: 'INDANAN',
        BARANGAY: 'MANILOP',
    },
    {
        CITY: 'INDANAN',
        BARANGAY: 'PALIGUE',
    },
    {
        CITY: 'INDANAN',
        BARANGAY: 'PANABUAN',
    },
    {
        CITY: 'INDANAN',
        BARANGAY: 'PANGLIMA MISUARI (SASAK)',
    },
    {
        CITY: 'INDANAN',
        BARANGAY: 'PASIL',
    },
    {
        CITY: 'INDANAN',
        BARANGAY: 'POBLACION (INDANAN)',
    },
    {
        CITY: 'INDANAN',
        BARANGAY: 'SAPAH MALAUM',
    },
    {
        CITY: 'INDANAN',
        BARANGAY: 'SAWAKI',
    },
    {
        CITY: 'INDANAN',
        BARANGAY: 'SIONOGAN',
    },
    {
        CITY: 'INDANAN',
        BARANGAY: 'TAGBAK',
    },
    {
        CITY: 'INDANAN',
        BARANGAY: 'TIMBANGAN',
    },
    {
        CITY: 'INDANAN',
        BARANGAY: 'TUBIG DAKULAH',
    },
    {
        CITY: 'INDANAN',
        BARANGAY: 'TUBIG PARANG',
    },
    {
        CITY: 'INDANAN',
        BARANGAY: 'TUMANTANGIS',
    },
    {
        CITY: 'JOLO',
        BARANGAY: 'ALAT',
    },
    {
        CITY: 'JOLO',
        BARANGAY: 'ASTURIAS',
    },
    {
        CITY: 'JOLO',
        BARANGAY: 'BUS-BUS',
    },
    {
        CITY: 'JOLO',
        BARANGAY: 'CHINESE PIER',
    },
    {
        CITY: 'JOLO',
        BARANGAY: 'SAN RAYMUNDO',
    },
    {
        CITY: 'JOLO',
        BARANGAY: 'TAKUT-TAKUT',
    },
    {
        CITY: 'JOLO',
        BARANGAY: 'TULAY',
    },
    {
        CITY: 'JOLO',
        BARANGAY: 'WALLED CITY (POB.)',
    },
    {
        CITY: 'KALINGALAN-CALUANG',
        BARANGAY: 'KAMBING',
    },
    {
        CITY: 'KALINGALAN-CALUANG',
        BARANGAY: 'KANLAGAY',
    },
    {
        CITY: 'KALINGALAN-CALUANG',
        BARANGAY: 'KARUNGDONG (POB.)',
    },
    {
        CITY: 'KALINGALAN-CALUANG',
        BARANGAY: 'MASJID BAYLE',
    },
    {
        CITY: 'KALINGALAN-CALUANG',
        BARANGAY: 'MASJID PUNJUNGAN',
    },
    {
        CITY: 'KALINGALAN-CALUANG',
        BARANGAY: 'PANG',
    },
    {
        CITY: 'KALINGALAN-CALUANG',
        BARANGAY: 'PANGDAN PANGDAN',
    },
    {
        CITY: 'KALINGALAN-CALUANG',
        BARANGAY: 'PITOGO',
    },
    {
        CITY: 'KALINGALAN-CALUANG',
        BARANGAY: 'TUNGGOL',
    },
    {
        CITY: 'LUGUS',
        BARANGAY: 'ALU BUS-BUS',
    },
    {
        CITY: 'LUGUS',
        BARANGAY: 'ALU-DUYONG',
    },
    {
        CITY: 'LUGUS',
        BARANGAY: 'BAS LUGUS',
    },
    {
        CITY: 'LUGUS',
        BARANGAY: 'GAPAS RUGASAN',
    },
    {
        CITY: 'LUGUS',
        BARANGAY: 'GAPAS TUBIG TUWAK',
    },
    {
        CITY: 'LUGUS',
        BARANGAY: 'HUWIT-HUWIT BAS NONOK',
    },
    {
        CITY: 'LUGUS',
        BARANGAY: 'HUWIT-HUWIT PROPER',
    },
    {
        CITY: 'LUGUS',
        BARANGAY: 'KUTAH PARANG',
    },
    {
        CITY: 'LUGUS',
        BARANGAY: 'LAHA',
    },
    {
        CITY: 'LUGUS',
        BARANGAY: 'LARAP',
    },
    {
        CITY: 'LUGUS',
        BARANGAY: 'LUGUS PROPER',
    },
    {
        CITY: 'LUGUS',
        BARANGAY: 'MANGKALLAY',
    },
    {
        CITY: 'LUGUS',
        BARANGAY: 'MANTAN',
    },
    {
        CITY: 'LUGUS',
        BARANGAY: 'PAIT',
    },
    {
        CITY: 'LUGUS',
        BARANGAY: 'PARIAN KAYAWAN',
    },
    {
        CITY: 'LUGUS',
        BARANGAY: 'SIBUL',
    },
    {
        CITY: 'LUGUS',
        BARANGAY: 'TINGKANGAN',
    },
    {
        CITY: 'LUUK',
        BARANGAY: 'BUAL',
    },
    {
        CITY: 'LUUK',
        BARANGAY: 'GUIMBAUN',
    },
    {
        CITY: 'LUUK',
        BARANGAY: 'KAN-BULAK',
    },
    {
        CITY: 'LUUK',
        BARANGAY: 'KAN-MINDUS',
    },
    {
        CITY: 'LUUK',
        BARANGAY: 'LAMBAGO',
    },
    {
        CITY: 'LUUK',
        BARANGAY: 'LIANUTAN',
    },
    {
        CITY: 'LUUK',
        BARANGAY: 'LINGAH',
    },
    {
        CITY: 'LUUK',
        BARANGAY: 'MANANTI',
    },
    {
        CITY: 'LUUK',
        BARANGAY: 'NIOG-NIOG',
    },
    {
        CITY: 'LUUK',
        BARANGAY: 'TANDU-BATO',
    },
    {
        CITY: 'LUUK',
        BARANGAY: 'TUBIG-PUTI (POB.)',
    },
    {
        CITY: 'LUUK',
        BARANGAY: 'TULAYAN ISLAND',
    },
    {
        CITY: 'MAIMBUNG',
        BARANGAY: 'ANAK JATI',
    },
    {
        CITY: 'MAIMBUNG',
        BARANGAY: 'BATO UGIS',
    },
    {
        CITY: 'MAIMBUNG',
        BARANGAY: 'BUALO LAHI',
    },
    {
        CITY: 'MAIMBUNG',
        BARANGAY: 'BUALO LIPID',
    },
    {
        CITY: 'MAIMBUNG',
        BARANGAY: 'BULABOG',
    },
    {
        CITY: 'MAIMBUNG',
        BARANGAY: 'DUHOL KABBON',
    },
    {
        CITY: 'MAIMBUNG',
        BARANGAY: 'GULANGAN',
    },
    {
        CITY: 'MAIMBUNG',
        BARANGAY: 'IPIL',
    },
    {
        CITY: 'MAIMBUNG',
        BARANGAY: 'KANDANG',
    },
    {
        CITY: 'MAIMBUNG',
        BARANGAY: 'KAPOK-PUNGGOL',
    },
    {
        CITY: 'MAIMBUNG',
        BARANGAY: 'KULASI',
    },
    {
        CITY: 'MAIMBUNG',
        BARANGAY: 'LABAH',
    },
    {
        CITY: 'MAIMBUNG',
        BARANGAY: 'LAGASAN ASIBIH',
    },
    {
        CITY: 'MAIMBUNG',
        BARANGAY: 'LANTONG',
    },
    {
        CITY: 'MAIMBUNG',
        BARANGAY: 'LAPA',
    },
    {
        CITY: 'MAIMBUNG',
        BARANGAY: 'LAUD KULASI',
    },
    {
        CITY: 'MAIMBUNG',
        BARANGAY: 'LAUM MAIMBUNG',
    },
    {
        CITY: 'MAIMBUNG',
        BARANGAY: 'LOWER TAMBAKING',
    },
    {
        CITY: 'MAIMBUNG',
        BARANGAY: 'LUNGGANG',
    },
    {
        CITY: 'MAIMBUNG',
        BARANGAY: 'MATATAL',
    },
    {
        CITY: 'MAIMBUNG',
        BARANGAY: 'PATAO',
    },
    {
        CITY: 'MAIMBUNG',
        BARANGAY: 'POBLACION (MAIMBUNG)',
    },
    {
        CITY: 'MAIMBUNG',
        BARANGAY: 'RATAG LIMBON',
    },
    {
        CITY: 'MAIMBUNG',
        BARANGAY: 'TABU-BATO',
    },
    {
        CITY: 'MAIMBUNG',
        BARANGAY: 'TANDU PATONG',
    },
    {
        CITY: 'MAIMBUNG',
        BARANGAY: 'TUBIG-SAMIN',
    },
    {
        CITY: 'MAIMBUNG',
        BARANGAY: 'UPPER TAMBAKING',
    },
    {
        CITY: 'OLD-PANAMAO',
        BARANGAY: 'ASIN',
    },
    {
        CITY: 'OLD-PANAMAO',
        BARANGAY: 'BAKUD',
    },
    {
        CITY: 'OLD-PANAMAO',
        BARANGAY: 'BANGDAY',
    },
    {
        CITY: 'OLD-PANAMAO',
        BARANGAY: 'BAUNOH',
    },
    {
        CITY: 'OLD-PANAMAO',
        BARANGAY: 'BITANAG',
    },
    {
        CITY: 'OLD-PANAMAO',
        BARANGAY: 'BUD SEIT',
    },
    {
        CITY: 'OLD-PANAMAO',
        BARANGAY: 'BULANGSI',
    },
    {
        CITY: 'OLD-PANAMAO',
        BARANGAY: 'DATAG',
    },
    {
        CITY: 'OLD-PANAMAO',
        BARANGAY: 'KAMALIG',
    },
    {
        CITY: 'OLD-PANAMAO',
        BARANGAY: 'KAN ASAALI',
    },
    {
        CITY: 'OLD-PANAMAO',
        BARANGAY: 'KAN UKOL',
    },
    {
        CITY: 'OLD-PANAMAO',
        BARANGAY: 'KAN-DAYOK',
    },
    {
        CITY: 'OLD-PANAMAO',
        BARANGAY: 'KAN-SIPAT',
    },
    {
        CITY: 'OLD-PANAMAO',
        BARANGAY: 'KAWASAN',
    },
    {
        CITY: 'OLD-PANAMAO',
        BARANGAY: 'KULAY-KULAY',
    },
    {
        CITY: 'OLD-PANAMAO',
        BARANGAY: 'LAKIT',
    },
    {
        CITY: 'OLD-PANAMAO',
        BARANGAY: 'LOWER PATIBULAN',
    },
    {
        CITY: 'OLD-PANAMAO',
        BARANGAY: 'LUNGGANG',
    },
    {
        CITY: 'OLD-PANAMAO',
        BARANGAY: 'PARANG',
    },
    {
        CITY: 'OLD-PANAMAO',
        BARANGAY: 'PUGAD MANAUL',
    },
    {
        CITY: 'OLD-PANAMAO',
        BARANGAY: 'PUHAGAN',
    },
    {
        CITY: 'OLD-PANAMAO',
        BARANGAY: 'SEIT HIGAD',
    },
    {
        CITY: 'OLD-PANAMAO',
        BARANGAY: 'SEIT LAKE (POB.)',
    },
    {
        CITY: 'OLD-PANAMAO',
        BARANGAY: 'SU-UH',
    },
    {
        CITY: 'OLD-PANAMAO',
        BARANGAY: 'TABU MANUK',
    },
    {
        CITY: 'OLD-PANAMAO',
        BARANGAY: 'TANDU-TANDU',
    },
    {
        CITY: 'OLD-PANAMAO',
        BARANGAY: 'TAYUNGAN',
    },
    {
        CITY: 'OLD-PANAMAO',
        BARANGAY: 'TINAH',
    },
    {
        CITY: 'OLD-PANAMAO',
        BARANGAY: 'TUBIG GANTANG',
    },
    {
        CITY: 'OLD-PANAMAO',
        BARANGAY: 'TUBIG JATI',
    },
    {
        CITY: 'OLD-PANAMAO',
        BARANGAY: 'UPPER PATIBULAN',
    },
    {
        CITY: 'OMAR',
        BARANGAY: 'ANDALAN',
    },
    {
        CITY: 'OMAR',
        BARANGAY: 'ANGILAN',
    },
    {
        CITY: 'OMAR',
        BARANGAY: 'CAPUAL ISLAND',
    },
    {
        CITY: 'OMAR',
        BARANGAY: 'HUWIT-HUWIT',
    },
    {
        CITY: 'OMAR',
        BARANGAY: 'LAHING-LAHING',
    },
    {
        CITY: 'OMAR',
        BARANGAY: 'NIANGKAAN',
    },
    {
        CITY: 'OMAR',
        BARANGAY: 'SUCUBAN',
    },
    {
        CITY: 'OMAR',
        BARANGAY: 'TANGKUAN',
    },
    {
        CITY: 'PANDAMI',
        BARANGAY: 'BALIGTANG',
    },
    {
        CITY: 'PANDAMI',
        BARANGAY: 'BUD SIBAUD',
    },
    {
        CITY: 'PANDAMI',
        BARANGAY: 'HAMBILAN',
    },
    {
        CITY: 'PANDAMI',
        BARANGAY: 'KABBON',
    },
    {
        CITY: 'PANDAMI',
        BARANGAY: 'LAHI',
    },
    {
        CITY: 'PANDAMI',
        BARANGAY: 'LAPAK',
    },
    {
        CITY: 'PANDAMI',
        BARANGAY: 'LAUD SIBAUD',
    },
    {
        CITY: 'PANDAMI',
        BARANGAY: 'MALANTA',
    },
    {
        CITY: 'PANDAMI',
        BARANGAY: 'MAMANOK',
    },
    {
        CITY: 'PANDAMI',
        BARANGAY: 'NORTH MANUBUL',
    },
    {
        CITY: 'PANDAMI',
        BARANGAY: 'PARIAN DAKULA',
    },
    {
        CITY: 'PANDAMI',
        BARANGAY: 'SIBAUD PROPER',
    },
    {
        CITY: 'PANDAMI',
        BARANGAY: 'SIGANGGANG',
    },
    {
        CITY: 'PANDAMI',
        BARANGAY: 'SOUTH MANUBUL',
    },
    {
        CITY: 'PANDAMI',
        BARANGAY: 'SUBA-SUBA',
    },
    {
        CITY: 'PANDAMI',
        BARANGAY: 'TENGA MANUBUL',
    },
    {
        CITY: 'PANGLIMA-ESTINO',
        BARANGAY: 'GAGGUIL',
    },
    {
        CITY: 'PANGLIMA-ESTINO',
        BARANGAY: 'GATA-GATA',
    },
    {
        CITY: 'PANGLIMA-ESTINO',
        BARANGAY: 'JINGGAN',
    },
    {
        CITY: 'PANGLIMA-ESTINO',
        BARANGAY: 'KAMIH-PUNGUD',
    },
    {
        CITY: 'PANGLIMA-ESTINO',
        BARANGAY: 'LIHBUG KABAW',
    },
    {
        CITY: 'PANGLIMA-ESTINO',
        BARANGAY: 'LIKBAH',
    },
    {
        CITY: 'PANGLIMA-ESTINO',
        BARANGAY: 'LUBUK-LUBUK',
    },
    {
        CITY: 'PANGLIMA-ESTINO',
        BARANGAY: 'MARSADA',
    },
    {
        CITY: 'PANGLIMA-ESTINO',
        BARANGAY: 'PAIKSA',
    },
    {
        CITY: 'PANGLIMA-ESTINO',
        BARANGAY: 'PANDAKAN',
    },
    {
        CITY: 'PANGLIMA-ESTINO',
        BARANGAY: 'PUNAY (POB.)',
    },
    {
        CITY: 'PANGLIMA-ESTINO',
        BARANGAY: 'TIPTIPON',
    },
    {
        CITY: 'PANGUTARAN',
        BARANGAY: 'ALU BUNAH',
    },
    {
        CITY: 'PANGUTARAN',
        BARANGAY: 'BANGKILAY',
    },
    {
        CITY: 'PANGUTARAN',
        BARANGAY: 'KAWITAN',
    },
    {
        CITY: 'PANGUTARAN',
        BARANGAY: 'KEHI NIOG',
    },
    {
        CITY: 'PANGUTARAN',
        BARANGAY: 'LANTONG BABAG',
    },
    {
        CITY: 'PANGUTARAN',
        BARANGAY: 'LUMAH DAPDAP',
    },
    {
        CITY: 'PANGUTARAN',
        BARANGAY: 'PANDAN NIOG',
    },
    {
        CITY: 'PANGUTARAN',
        BARANGAY: 'PANDUCAN',
    },
    {
        CITY: 'PANGUTARAN',
        BARANGAY: 'PANITIKAN',
    },
    {
        CITY: 'PANGUTARAN',
        BARANGAY: 'PATUTOL',
    },
    {
        CITY: 'PANGUTARAN',
        BARANGAY: 'SE-IPANG',
    },
    {
        CITY: 'PANGUTARAN',
        BARANGAY: 'SIMBAHAN (POB.)',
    },
    {
        CITY: 'PANGUTARAN',
        BARANGAY: 'SUANG BUNAH',
    },
    {
        CITY: 'PANGUTARAN',
        BARANGAY: 'TONGGASANG',
    },
    {
        CITY: 'PANGUTARAN',
        BARANGAY: 'TUBIG NONOK',
    },
    {
        CITY: 'PANGUTARAN',
        BARANGAY: 'TUBIG SALLANG',
    },
    {
        CITY: 'PATA',
        BARANGAY: 'ANDALAN',
    },
    {
        CITY: 'PATA',
        BARANGAY: 'DAUNGDONG',
    },
    {
        CITY: 'PATA',
        BARANGAY: 'KAMAWI',
    },
    {
        CITY: 'PATA',
        BARANGAY: 'KANJARANG',
    },
    {
        CITY: 'PATA',
        BARANGAY: 'KAYAWAN (POB.)',
    },
    {
        CITY: 'PATA',
        BARANGAY: 'KIPUT',
    },
    {
        CITY: 'PATA',
        BARANGAY: 'LIKUD',
    },
    {
        CITY: 'PATA',
        BARANGAY: 'LUUK-TULAY',
    },
    {
        CITY: 'PATA',
        BARANGAY: 'NIOG-NIOG',
    },
    {
        CITY: 'PATA',
        BARANGAY: 'PATIAN',
    },
    {
        CITY: 'PATA',
        BARANGAY: 'PISAK-PISAK',
    },
    {
        CITY: 'PATA',
        BARANGAY: 'SAIMBANGON',
    },
    {
        CITY: 'PATA',
        BARANGAY: 'SANGKAP',
    },
    {
        CITY: 'PATA',
        BARANGAY: 'TIMUDDAS',
    },
    {
        CITY: 'PATIKUL',
        BARANGAY: 'ANULING',
    },
    {
        CITY: 'PATIKUL',
        BARANGAY: 'BAKONG',
    },
    {
        CITY: 'PATIKUL',
        BARANGAY: 'BANGKAL',
    },
    {
        CITY: 'PATIKUL',
        BARANGAY: 'BONBON',
    },
    {
        CITY: 'PATIKUL',
        BARANGAY: 'BUHANGINAN (DARAYAN)',
    },
    {
        CITY: 'PATIKUL',
        BARANGAY: 'BUNGKAUNG',
    },
    {
        CITY: 'PATIKUL',
        BARANGAY: 'DANAG',
    },
    {
        CITY: 'PATIKUL',
        BARANGAY: 'GANDASULI',
    },
    {
        CITY: 'PATIKUL',
        BARANGAY: 'IGASAN',
    },
    {
        CITY: 'PATIKUL',
        BARANGAY: 'KABBON TAKAS',
    },
    {
        CITY: 'PATIKUL',
        BARANGAY: 'KADDAY MAMPALLAM',
    },
    {
        CITY: 'PATIKUL',
        BARANGAY: 'KAN AGUE',
    },
    {
        CITY: 'PATIKUL',
        BARANGAY: 'KAUNAYAN',
    },
    {
        CITY: 'PATIKUL',
        BARANGAY: 'LANGHUB',
    },
    {
        CITY: 'PATIKUL',
        BARANGAY: 'LATIH',
    },
    {
        CITY: 'PATIKUL',
        BARANGAY: 'LIANG',
    },
    {
        CITY: 'PATIKUL',
        BARANGAY: 'MALIGAY',
    },
    {
        CITY: 'PATIKUL',
        BARANGAY: 'MAUBOH',
    },
    {
        CITY: 'PATIKUL',
        BARANGAY: 'PANGDANON',
    },
    {
        CITY: 'PATIKUL',
        BARANGAY: 'PANGLAYAHAN',
    },
    {
        CITY: 'PATIKUL',
        BARANGAY: 'PANSUL',
    },
    {
        CITY: 'PATIKUL',
        BARANGAY: 'PATIKUL HIGAD',
    },
    {
        CITY: 'PATIKUL',
        BARANGAY: 'SANDAH',
    },
    {
        CITY: 'PATIKUL',
        BARANGAY: 'TAGLIBI (POB.)',
    },
    {
        CITY: 'PATIKUL',
        BARANGAY: 'TANDU-BAGUA',
    },
    {
        CITY: 'PATIKUL',
        BARANGAY: 'TANUM',
    },
    {
        CITY: 'PATIKUL',
        BARANGAY: 'TAUNG',
    },
    {
        CITY: 'PATIKUL',
        BARANGAY: 'TIMPOK',
    },
    {
        CITY: 'PATIKUL',
        BARANGAY: 'TUGAS',
    },
    {
        CITY: 'PATIKUL',
        BARANGAY: 'UMANGAY',
    },
    {
        CITY: 'SIASI',
        BARANGAY: 'BAKUD',
    },
    {
        CITY: 'SIASI',
        BARANGAY: 'BUAN',
    },
    {
        CITY: 'SIASI',
        BARANGAY: 'BULANSING TARA',
    },
    {
        CITY: 'SIASI',
        BARANGAY: 'BULIHKULLUL',
    },
    {
        CITY: 'SIASI',
        BARANGAY: 'CAMPO ISLAM',
    },
    {
        CITY: 'SIASI',
        BARANGAY: 'DUGGO',
    },
    {
        CITY: 'SIASI',
        BARANGAY: 'DUHOL TARA',
    },
    {
        CITY: 'SIASI',
        BARANGAY: 'EAST KUNGTAD',
    },
    {
        CITY: 'SIASI',
        BARANGAY: 'EAST SISANGAT',
    },
    {
        CITY: 'SIASI',
        BARANGAY: 'IPIL',
    },
    {
        CITY: 'SIASI',
        BARANGAY: 'JAMBANGAN',
    },
    {
        CITY: 'SIASI',
        BARANGAY: 'KABUBU',
    },
    {
        CITY: 'SIASI',
        BARANGAY: 'KONG-KONG LAMINUSA',
    },
    {
        CITY: 'SIASI',
        BARANGAY: 'KUD-KUD',
    },
    {
        CITY: 'SIASI',
        BARANGAY: 'KUNGTAD WEST',
    },
    {
        CITY: 'SIASI',
        BARANGAY: 'LATUNG',
    },
    {
        CITY: 'SIASI',
        BARANGAY: 'LUUK LAMINUSA',
    },
    {
        CITY: 'SIASI',
        BARANGAY: 'LUUK TARA',
    },
    {
        CITY: 'SIASI',
        BARANGAY: 'MANTA',
    },
    {
        CITY: 'SIASI',
        BARANGAY: 'MINAPAN',
    },
    {
        CITY: 'SIASI',
        BARANGAY: 'NIPA-NIPA',
    },
    {
        CITY: 'SIASI',
        BARANGAY: 'NORTH LAUD',
    },
    {
        CITY: 'SIASI',
        BARANGAY: 'NORTH MANTA',
    },
    {
        CITY: 'SIASI',
        BARANGAY: 'NORTH MUSU LAUD',
    },
    {
        CITY: 'SIASI',
        BARANGAY: 'NORTH SILUMPAK',
    },
    {
        CITY: 'SIASI',
        BARANGAY: 'PISLONG',
    },
    {
        CITY: 'SIASI',
        BARANGAY: 'POBLACION (CAMPO BARO)',
    },
    {
        CITY: 'SIASI',
        BARANGAY: 'PUNUNGAN',
    },
    {
        CITY: 'SIASI',
        BARANGAY: 'PUUKAN LAMINUSA',
    },
    {
        CITY: 'SIASI',
        BARANGAY: 'RATAG',
    },
    {
        CITY: 'SIASI',
        BARANGAY: 'SABLAY',
    },
    {
        CITY: 'SIASI',
        BARANGAY: 'SARUKOT',
    },
    {
        CITY: 'SIASI',
        BARANGAY: 'SIBURI',
    },
    {
        CITY: 'SIASI',
        BARANGAY: 'SINGKO',
    },
    {
        CITY: 'SIASI',
        BARANGAY: 'SIOLAKAN',
    },
    {
        CITY: 'SIASI',
        BARANGAY: 'SIOWING',
    },
    {
        CITY: 'SIASI',
        BARANGAY: 'SIPANDING',
    },
    {
        CITY: 'SIASI',
        BARANGAY: 'SISANGAT',
    },
    {
        CITY: 'SIASI',
        BARANGAY: 'SIUNDOH',
    },
    {
        CITY: 'SIASI',
        BARANGAY: 'SOUTH MUSU LAUD',
    },
    {
        CITY: 'SIASI',
        BARANGAY: 'SOUTH SILUMPAK',
    },
    {
        CITY: 'SIASI',
        BARANGAY: 'SOUTHWESTERN BULIKULLUL',
    },
    {
        CITY: 'SIASI',
        BARANGAY: 'SUBAH BUAYA',
    },
    {
        CITY: 'SIASI',
        BARANGAY: 'TAMPAKAN LAMINUSA',
    },
    {
        CITY: 'SIASI',
        BARANGAY: 'TENGAH LAMINUSA',
    },
    {
        CITY: 'SIASI',
        BARANGAY: 'TONG LAMINUSA',
    },
    {
        CITY: 'SIASI',
        BARANGAY: 'TONGLABAH',
    },
    {
        CITY: 'SIASI',
        BARANGAY: 'TONG-TONG',
    },
    {
        CITY: 'SIASI',
        BARANGAY: 'TUBIG KUTAH',
    },
    {
        CITY: 'SIASI',
        BARANGAY: 'TULLING',
    },
    {
        CITY: 'PARANGPARANG',
        BARANGAY: 'ALU LAYAG-LAYAG',
    },
    {
        CITY: 'PARANGPARANG',
        BARANGAY: 'ALU PANGKOH',
    },
    {
        CITY: 'PARANGPARANG',
        BARANGAY: 'BAGSAK',
    },
    {
        CITY: 'PARANGPARANG',
        BARANGAY: 'BAWISAN',
    },
    {
        CITY: 'PARANGPARANG',
        BARANGAY: 'BIID',
    },
    {
        CITY: 'PARANGPARANG',
        BARANGAY: 'BUKID',
    },
    {
        CITY: 'PARANGPARANG',
        BARANGAY: 'BULI BAWANG',
    },
    {
        CITY: 'PARANGPARANG',
        BARANGAY: 'BUTON',
    },
    {
        CITY: 'PARANGPARANG',
        BARANGAY: 'BUTON MAHABLO',
    },
    {
        CITY: 'PARANGPARANG',
        BARANGAY: 'DANAPA',
    },
    {
        CITY: 'PARANGPARANG',
        BARANGAY: 'DUYAN KABAO',
    },
    {
        CITY: 'PARANGPARANG',
        BARANGAY: 'GIMBA LAGASAN',
    },
    {
        CITY: 'PARANGPARANG',
        BARANGAY: 'KAHA',
    },
    {
        CITY: 'PARANGPARANG',
        BARANGAY: 'KAHOY SINAH',
    },
    {
        CITY: 'PARANGPARANG',
        BARANGAY: 'KANAWAY',
    },
    {
        CITY: 'PARANGPARANG',
        BARANGAY: 'KUTAH SAIRAP',
    },
    {
        CITY: 'PARANGPARANG',
        BARANGAY: 'LAGASAN HIGAD',
    },
    {
        CITY: 'PARANGPARANG',
        BARANGAY: 'LANAO DAKULA',
    },
    {
        CITY: 'PARANGPARANG',
        BARANGAY: 'LAUM BUWAHAN',
    },
    {
        CITY: 'PARANGPARANG',
        BARANGAY: 'LAUM SUWAH',
    },
    {
        CITY: 'PARANGPARANG',
        BARANGAY: 'LIANG',
    },
    {
        CITY: 'PARANGPARANG',
        BARANGAY: 'LINUHO',
    },
    {
        CITY: 'PARANGPARANG',
        BARANGAY: 'LIPUNOS',
    },
    {
        CITY: 'PARANGPARANG',
        BARANGAY: 'LOWER SAMPUNAY',
    },
    {
        CITY: 'PARANGPARANG',
        BARANGAY: 'LUMBAAN MAHABA',
    },
    {
        CITY: 'PARANGPARANG',
        BARANGAY: 'LUNGAN GITONG',
    },
    {
        CITY: 'PARANGPARANG',
        BARANGAY: 'LUPA ABU',
    },
    {
        CITY: 'PARANGPARANG',
        BARANGAY: 'NONOKAN',
    },
    {
        CITY: 'PARANGPARANG',
        BARANGAY: 'PAUGAN',
    },
    {
        CITY: 'PARANGPARANG',
        BARANGAY: 'PAYUHAN',
    },
    {
        CITY: 'PARANGPARANG',
        BARANGAY: 'PIYAHAN',
    },
    {
        CITY: 'PARANGPARANG',
        BARANGAY: 'POBLACION (PARANG)',
    },
    {
        CITY: 'PARANGPARANG',
        BARANGAY: 'SALDANG',
    },
    {
        CITY: 'PARANGPARANG',
        BARANGAY: 'SAMPUNAY',
    },
    {
        CITY: 'PARANGPARANG',
        BARANGAY: 'SILANGKAN',
    },
    {
        CITY: 'PARANGPARANG',
        BARANGAY: 'TAINGTING',
    },
    {
        CITY: 'PARANGPARANG',
        BARANGAY: 'TIKONG',
    },
    {
        CITY: 'PARANGPARANG',
        BARANGAY: 'TUKAY',
    },
    {
        CITY: 'PARANGPARANG',
        BARANGAY: 'TUMANGAS',
    },
    {
        CITY: 'PARANGPARANG',
        BARANGAY: 'WANNI PIYANJIHAN',
    },
    {
        CITY: 'TALIPAO',
        BARANGAY: 'ANDALAN',
    },
    {
        CITY: 'TALIPAO',
        BARANGAY: 'BAGSAK',
    },
    {
        CITY: 'TALIPAO',
        BARANGAY: 'BANDANG',
    },
    {
        CITY: 'TALIPAO',
        BARANGAY: 'BILAAN (POB.)',
    },
    {
        CITY: 'TALIPAO',
        BARANGAY: 'BUD BUNGA',
    },
    {
        CITY: 'TALIPAO',
        BARANGAY: 'BUNTOD',
    },
    {
        CITY: 'TALIPAO',
        BARANGAY: 'BUROH',
    },
    {
        CITY: 'TALIPAO',
        BARANGAY: 'DALIH',
    },
    {
        CITY: 'TALIPAO',
        BARANGAY: 'GATA',
    },
    {
        CITY: 'TALIPAO',
        BARANGAY: 'KABATUHAN BILAAN',
    },
    {
        CITY: 'TALIPAO',
        BARANGAY: 'KABATUHAN TIIS',
    },
    {
        CITY: 'TALIPAO',
        BARANGAY: 'KABUNGKOL',
    },
    {
        CITY: 'TALIPAO',
        BARANGAY: 'KAGAY',
    },
    {
        CITY: 'TALIPAO',
        BARANGAY: 'KAHAWA',
    },
    {
        CITY: 'TALIPAO',
        BARANGAY: 'KANDAGA',
    },
    {
        CITY: 'TALIPAO',
        BARANGAY: 'KANLIBOT',
    },
    {
        CITY: 'TALIPAO',
        BARANGAY: 'KIUTAAN',
    },
    {
        CITY: 'TALIPAO',
        BARANGAY: 'KUHAW',
    },
    {
        CITY: 'TALIPAO',
        BARANGAY: 'KULAMBOH',
    },
    {
        CITY: 'TALIPAO',
        BARANGAY: 'KUTTONG',
    },
    {
        CITY: 'TALIPAO',
        BARANGAY: 'LAGTOH',
    },
    {
        CITY: 'TALIPAO',
        BARANGAY: 'LAMBANAH',
    },
    {
        CITY: 'TALIPAO',
        BARANGAY: 'LIBAN',
    },
    {
        CITY: 'TALIPAO',
        BARANGAY: 'LIU-BUD PANTAO',
    },
    {
        CITY: 'TALIPAO',
        BARANGAY: 'LOWER BINUANG',
    },
    {
        CITY: 'TALIPAO',
        BARANGAY: 'LOWER KAMUNTAYAN',
    },
    {
        CITY: 'TALIPAO',
        BARANGAY: 'LOWER LAUS',
    },
    {
        CITY: 'TALIPAO',
        BARANGAY: 'LOWER SINUMAAN',
    },
    {
        CITY: 'TALIPAO',
        BARANGAY: 'LOWER TALIPAO',
    },
    {
        CITY: 'TALIPAO',
        BARANGAY: 'LUMBAYAO',
    },
    {
        CITY: 'TALIPAO',
        BARANGAY: 'LUMPING PIGIH DAHO',
    },
    {
        CITY: 'TALIPAO',
        BARANGAY: 'LUNGKIABAN',
    },
    {
        CITY: 'TALIPAO',
        BARANGAY: 'MABAHAY',
    },
    {
        CITY: 'TALIPAO',
        BARANGAY: 'MAHALA',
    },
    {
        CITY: 'TALIPAO',
        BARANGAY: 'MAMPALLAM',
    },
    {
        CITY: 'TALIPAO',
        BARANGAY: 'MARSADA',
    },
    {
        CITY: 'TALIPAO',
        BARANGAY: 'MAUBOH',
    },
    {
        CITY: 'TALIPAO',
        BARANGAY: 'MUNGIT-MUNGIT',
    },
    {
        CITY: 'TALIPAO',
        BARANGAY: 'NIOG-SANGAHAN',
    },
    {
        CITY: 'TALIPAO',
        BARANGAY: 'PANTAO',
    },
    {
        CITY: 'TALIPAO',
        BARANGAY: 'SAMAK',
    },
    {
        CITY: 'TALIPAO',
        BARANGAY: 'TALIPAO PROPER',
    },
    {
        CITY: 'TALIPAO',
        BARANGAY: 'TAMPAKAN',
    },
    {
        CITY: 'TALIPAO',
        BARANGAY: 'TIIS',
    },
    {
        CITY: 'TALIPAO',
        BARANGAY: 'TINGGAH',
    },
    {
        CITY: 'TALIPAO',
        BARANGAY: 'TUBOD',
    },
    {
        CITY: 'TALIPAO',
        BARANGAY: 'TUYANG',
    },
    {
        CITY: 'TALIPAO',
        BARANGAY: 'UPPER BINUANG',
    },
    {
        CITY: 'TALIPAO',
        BARANGAY: 'UPPER KAMUNTAYAN',
    },
    {
        CITY: 'TALIPAO',
        BARANGAY: 'UPPER LAUS',
    },
    {
        CITY: 'TALIPAO',
        BARANGAY: 'UPPER SINUMAAN',
    },
    {
        CITY: 'TALIPAO',
        BARANGAY: 'UPPER TALIPAO',
    },
    {
        CITY: 'TAPUL',
        BARANGAY: 'ALU-KABINGAAN',
    },
    {
        CITY: 'TAPUL',
        BARANGAY: 'BANTING',
    },
    {
        CITY: 'TAPUL',
        BARANGAY: 'HAWAN',
    },
    {
        CITY: 'TAPUL',
        BARANGAY: 'KALANG (POB.)',
    },
    {
        CITY: 'TAPUL',
        BARANGAY: 'KAMAUNGGI',
    },
    {
        CITY: 'TAPUL',
        BARANGAY: 'KANAWAY',
    },
    {
        CITY: 'TAPUL',
        BARANGAY: 'KANMANGON',
    },
    {
        CITY: 'TAPUL',
        BARANGAY: 'KAUMPANG',
    },
    {
        CITY: 'TAPUL',
        BARANGAY: 'PAGATPAT',
    },
    {
        CITY: 'TAPUL',
        BARANGAY: 'PANGDAN',
    },
    {
        CITY: 'TAPUL',
        BARANGAY: 'PUOK',
    },
    {
        CITY: 'TAPUL',
        BARANGAY: 'SAYLI',
    },
    {
        CITY: 'TAPUL',
        BARANGAY: 'SUMAMBAT',
    },
    {
        CITY: 'TAPUL',
        BARANGAY: 'TANGKAPAAN',
    },
    {
        CITY: 'TAPUL',
        BARANGAY: 'TULAKAN',
    },
    {
        CITY: 'TONGKIL',
        BARANGAY: 'BAKKAAN',
    },
    {
        CITY: 'TONGKIL',
        BARANGAY: 'BANGALAW',
    },
    {
        CITY: 'TONGKIL',
        BARANGAY: 'DANAO',
    },
    {
        CITY: 'TONGKIL',
        BARANGAY: 'DUNGON',
    },
    {
        CITY: 'TONGKIL',
        BARANGAY: 'KAHIKUKUK',
    },
    {
        CITY: 'TONGKIL',
        BARANGAY: 'LUUK (POB.)',
    },
    {
        CITY: 'TONGKIL',
        BARANGAY: 'NORTH PAAROL',
    },
    {
        CITY: 'TONGKIL',
        BARANGAY: 'SIGUMBAL',
    },
    {
        CITY: 'TONGKIL',
        BARANGAY: 'SOUTH PAAROL',
    },
    {
        CITY: 'TONGKIL',
        BARANGAY: 'TABIALAN',
    },
    {
        CITY: 'TONGKIL',
        BARANGAY: 'TAINGA-BAKKAO',
    },
    {
        CITY: 'TONGKIL',
        BARANGAY: 'TAMBUN-BUN',
    },
    {
        CITY: 'TONGKIL',
        BARANGAY: 'TATTALAN',
    },
    {
        CITY: 'TONGKIL',
        BARANGAY: 'TINUTUNGAN',
    }
];
